var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 506,
    height: 235,
    viewBox: "0 0 506 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.53 108.24V109.43H164.21V108.24C171.27 108.04 170.81 107.05 170.81 93.9901V77.7601C170.81 64.7001 171.27 63.7101 164.21 63.4501V62.3301H190.53V63.4501C183.47 63.7101 183.93 64.7001 183.93 77.7601V85.5401H200.81V77.7601C200.81 64.7001 201.27 63.7101 194.21 63.4501V62.3301H220.53V63.4501C213.47 63.7101 213.93 64.7001 213.93 77.7601V93.9901C213.93 107.05 213.47 108.04 220.53 108.24V109.43H194.21V108.24C201.27 108.04 200.81 107.05 200.81 93.9901V87.0601H183.93V93.9901C183.93 107.05 183.47 108.04 190.53 108.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.46 108.57C228.19 108.37 227.66 108.17 227.66 93.8001C227.66 78.4301 228.71 78.2301 221.06 78.1001V77.1801L240.19 76.3901V93.8001C240.72 108.18 239.66 108.38 246.39 108.57V109.43H221.46V108.57ZM226.54 65.1101C226.54 61.2801 229.9 58.1801 233.8 58.1801C237.7 58.1801 241.06 61.2801 241.06 65.1101C241.06 68.9401 237.76 72.0401 233.8 72.0401C229.84 72.0401 226.54 68.9401 226.54 65.1101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.72 108.57C253.25 108.31 252.99 108.64 252.99 93.14V77.64C252.99 61.94 253.72 62.73 246.26 62.54V61.62L266.71 60.76C266.05 64.06 265.46 74.54 265.46 77.64V89.45C266.38 89.38 267.51 89.25 269.29 89.25C270.21 84.37 273.25 75.14 281.95 75.14C287.82 75.14 290.26 79.3 290.26 82.92C290.26 87.21 286.83 89.38 283.73 89.38C280.63 89.38 277.93 87.34 277.93 83.58C277.93 79.36 281.95 76.92 285.98 78.3C285.39 76.91 283.8 76.19 281.69 76.19C274.7 76.19 271.47 84.37 270.87 89.18H273.24C287.42 89.18 283.07 106.72 288.67 106.72C290.52 106.72 291.64 104.81 291.9 102.04H292.89C292.56 106.59 289.53 110.55 283.19 110.55C267.03 110.55 277.19 90.5 265.78 90.5H265.45V93.14C265.45 108.77 265.32 108.18 271.12 108.57V109.43H246.72V108.57Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.94 108.57C300.67 108.37 300.14 108.17 300.14 93.8C300.14 78.43 301.2 78.23 293.54 78.1V77.18L312.67 76.39V81.86C314.39 77.84 317.81 75.13 323.55 75.13C328.89 75.13 332.78 77.77 333.97 82.52C335.55 78.17 339.05 75.13 345.12 75.13C351.19 75.13 356.27 79.02 356.27 85.82C356.27 90.44 355.87 94.46 355.87 98.29C355.87 108.58 355.34 108.38 361.74 108.58V109.44H340.11V108.58C344.86 108.38 343.94 108.18 343.87 93.15C343.87 81.81 343.48 79.04 339.72 79.04C336.95 79.04 334.84 81.55 334.38 87.68C334.31 91.57 334.12 95 334.12 98.3C334.12 108.59 333.99 108.39 337.95 108.59V109.45H318.36V108.59C323.11 108.39 322.12 108.19 322.12 93.16C322.12 81.82 321.92 79.05 318.16 79.05C314.93 79.05 312.69 82.41 312.69 90.79V93.82C312.69 108.2 311.77 108.4 316.51 108.59V109.45H293.95V108.59L293.94 108.57Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.1 98.3501L398.09 98.6101C396.77 105.01 390.77 110.88 381.6 110.88C369.33 110.88 363.73 101.84 363.73 92.9401C363.73 84.0401 369.8 75.0701 382.13 75.0701C394.46 75.0701 397.96 85.4901 397.37 91.8201H375.87V91.8901C375.87 99.6701 379.83 106.2 386.62 106.2C391.77 106.2 395.72 103.63 397.11 98.3501H397.1ZM375.86 90.4401H385.69C386.15 80.4801 385.29 76.1301 381.8 76.1301C378.31 76.1301 376.06 79.4901 375.86 90.4401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.94 78.8901V77.7701C407.84 77.7701 416.02 72.3601 417.61 61.8101H418.8V77.1801H421.04C426.05 77.1801 427.83 74.4101 427.83 70.7201H428.69V85.3601H427.83C427.83 81.6701 426.05 78.9001 421.04 78.9001H418.8V95.7801C418.8 104.09 420.71 106.79 424.01 106.79C428.23 106.79 429.95 101.38 430.34 98.2201L431.4 98.4201C430.67 105.15 427.24 110.89 418.54 110.89C410.69 110.89 405.88 107.59 405.88 99.2201C405.88 95.1301 406.28 91.3701 406.28 85.4301C406.28 78.7701 405.69 78.9001 398.96 78.9001L398.94 78.8901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.31 108.57C440.04 108.37 439.51 108.17 439.51 93.8001C439.51 78.4301 440.57 78.2301 432.91 78.1001V77.1801L452.04 76.3901V93.8001C452.57 108.18 451.51 108.38 458.24 108.57V109.43H433.31V108.57ZM438.38 65.1101C438.38 61.2801 441.74 58.1801 445.64 58.1801C449.54 58.1801 452.9 61.2801 452.9 65.1101C452.9 68.9401 449.6 72.0401 445.64 72.0401C441.68 72.0401 438.38 68.9401 438.38 65.1101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.83 108.57C465.56 108.37 465.03 108.17 465.03 93.8C465.03 78.43 466.09 78.23 458.43 78.1V77.18L477.56 76.39V81.86C479.28 77.84 482.7 75.13 488.44 75.13C495.56 75.13 499.92 79.02 499.92 85.82C499.92 90.44 499.52 94.46 499.52 98.29C499.52 108.58 498.99 108.38 505.39 108.58V109.44H483.76V108.58C488.51 108.38 487.52 108.18 487.52 93.15C487.52 81.81 487.32 79.04 483.04 79.04C479.81 79.04 477.57 82.34 477.57 90.71V93.81C477.57 108.19 476.65 108.39 481.39 108.58V109.44H458.83V108.58V108.57Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.53 108.24V109.43H164.21V108.24C171.27 108.04 170.81 107.05 170.81 93.9901V77.7601C170.81 64.7001 171.27 63.7101 164.21 63.4501V62.3301H190.53V63.4501C183.47 63.7101 183.93 64.7001 183.93 77.7601V85.5401H200.81V77.7601C200.81 64.7001 201.27 63.7101 194.21 63.4501V62.3301H220.53V63.4501C213.47 63.7101 213.93 64.7001 213.93 77.7601V93.9901C213.93 107.05 213.47 108.04 220.53 108.24V109.43H194.21V108.24C201.27 108.04 200.81 107.05 200.81 93.9901V87.0601H183.93V93.9901C183.93 107.05 183.47 108.04 190.53 108.24Z",
    fill: "url(#paint0_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.46 108.57C228.19 108.37 227.66 108.17 227.66 93.8001C227.66 78.4301 228.71 78.2301 221.06 78.1001V77.1801L240.19 76.3901V93.8001C240.72 108.18 239.66 108.38 246.39 108.57V109.43H221.46V108.57ZM226.54 65.1101C226.54 61.2801 229.9 58.1801 233.8 58.1801C237.7 58.1801 241.06 61.2801 241.06 65.1101C241.06 68.9401 237.76 72.0401 233.8 72.0401C229.84 72.0401 226.54 68.9401 226.54 65.1101Z",
    fill: "url(#paint1_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.72 108.57C253.25 108.31 252.99 108.64 252.99 93.14V77.64C252.99 61.94 253.72 62.73 246.26 62.54V61.62L266.71 60.76C266.05 64.06 265.46 74.54 265.46 77.64V89.45C266.38 89.38 267.51 89.25 269.29 89.25C270.21 84.37 273.25 75.14 281.95 75.14C287.82 75.14 290.26 79.3 290.26 82.92C290.26 87.21 286.83 89.38 283.73 89.38C280.63 89.38 277.93 87.34 277.93 83.58C277.93 79.36 281.95 76.92 285.98 78.3C285.39 76.91 283.8 76.19 281.69 76.19C274.7 76.19 271.47 84.37 270.87 89.18H273.24C287.42 89.18 283.07 106.72 288.67 106.72C290.52 106.72 291.64 104.81 291.9 102.04H292.89C292.56 106.59 289.53 110.55 283.19 110.55C267.03 110.55 277.19 90.5 265.78 90.5H265.45V93.14C265.45 108.77 265.32 108.18 271.12 108.57V109.43H246.72V108.57Z",
    fill: "url(#paint2_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.94 108.57C300.67 108.37 300.14 108.17 300.14 93.8C300.14 78.43 301.2 78.23 293.54 78.1V77.18L312.67 76.39V81.86C314.39 77.84 317.81 75.13 323.55 75.13C328.89 75.13 332.78 77.77 333.97 82.52C335.55 78.17 339.05 75.13 345.12 75.13C351.19 75.13 356.27 79.02 356.27 85.82C356.27 90.44 355.87 94.46 355.87 98.29C355.87 108.58 355.34 108.38 361.74 108.58V109.44H340.11V108.58C344.86 108.38 343.94 108.18 343.87 93.15C343.87 81.81 343.48 79.04 339.72 79.04C336.95 79.04 334.84 81.55 334.38 87.68C334.31 91.57 334.12 95 334.12 98.3C334.12 108.59 333.99 108.39 337.95 108.59V109.45H318.36V108.59C323.11 108.39 322.12 108.19 322.12 93.16C322.12 81.82 321.92 79.05 318.16 79.05C314.93 79.05 312.69 82.41 312.69 90.79V93.82C312.69 108.2 311.77 108.4 316.51 108.59V109.45H293.95V108.59L293.94 108.57Z",
    fill: "url(#paint3_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.1 98.3501L398.09 98.6101C396.77 105.01 390.77 110.88 381.6 110.88C369.33 110.88 363.73 101.84 363.73 92.9401C363.73 84.0401 369.8 75.0701 382.13 75.0701C394.46 75.0701 397.96 85.4901 397.37 91.8201H375.87V91.8901C375.87 99.6701 379.83 106.2 386.62 106.2C391.77 106.2 395.72 103.63 397.11 98.3501H397.1ZM375.86 90.4401H385.69C386.15 80.4801 385.29 76.1301 381.8 76.1301C378.31 76.1301 376.06 79.4901 375.86 90.4401Z",
    fill: "url(#paint4_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.94 78.8901V77.7701C407.84 77.7701 416.02 72.3601 417.61 61.8101H418.8V77.1801H421.04C426.05 77.1801 427.83 74.4101 427.83 70.7201H428.69V85.3601H427.83C427.83 81.6701 426.05 78.9001 421.04 78.9001H418.8V95.7801C418.8 104.09 420.71 106.79 424.01 106.79C428.23 106.79 429.95 101.38 430.34 98.2201L431.4 98.4201C430.67 105.15 427.24 110.89 418.54 110.89C410.69 110.89 405.88 107.59 405.88 99.2201C405.88 95.1301 406.28 91.3701 406.28 85.4301C406.28 78.7701 405.69 78.9001 398.96 78.9001L398.94 78.8901Z",
    fill: "url(#paint5_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.31 108.57C440.04 108.37 439.51 108.17 439.51 93.8001C439.51 78.4301 440.57 78.2301 432.91 78.1001V77.1801L452.04 76.3901V93.8001C452.57 108.18 451.51 108.38 458.24 108.57V109.43H433.31V108.57ZM438.38 65.1101C438.38 61.2801 441.74 58.1801 445.64 58.1801C449.54 58.1801 452.9 61.2801 452.9 65.1101C452.9 68.9401 449.6 72.0401 445.64 72.0401C441.68 72.0401 438.38 68.9401 438.38 65.1101Z",
    fill: "url(#paint6_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.83 108.57C465.56 108.37 465.03 108.17 465.03 93.8C465.03 78.43 466.09 78.23 458.43 78.1V77.18L477.56 76.39V81.86C479.28 77.84 482.7 75.13 488.44 75.13C495.56 75.13 499.92 79.02 499.92 85.82C499.92 90.44 499.52 94.46 499.52 98.29C499.52 108.58 498.99 108.38 505.39 108.58V109.44H483.76V108.58C488.51 108.38 487.52 108.18 487.52 93.15C487.52 81.81 487.32 79.04 483.04 79.04C479.81 79.04 477.57 82.34 477.57 90.71V93.81C477.57 108.19 476.65 108.39 481.39 108.58V109.44H458.83V108.58V108.57Z",
    fill: "url(#paint7_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.69 182.98V184.17H170.37V182.98C177.43 182.78 176.97 181.79 176.97 168.73V152.5C176.97 139.44 177.43 138.45 170.37 138.19V137.07H196.69V138.19C189.63 138.45 190.09 139.44 190.09 152.5V168.73C190.09 181.79 189.63 182.78 196.69 182.98ZM176.18 125.79C176.18 121.97 179.54 118.86 183.44 118.86C187.34 118.86 190.7 121.96 190.7 125.79C190.7 129.62 187.4 132.72 183.44 132.72C179.48 132.72 176.18 129.62 176.18 125.79Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.84 161.28H212.85C204.41 161.28 201.9 161.08 201.7 168.8H200.58V151.19H230.19V152.24L209.08 174.07H217.52C225.96 174.07 228.53 174.66 228.73 166.95H229.85V184.16H198.46V183.1L219.83 161.27L219.84 161.28Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.09 183.3C239.82 183.1 239.29 182.9 239.29 168.53C239.29 153.16 240.35 152.96 232.69 152.83V151.91L251.82 151.12V168.53C252.35 182.91 251.29 183.11 258.02 183.3V184.16H233.09V183.3ZM238.17 139.84C238.17 136.01 241.53 132.91 245.43 132.91C249.33 132.91 252.69 136.01 252.69 139.84C252.69 143.67 249.39 146.77 245.43 146.77C241.47 146.77 238.17 143.67 238.17 139.84Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.62 183.3C265.35 183.1 264.82 182.9 264.82 168.53C264.82 153.16 265.88 152.96 258.22 152.83V151.91L277.35 151.12V156.59C279.07 152.57 282.49 149.86 288.23 149.86C295.35 149.86 299.71 153.75 299.71 160.55C299.71 165.17 299.31 169.19 299.31 173.02C299.31 183.31 298.78 183.11 305.18 183.31V184.17H283.55V183.31C288.3 183.11 287.31 182.91 287.31 167.88C287.31 156.54 287.11 153.77 282.83 153.77C279.6 153.77 277.36 157.07 277.36 165.44V168.54C277.36 182.92 276.44 183.12 281.18 183.31V184.17H258.62V183.31V183.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.27 178.36C332.36 182.45 328.8 185.48 322.6 185.48C313.3 185.48 307.5 178.36 307.5 168.2C307.5 158.04 313.5 149.86 324.32 149.86C329.46 149.86 332.56 151.84 333.95 154.61V152.7C333.95 136.34 335.07 137.46 326.04 137.2V136.41L347.47 135.49C346.88 138.79 346.15 149.54 346.15 152.7V167.94C346.15 181.07 348.13 182.65 354.46 182.91V183.7L336.06 185.02C335.14 183.37 334.54 180.8 334.28 178.36H334.27ZM334.47 167.01C334.47 157.45 332.1 151.84 326.82 151.84C322.07 151.84 319.63 158.37 319.63 167.21C319.63 174.86 322 182.31 327.15 182.31C331.77 182.31 334.47 176.84 334.47 167.01Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.15 173.08L389.14 173.34C387.82 179.74 381.82 185.61 372.65 185.61C360.38 185.61 354.78 176.57 354.78 167.67C354.78 158.77 360.85 149.8 373.18 149.8C385.51 149.8 389.01 160.22 388.42 166.55H366.92V166.62C366.92 174.4 370.88 180.93 377.67 180.93C382.82 180.93 386.77 178.36 388.16 173.08H388.15ZM366.91 165.17H376.74C377.2 155.21 376.34 150.86 372.85 150.86C369.36 150.86 367.11 154.22 366.91 165.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.69 182.98V184.17H170.37V182.98C177.43 182.78 176.97 181.79 176.97 168.73V152.5C176.97 139.44 177.43 138.45 170.37 138.19V137.07H196.69V138.19C189.63 138.45 190.09 139.44 190.09 152.5V168.73C190.09 181.79 189.63 182.78 196.69 182.98ZM176.18 125.79C176.18 121.97 179.54 118.86 183.44 118.86C187.34 118.86 190.7 121.96 190.7 125.79C190.7 129.62 187.4 132.72 183.44 132.72C179.48 132.72 176.18 129.62 176.18 125.79Z",
    fill: "url(#paint8_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.84 161.28H212.85C204.41 161.28 201.9 161.08 201.7 168.8H200.58V151.19H230.19V152.24L209.08 174.07H217.52C225.96 174.07 228.53 174.66 228.73 166.95H229.85V184.16H198.46V183.1L219.83 161.27L219.84 161.28Z",
    fill: "url(#paint9_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.09 183.3C239.82 183.1 239.29 182.9 239.29 168.53C239.29 153.16 240.35 152.96 232.69 152.83V151.91L251.82 151.12V168.53C252.35 182.91 251.29 183.11 258.02 183.3V184.16H233.09V183.3ZM238.17 139.84C238.17 136.01 241.53 132.91 245.43 132.91C249.33 132.91 252.69 136.01 252.69 139.84C252.69 143.67 249.39 146.77 245.43 146.77C241.47 146.77 238.17 143.67 238.17 139.84Z",
    fill: "url(#paint10_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.62 183.3C265.35 183.1 264.82 182.9 264.82 168.53C264.82 153.16 265.88 152.96 258.22 152.83V151.91L277.35 151.12V156.59C279.07 152.57 282.49 149.86 288.23 149.86C295.35 149.86 299.71 153.75 299.71 160.55C299.71 165.17 299.31 169.19 299.31 173.02C299.31 183.31 298.78 183.11 305.18 183.31V184.17H283.55V183.31C288.3 183.11 287.31 182.91 287.31 167.88C287.31 156.54 287.11 153.77 282.83 153.77C279.6 153.77 277.36 157.07 277.36 165.44V168.54C277.36 182.92 276.44 183.12 281.18 183.31V184.17H258.62V183.31V183.3Z",
    fill: "url(#paint11_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.27 178.36C332.36 182.45 328.8 185.48 322.6 185.48C313.3 185.48 307.5 178.36 307.5 168.2C307.5 158.04 313.5 149.86 324.32 149.86C329.46 149.86 332.56 151.84 333.95 154.61V152.7C333.95 136.34 335.07 137.46 326.04 137.2V136.41L347.47 135.49C346.88 138.79 346.15 149.54 346.15 152.7V167.94C346.15 181.07 348.13 182.65 354.46 182.91V183.7L336.06 185.02C335.14 183.37 334.54 180.8 334.28 178.36H334.27ZM334.47 167.01C334.47 157.45 332.1 151.84 326.82 151.84C322.07 151.84 319.63 158.37 319.63 167.21C319.63 174.86 322 182.31 327.15 182.31C331.77 182.31 334.47 176.84 334.47 167.01Z",
    fill: "url(#paint12_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.15 173.08L389.14 173.34C387.82 179.74 381.82 185.61 372.65 185.61C360.38 185.61 354.78 176.57 354.78 167.67C354.78 158.77 360.85 149.8 373.18 149.8C385.51 149.8 389.01 160.22 388.42 166.55H366.92V166.62C366.92 174.4 370.88 180.93 377.67 180.93C382.82 180.93 386.77 178.36 388.16 173.08H388.15ZM366.91 165.17H376.74C377.2 155.21 376.34 150.86 372.85 150.86C369.36 150.86 367.11 154.22 366.91 165.17Z",
    fill: "url(#paint13_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.86 231.64C285.11 231.56 282.44 231.6 279.75 231.58C274.47 231.54 269.21 231.18 263.95 230.59C258.07 229.93 252.24 229.01 246.47 227.7C239.84 226.2 233.28 224.46 227.19 221.51C225.19 220.54 223.23 219.49 221.85 217.82C220.64 216.37 220.72 215.15 222.07 213.91C223.03 213.03 224.54 212.28 226.32 211.88C225.26 212.5 224.38 212.97 223.56 213.51C221.43 214.92 221.42 216.59 223.55 218.21C225.45 219.66 227.68 220.64 229.95 221.53C236.47 224.08 243.29 225.62 250.2 226.86C262 228.98 273.85 229.98 285.76 229.42C292.16 229.12 298.45 228.31 304.34 226.13C305.82 225.58 307.26 224.97 308.49 224.04C305.92 225.05 303.3 225.91 300.52 226.44C297.75 226.96 294.95 227.25 292.08 227.31C293.69 226.91 295.31 226.54 296.91 226.12C300.9 225.09 304.53 223.49 307.73 221.24C309.42 220.05 310.57 218.55 311.14 216.69C311.44 215.72 311.18 214.97 310.29 214.3C307.93 212.52 305.11 211.57 302.23 210.77C293.18 208.26 283.89 207.27 274.56 206.43C269.17 205.94 263.78 205.56 258.38 205.28C252.59 204.98 246.8 204.76 241.01 204.6C233.21 204.39 225.41 204.22 217.62 204.16C205.91 204.07 194.2 204.09 182.5 204.08C176.63 204.08 170.76 204.12 164.89 204.13C156.5 204.13 148.1 204.42 139.71 204C135.62 203.8 131.53 203.67 127.44 203.61C117.31 203.46 107.18 203.31 97.05 202.51C92.52 202.15 87.98 201.7 83.62 200.28C81.69 199.65 79.92 198.8 78.66 197.3C76.75 195.03 77.2 192.71 78.18 190.41C79.63 186.98 82.43 184.48 85.71 182.37C92.39 178.09 100.1 175.57 108 173.38C110.22 172.76 112.49 172.24 114.74 171.68C115.03 171.61 115.34 171.57 115.69 171.68C113.4 172.28 111.11 172.86 108.84 173.49C102.8 175.16 96.9 177.11 91.4 179.79C87.43 181.72 83.75 183.97 80.99 187.17C79.86 188.48 78.97 189.92 78.45 191.52C77.3 195.06 78.74 197.72 82.73 199.29C85.91 200.54 89.29 201.01 92.68 201.37C104.77 202.64 116.85 202.63 128.93 202.66C135.41 202.68 141.9 202.66 148.37 202.58C158.31 202.45 168.24 202.26 178.17 202.06C183.95 201.94 189.73 201.77 195.51 201.62C195.93 201.61 196.36 201.56 196.77 201.38C171.55 200.6 146.4 201.34 121.2 200.86C149.4 200.76 177.54 200.07 205.69 199.11C204.23 199.04 202.76 198.93 201.3 198.91C191.83 198.75 182.36 198.69 172.9 198.71C166.66 198.72 160.42 198.6 154.18 198.65C144.07 198.73 133.95 198.65 123.84 198.55C116.41 198.47 108.97 198.18 101.54 197.84C101.14 197.82 100.73 197.75 100.32 197.63C106.79 197.5 113.24 197.34 119.68 196.92C115.78 196.52 111.88 196.23 108.01 195.54C110.75 195.59 113.5 195.64 116.24 195.68C125.38 195.81 134.51 195.78 143.65 195.69C149.51 195.63 155.37 195.61 161.24 195.55C167.8 195.49 174.36 195.38 180.92 195.34C190.54 195.28 200.17 195.26 209.79 195.24C219.78 195.21 229.79 195.36 239.79 195.64C247.23 195.85 254.66 196.16 262.1 196.61C273.56 197.31 284.99 198.27 296.3 200.43C302.43 201.6 308.48 203.07 313.91 206.09C316.6 207.58 318.85 209.43 320.13 212.02C322.01 215.79 321.06 219.28 319.1 222.61C316.67 226.73 312.58 229.27 307.8 231.08C301.38 233.51 294.5 234.33 287.48 234.68C283.98 234.85 280.47 234.73 276.96 234.7C276.48 234.7 275.99 234.61 275.51 234.43C277.99 234.43 280.48 234.48 282.96 234.43C290.36 234.25 297.66 233.58 304.59 231.43C309.84 229.8 314.5 227.44 317.54 223.24C319.14 221.02 320.1 218.58 320.04 215.89C319.95 212.17 317.54 209.53 314.15 207.45C310.28 205.07 305.88 203.8 301.41 202.71C292.05 200.43 282.51 199.47 272.94 198.73C271.48 198.62 270.02 198.48 268.54 198.54C270.45 198.72 272.35 198.89 274.26 199.08C284.47 200.1 294.66 201.24 304.56 204.07C307.94 205.03 311.22 206.24 314.13 208.15C319.72 211.82 320.52 216.09 317.91 221.18C315.7 225.49 311.57 228.06 306.74 229.87C299.93 232.41 292.61 233.2 285.18 233.46C278.9 233.68 272.62 233.35 266.32 232.8C258.12 232.08 250.05 230.7 242.08 228.75C235.95 227.25 229.92 225.45 224.46 222.41C222.17 221.13 219.99 219.7 219 217.36C218.73 216.73 218.51 216.08 218.9 215.32C219.18 218.24 221.44 219.85 223.92 221.26C227.61 223.35 231.66 224.71 235.79 225.89C247.99 229.38 260.47 231.13 273.12 231.83C277.65 232.08 282.18 232.08 286.69 231.82C287.09 231.8 287.48 231.74 287.88 231.71L287.86 231.64Z",
    fill: "url(#paint14_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.68 154.76C152.15 164.03 153.26 173.16 156.03 182.05C156.63 183.26 156.63 184.49 159.28 184.5H121.07C123.47 184.51 124.06 182.73 124.22 182.22C127.03 173.34 128.16 164.21 127.63 154.94C126.91 142.51 117.99 133.55 105.57 132.33C100.88 131.87 96.21 132.03 91.53 132.15C84.51 132.33 77.57 131.81 70.7 130.35C68 129.78 65.26 129.37 62.47 129.76C59.35 130.19 56.95 131.91 54.7 133.97C55.94 131.23 58.05 129.4 60.77 128.23C62.76 127.37 64.88 126.96 67.04 126.89C68.96 126.83 70.88 126.93 72.8 126.83C74.16 126.76 75.27 127.58 76.68 127.56C75.21 126.49 73.74 125.41 72.35 124.25C69.94 122.23 67.5 120.23 65.03 118.27C63.83 117.32 62.56 116.43 61.26 115.62C54.65 111.51 46.82 114.12 44.26 121.54C42.76 125.9 39.93 128.46 35.67 129.71C33.34 130.39 31.03 131.14 28.83 132.24C29.97 130.9 31.39 130 32.97 129.32C34.09 128.83 35.24 128.38 36.33 127.81C39 126.43 40.83 124.39 41.26 121.29C41.37 120.47 41.62 119.67 41.82 118.79C40.78 118.75 40.1 119.3 39.36 119.62C36.81 120.71 34.23 121.62 31.45 121.98C27.66 122.46 24.28 121.53 21.3 119.21C19.62 117.9 18.18 116.32 16.6 114.54C17.54 114.54 17.88 115.09 18.31 115.45C19.01 116.05 19.66 116.7 20.37 117.29C24.08 120.4 28.26 121.21 32.88 119.77C35.61 118.92 38.11 117.56 40.56 116.13C43.28 114.54 45.96 112.91 48.79 111.51C53.95 108.95 58.96 109.08 63.96 111.97C66.96 113.71 69.79 115.67 72.65 117.61C74.81 119.07 77.01 120.47 79.22 121.86C82.57 123.97 86.2 124.78 90.18 124.69C95.33 124.57 100.45 124.01 105.61 124.11C110.47 124.2 115.27 124.55 119.8 126.52C120.1 127.02 120.56 127.28 121.18 127.49C120.95 126.82 120.56 126.47 119.98 126.32C118.66 124.8 116.8 124.25 115.01 123.59C111.69 122.37 108.19 121.8 104.77 120.94C102.38 120.34 100.05 119.61 97.86 118.47C95.53 117.27 92.98 116.65 90.51 115.81C88.4 115.09 86.33 114.29 84.34 113.28C80.99 111.57 78.23 109.19 76.06 106.12C75.62 105.49 75.15 104.88 74.77 104.21C72.69 100.47 69.31 99.09 65.26 98.68C60.85 98.24 56.53 98.8801 52.19 99.41C47.55 99.98 42.91 100.71 38.2 100.17C35.02 99.8 32.3 98.6 30.18 96.14C29.01 94.78 27.76 93.49 26.65 92.07C28 92.65 29.05 93.66 30.01 94.69C33.11 98.05 36.97 98.87 41.33 98.52C46.71 98.09 51.9 96.63 57.2 95.79C58.1 95.65 59 95.5 59.96 95.35C59.92 95.08 59.96 94.8101 59.83 94.66C56.8 90.8101 55.8 86.28 55.36 81.56C55.03 77.96 55.22 74.3401 55.16 70.7301C55.12 68.8101 55.09 66.8801 54.87 64.9801C54.41 61.0301 52.75 57.64 49.85 54.8801C49.24 54.3 48.6 53.75 47.97 53.18C48.58 52.78 48.88 53.3301 49.22 53.5601C54.23 56.8301 56.52 61.69 57.19 67.45C57.69 71.72 58.05 76 58.6 80.27C58.98 83.25 59.81 86.12 61.25 88.8C62.6 91.33 64.62 92.94 67.42 93.54C68.98 93.87 70.55 94.1701 72.27 94.51C72.33 93.69 71.95 93.11 71.73 92.51C69.84 87.4901 70.24 82.64 73.22 78.21C75.11 75.39 75.26 72.53 74.52 69.42C73.88 66.72 72.84 64.16 71.84 61.59C70.86 59.0801 70 56.5401 69.43 53.91C68.95 51.71 68.82 49.5201 70.42 47.59C69.34 50.8601 70.49 53.82 71.74 56.71C72.99 59.6 74.45 62.39 75.79 65.24C76.87 67.54 77.75 69.9 78.06 72.45C78.35 74.88 78.07 77.19 76.83 79.35C74.53 83.36 74.63 87.35 76.83 91.4C78.19 93.89 79.45 96.4501 80.59 99.04C82.74 103.9 86.38 106.86 91.55 107.98C99.33 109.67 106.91 112.25 114.89 113.12C120.42 113.72 125.41 115.82 129.51 119.77C131.46 121.64 133.09 123.57 132.36 126.54C132.31 126.75 132.4 126.99 132.56 127.26C133.5 123.64 135.25 120.31 136.12 116.66C136.82 113.71 135.76 111.57 133.32 109.97C131.77 108.95 130.06 108.26 128.37 107.53C124.85 106 121.31 104.52 117.81 102.96C114.92 101.67 112.21 100.08 109.99 97.77C109.18 96.93 108.18 96.37 107.12 95.89C104.73 94.82 102.27 93.96 99.74 93.32C98.4 92.98 97.09 92.54 95.86 91.89C91.67 89.67 90.55 86.8 92.14 82.35C92.42 81.56 92.72 80.76 93.09 80C93.99 78.16 93.77 76.46 92.64 74.78C91.65 73.32 90.69 71.83 89.8 70.31C88.28 67.73 87.8 65.8 87.89 62.98C88.1 63.3801 88.3 63.6301 88.36 63.91C88.92 66.5601 90.44 68.66 92.2 70.63C93.22 71.78 94.29 72.8901 95.25 74.0801C96.73 75.9301 97.26 78 96.59 80.34C96.29 81.37 96.08 82.43 95.93 83.49C95.6 85.89 95.98 86.44 98.36 87.07C99.25 87.3 100.16 87.46 101.07 87.58C102.05 87.7001 103.04 87.74 104.1 87.81C104.43 87.06 104.14 86.41 104.01 85.76C102.71 79.25 102.22 72.71 103.07 66.07C103.82 60.23 103.15 54.6001 100.03 49.4001C98.15 46.2601 97.21 42.7701 96.88 39.14C96.71 37.28 95.94 35.79 94.64 34.48C93.05 32.88 91.15 31.73 89.23 30.59C87.52 29.57 85.78 28.59 84.12 27.49C83.06 26.79 82.08 25.94 81.77 24.57C83.51 26.24 85.64 27.18 87.82 28.0201C91.04 29.25 94.23 30.5301 97.16 32.6301C98.94 25.5001 102.37 19.4 106.87 13.84C106.52 14.57 106.18 15.3 105.82 16.02C103.61 20.42 101.77 24.96 100.78 29.81C99.6 35.61 100.62 40.9401 104.06 45.7901C105.7 48.1001 107.57 50.25 108.87 52.7701C109.65 52.68 109.95 52.09 110.37 51.7001C113.77 48.5801 117.76 46.4901 122.03 44.8801C125.4 43.6101 128.81 42.42 132.19 41.17C134.14 40.45 136.01 39.57 137.81 38.53C144.03 34.94 147.5 29.55 148.5 22.47C149.06 18.5 149.06 14.53 148.72 10.55C150.18 16.74 150.59 22.94 148.79 29.12C147.27 34.35 143.9 38.26 139.52 41.37C136.75 43.34 133.69 44.7701 130.63 46.2001C128.06 47.4001 125.48 48.59 122.92 49.8101C121.18 50.6401 119.57 51.6701 118 52.7901C113.17 56.23 110.63 60.96 110.3 66.82C109.94 73.18 110.99 79.37 113.09 85.37C114.35 88.98 116.71 91.5601 120.44 92.76C121.53 93.11 122.61 93.54 123.68 93.95C125.88 94.78 128.24 95.18 130.45 96.37C128.8 94.75 129.54 93.14 130.21 91.55C131.48 88.55 133.34 85.91 135.47 83.48C137.7 80.94 139.99 78.46 142.25 75.94C143.64 74.39 144.88 72.74 146 70.99C149.48 65.55 149.9 59.8101 147.8 53.7901C147.53 53.0201 147.04 52.3101 147.03 51.07C151.17 56.83 153.04 62.73 151.48 69.49C150.61 73.27 149.03 76.75 147.09 80.08C145.66 82.53 144.14 84.94 142.71 87.39C141.59 89.31 140.65 91.32 140.05 93.49C139.35 95.99 139.81 98.18 141.36 100.21C142.16 101.25 143.13 102.12 144.06 103.04C147.12 106.06 149.16 109.55 149.02 114.03C148.97 115.75 148.34 117.29 147.74 118.9C151.89 127.7 152.71 154.79 152.71 154.79L152.68 154.76ZM138.09 159.28C137.89 159.8 137.93 160.31 138.09 161.08V159.29C138.02 157.76 137.94 156.24 137.87 154.71C137.71 151.18 137.31 147.69 136.01 144.37C135.3 142.56 134.49 140.79 132.93 139.47C133.04 140.06 133.31 140.58 133.56 141.11C134.99 144.09 136.01 147.21 136.46 150.49C136.8 152.99 137.08 155.5 137.39 158C137.45 158.51 137.37 159.12 138.09 159.28ZM112.31 130.79C116.52 132.47 120.4 134.67 123.63 137.88C126.9 141.13 129.09 145.05 130.72 149.33C130.3 140.01 121.21 130.85 112.3 130.79H112.31ZM136.19 125.83C137.47 122.89 139.12 120.11 139.93 116.99C141.02 112.75 138.89 108.61 134.97 107.27C134.97 107.32 134.96 107.4 134.99 107.43C135.2 107.65 135.42 107.86 135.65 108.07C137.65 109.89 138.51 112.15 138.39 114.85C138.3 117.02 137.64 119.06 137.12 121.13C136.73 122.67 136.09 124.16 136.2 125.83H136.19ZM133.93 158.43C133.6 159.57 133.86 160.55 133.95 161.53C134.47 167.32 135.17 173.1 134.61 178.92C134.46 180.51 134.15 182.1 133.91 183.68C133.86 184.01 133.9 184.3 134.25 184.41C134.66 184.54 135.02 184.46 135.16 184.01C135.28 183.65 135.38 183.27 135.42 182.9C135.76 179.63 136.17 176.37 135.86 173.06C135.4 168.21 134.78 163.38 133.93 158.43ZM108.47 118.73C114.52 120.97 120.9 122.63 125.32 127.9C121.69 121.21 115.01 120.1 108.47 118.73ZM131.71 171.58C131.17 175.68 130.43 179.73 129.07 183.65C129.05 183.72 129.04 183.8 129.03 183.88C128.97 184.14 129.08 184.36 129.3 184.42C129.5 184.47 129.81 184.47 129.94 184.35C130.16 184.16 130.34 183.88 130.41 183.6C131.37 179.66 132.14 175.69 131.71 171.59V171.58Z",
    fill: "url(#paint15_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77 26.8199C152.16 26.8199 151.87 26.3099 153.59 23.0599C156.48 17.5799 162.66 14.4299 168.77 15.3199C170.2 15.5299 170.27 15.65 169.77 17.12C167.81 22.82 162.02 26.8399 155.78 26.8299L155.77 26.8199Z",
    fill: "url(#paint16_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.42 26.54C143.46 27.87 143.24 29.15 142.93 30.42C142.68 31.48 142.21 31.54 141.28 31.14C135.17 28.51 131.41 20.45 133.33 14C133.69 12.78 133.95 12.61 135.12 13.23C140.48 16.05 143.18 20.54 143.41 26.54H143.42Z",
    fill: "url(#paint17_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91002 135.1C9.03002 128.87 13.17 123.31 18.91 121.54C20.79 120.96 21.08 121.16 21.14 123.07C21.33 129.28 16.86 135.36 10.88 137.02C9.19002 137.49 9.06003 137.39 8.93003 135.7C8.91003 135.47 8.91002 135.24 8.90002 135.11L8.91002 135.1Z",
    fill: "url(#paint18_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3899 87.62C23.3099 86.53 21.7699 84.88 20.6099 82.88C18.1899 78.7 17.9099 74.37 19.8199 69.91C20.1599 69.1 20.4599 68.61 21.4699 69.25C27.2099 72.9 29.2099 81.9 25.3999 87.62H25.3899Z",
    fill: "url(#paint19_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0199 37.7399C65.1499 33.2599 64.9099 23.5199 70.4799 18.6899C74.9999 21.7699 76.2699 32.3699 70.0199 37.7399Z",
    fill: "url(#paint20_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.23 22.96C109.17 22.83 108.1 22.74 107.05 22.55C106.35 22.42 106.08 22.07 106.37 21.25C108.39 15.56 116.23 11.67 122.06 13.46C123.07 13.77 122.95 14.24 122.66 14.98C120.8 19.62 115.65 22.91 110.23 22.97V22.96Z",
    fill: "url(#paint21_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.01 62.3C47 62.45 50.81 64.64 53.38 68.93C54.3 70.47 54.18 70.69 52.53 71.1C46.9 72.52 40.69 69.85 37.95 64.84C37.09 63.27 37.16 63.15 38.81 62.66C39.86 62.35 40.93 62.33 42.02 62.3H42.01Z",
    fill: "url(#paint22_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.38 114.7C12.65 114.8 13.88 114.79 15.06 115.2C16.35 115.65 16.46 115.8 15.8 116.95C13.92 120.27 11.08 122.31 7.36996 123.16C5.30996 123.63 3.24996 123.53 1.22996 123C-0.170035 122.63 -0.300035 122.35 0.439965 121.11C2.90996 116.95 6.62996 114.89 11.38 114.7Z",
    fill: "url(#paint23_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1399 34.5601C54.1499 38.0101 54.4399 48.0001 49.5999 51.8001C44.8199 47.9501 44.3499 38.9501 49.1399 34.5601Z",
    fill: "url(#paint24_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.74 44.94C67.74 46.45 67.6 46.57 66.19 46.3C60.76 45.24 56.25 39.61 56.44 34.15C56.48 32.93 56.77 32.71 58.02 32.95C63.28 33.98 67.71 39.45 67.73 44.95L67.74 44.94Z",
    fill: "url(#paint25_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 40.94C122.82 37.57 121.54 29.74 125.99 24.27C126.76 23.32 127.21 23.81 127.75 24.48C131.77 29.49 131.21 36.8 127 40.93V40.94Z",
    fill: "url(#paint26_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.12 41.57C148.1 41.61 147.13 41.37 146.16 41.13C144.69 40.77 144.58 40.57 145.29 39.3C147.38 35.57 150.59 33.43 154.81 32.87C156.18 32.69 157.57 32.72 158.93 33.02C160.91 33.46 161.04 33.71 160.01 35.38C157.52 39.44 153.79 41.35 149.12 41.57Z",
    fill: "url(#paint27_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.05 0C143.51 1.17 147.66 7.61 146.39 14.33C140.46 14.22 135.4 6.6 137.05 0Z",
    fill: "url(#paint28_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.95 68.12C124.59 73.64 118.99 79.06 113.67 79.14C112.88 79.15 112.53 78.8999 112.61 78.0899C113.3 71.6199 118.26 67.24 123.96 66.68C125.33 66.55 124.89 67.53 124.95 68.12Z",
    fill: "url(#paint29_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.69 1.36999C163.1 7.39999 159.4 13.96 153.78 15.65C153.06 15.87 152.33 16.18 152.11 14.91C151.04 9.00999 155.61 2.42999 161.7 1.35999L161.69 1.36999Z",
    fill: "url(#paint30_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.04 51.15C81.83 54.84 80.3 58.2 76.85 60.51C75.61 61.34 75.33 61.23 74.87 59.95C73.19 55.25 75.29 49.27 79.55 46.66C80.76 45.92 81.0299 46 81.4499 47.4C81.7799 48.5 82.03 49.62 82.03 51.14L82.04 51.15Z",
    fill: "url(#paint31_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.74 35.27C102.99 35.27 102.82 34.97 104.09 32.43C106.22 28.17 111.06 25.45 115.57 25.98C116.99 26.15 117.13 26.36 116.67 27.69C115.12 32.2 110.71 35.26 105.75 35.26L105.74 35.27Z",
    fill: "url(#paint32_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.63 140.71C41.64 141.81 41.13 143.7 40.14 145.47C39.71 146.24 39.3 146.39 38.54 145.78C34.61 142.62 33.47 135.66 36.17 131.34C36.78 130.36 37.29 130.55 37.95 131.19C40.38 133.54 41.62 136.39 41.63 140.71Z",
    fill: "url(#paint33_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.86 63.47C65.07 62.72 69.66 65.13 71.87 69.28C72.41 70.3 72.79 71.38 73.02 72.52C73.18 73.34 72.88 73.62 72.09 73.69C66.7 74.16 60.95 68.93 60.86 63.47Z",
    fill: "url(#paint34_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.11 48.99C62.84 49.07 67.25 52.29 68.74 56.76C69.23 58.23 69.09 58.44 67.49 58.55C62.7 58.9 57.67 55.51 56.08 50.87C55.53 49.26 55.69 49.04 57.42 48.99C57.65 48.99 57.88 48.99 58.11 48.99Z",
    fill: "url(#paint35_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.85 42.43C73.01 37.56 75.21 33.99 79.63 31.87C81.34 31.05 81.6 31.24 81.78 33.03C82.25 37.85 79.51 42.59 75.1 44.57C73.19 45.43 72.94 45.27 72.86 43.11C72.86 42.88 72.86 42.65 72.86 42.42L72.85 42.43Z",
    fill: "url(#paint36_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.04 98.62C142.63 93.84 145.88 87.64 151.5 85.86C152.72 85.47 152.94 85.66 153.05 86.98C153.46 92.07 150.02 97.16 145.17 98.64C144.8 98.75 144.42 98.83 144.04 98.62Z",
    fill: "url(#paint37_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.64 53.92C139.55 54.14 141.03 55.22 142.33 56.5C145.08 59.21 146.11 62.55 145.67 66.36C145.52 67.68 145.26 67.82 144.07 67.38C138.96 65.49 135.98 59.32 137.64 53.92Z",
    fill: "url(#paint38_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9799 96.51C34.0999 94.68 32.4499 92.05 31.9099 88.75C31.5299 86.45 31.7999 84.19 32.8199 82.04C33.2399 81.15 33.6899 80.98 34.5599 81.6C38.9399 84.75 40.1899 91.87 36.9899 96.51H36.9799Z",
    fill: "url(#paint39_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.5 74.2C137.52 76.07 137.11 77.82 136.27 79.5C135.85 80.33 135.39 80.43 134.69 79.82C131.53 77.05 130.14 73.58 130.64 69.41C130.79 68.12 131.21 66.89 131.8 65.72C132.22 64.87 132.66 64.8 133.36 65.4C136.09 67.71 137.45 70.65 137.5 74.21V74.2Z",
    fill: "url(#paint40_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.59 39.5901C164.04 34.2901 167.77 27.8001 172.87 26.5201C173.84 26.2801 174.12 26.7201 174.2 27.5301C174.41 29.8901 173.94 32.1201 172.78 34.1601C171.2 36.9401 168.87 38.7901 165.59 39.5801V39.5901Z",
    fill: "url(#paint41_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.18 110.61C9.50997 109.85 6.30997 106.45 5.58997 102.54C5.35997 101.33 5.28997 100.1 5.44997 98.87C5.67997 97.12 5.90997 96.97 7.43997 97.7C10.54 99.19 12.47 101.67 13.34 104.96C13.83 106.83 13.92 108.74 13.19 110.6L13.18 110.61Z",
    fill: "url(#paint42_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6599 54.59C34.4999 51.15 41.8399 50.55 46.1399 54.87C46.6999 55.43 46.4199 55.79 45.9299 56.16C40.8399 59.91 33.9599 58.05 31.6599 54.59Z",
    fill: "url(#paint43_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.05 56.19C126.01 61.27 119.03 63.99 114.2 61.47C115.51 56.38 122.55 53.65 128.05 56.19Z",
    fill: "url(#paint44_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7 10C110.41 8.88002 110.92 7.91002 111.4 6.98002C113.37 3.20002 116.53 1.25002 120.78 1.08002C122.12 1.03002 122.31 1.32002 122.03 2.51002C120.91 7.35002 115.74 10.78 110.7 9.99002V10Z",
    fill: "url(#paint45_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9199 77.04C47.7699 77.15 50.8899 79.01 52.9099 82.65C53.5599 83.82 53.3899 84.12 52.1899 84.39C47.8899 85.37 42.9899 83.11 40.9199 79.18C40.1499 77.71 40.3099 77.37 41.9899 77.14C42.5199 77.07 43.0599 77.08 43.9199 77.04Z",
    fill: "url(#paint46_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9301 24.49C80.7401 19.86 82.1901 13.35 86.9001 10.77C89.8001 14.16 88.8701 21.53 83.9301 24.49Z",
    fill: "url(#paint47_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.37 43.03C89.88 42.97 85.93 40.09 84.66 36.22C84.36 35.3 84.61 34.97 85.49 34.81C89.58 34.02 95.21 37.63 96.28 41.73C96.52 42.66 96.18 43.01 95.29 43.01C94.91 43.01 94.52 43.04 94.38 43.05L94.37 43.03Z",
    fill: "url(#paint48_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.47 12.21C93.54 11.08 93.61 10.02 93.97 8.98997C94.26 8.15997 94.68 8.15997 95.36 8.49997C99.16 10.41 101.43 16.43 99.88 20.48C99.55 21.34 99.11 21.52 98.34 21.01C95.14 18.92 93.52 15.97 93.47 12.21Z",
    fill: "url(#paint49_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5399 105.7C26.8899 108.42 28.6499 113.31 27.0099 117.75C26.4499 119.27 26.1599 119.37 24.9399 118.42C21.1499 115.49 20.0799 110.03 22.5399 105.7Z",
    fill: "url(#paint50_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.34 45.25C109.65 41.32 111.37 38.25 115 36.43C116.35 35.75 116.53 35.86 116.78 37.31C117.49 41.38 115.2 45.76 111.41 47.6C109.96 48.3 109.73 48.19 109.47 46.64C109.39 46.19 109.39 45.73 109.35 45.24L109.34 45.25Z",
    fill: "url(#paint51_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6499 102.01C97.4399 97.22 102.67 95.63 107.32 98.06C105.44 102.64 99.4499 104.57 94.6499 102.01Z",
    fill: "url(#paint52_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8199 132.47C62.1299 135.95 60.9399 142.3 57.4699 145.21C56.7399 145.83 56.4099 145.26 56.0699 144.71C53.6999 140.8 54.9599 135.21 58.8199 132.47Z",
    fill: "url(#paint53_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.24 78.64C127.5 82.67 126.39 87.9 122.83 90.39C121.78 91.12 121.55 91.04 121.06 89.77C119.5 85.71 121.19 81.07 125.24 78.63V78.64Z",
    fill: "url(#paint54_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.76 51.65C133.95 51.59 131.96 50.95 130.22 49.57C129.46 48.97 129.57 48.55 130.28 47.99C133.32 45.58 138.75 45.71 141.57 48.27C142.25 48.89 142.27 49.32 141.51 49.88C140.23 50.83 137.97 51.62 135.76 51.65Z",
    fill: "url(#paint55_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.32 102.78C82.05 98.48 83.89 93.25 86.37 91C87.24 90.21 87.5 90.25 88.07 91.29C90 94.84 89.15 100.41 85.33 102.78H85.32Z",
    fill: "url(#paint56_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.67 98.27C17.61 98.26 15.94 97.78 14.41 96.82C13.84 96.46 13.77 96.09 14.22 95.53C16.59 92.65 22.57 92.01 25.63 94.3C26.36 94.85 26.14 95.23 25.63 95.75C24.24 97.18 21.63 98.26 18.65 98.28L18.67 98.27Z",
    fill: "url(#paint57_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91 45.39C158.5 49.4 157.07 54.79 152.81 57.12C150.19 53.2 151.66 47.65 155.91 45.39Z",
    fill: "url(#paint58_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.35 61.7701C90.38 58.8201 91.59 56.4601 93.96 54.7101C94.96 53.9801 95.17 54.0701 95.59 55.1901C96.88 58.5801 95.34 63.2101 92.31 65.1501C91.56 65.6301 91.11 65.6401 90.78 64.7001C90.45 63.7401 90.33 62.7701 90.35 61.7601V61.7701Z",
    fill: "url(#paint59_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.11 80.3C83.95 83.95 82.33 86.6 79.12 88.25C78.49 88.57 78.03 88.69 77.73 87.82C76.61 84.58 79.5 79.02 82.84 78.09C83.48 77.91 83.88 78.05 83.95 78.77C84 79.3 84.06 79.83 84.12 80.3H84.11Z",
    fill: "url(#paint60_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76001 86.12C13 83.85 18.19 85.43 20.34 88.58C20.73 89.16 20.95 89.63 20.06 90C17.09 91.24 11.41 90.48 9.76001 86.12Z",
    fill: "url(#paint61_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4 129.97C53.14 133.66 48.02 134 45.27 132.61C44 131.97 43.95 131.62 45 130.62C47.16 128.54 51.85 127.1 55.41 129.97H55.4Z",
    fill: "url(#paint62_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4099 128.16C28.4199 128.01 26.5999 127.47 25.0799 126.16C24.5699 125.72 24.5199 125.34 25.0799 124.86C27.5899 122.68 33.0799 122.92 35.3199 125.32C35.8599 125.89 35.6299 126.24 35.1299 126.61C33.7199 127.66 32.0899 128.02 30.4199 128.16H30.4099Z",
    fill: "url(#paint63_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.63 107.32C47.93 103.47 51.46 100.21 55.25 100.23C56.25 100.23 56.38 100.74 56.22 101.55C55.5 105.24 51.46 107.95 47.62 107.32H47.63Z",
    fill: "url(#paint64_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.03 137.9C25.88 141.18 24.38 143.59 21.5 145.09C20.51 145.61 20.15 145.38 19.94 144.28C19.37 141.28 21.28 137.51 24.13 136.03C25.52 135.31 25.83 135.47 25.98 137.03C26.01 137.33 26.01 137.64 26.02 137.91L26.03 137.9Z",
    fill: "url(#paint65_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6099 100.89C32.2599 104.38 27.0099 104.55 24.3599 102.9C23.3699 102.28 23.3399 102.02 24.1999 101.19C26.8699 98.61 31.3499 98.46 34.6099 100.9V100.89Z",
    fill: "url(#paint66_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.46 88.1401C47.79 87.1201 51.49 90.9301 52.13 93.7001C52.42 94.9901 52.28 95.1901 50.97 95.1501C47.3 95.0401 44.39 92.3801 43.46 88.1401Z",
    fill: "url(#paint67_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2 109.06C35.97 109.08 35.73 108.77 36.05 107.53C36.85 104.42 40.46 101.7 43.6 101.81C44.53 101.84 44.8 102.18 44.57 103.1C43.77 106.31 40.47 109.01 37.2 109.06Z",
    fill: "url(#paint68_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.28 4.81995C106 7.91995 106.33 11.9199 104.23 14.8899C103.44 16.0099 103.16 16.0199 102.37 14.9899C100.15 12.0799 100.5 7.67995 103.28 4.82995V4.81995Z",
    fill: "url(#paint69_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5399 84.14C62.6299 80.9 63.8899 78.58 66.3899 76.95C67.0899 76.49 67.4799 76.7 67.7499 77.47C68.8199 80.56 67.3299 84.77 64.4999 86.59C63.3999 87.29 63.0699 87.18 62.7799 85.92C62.6299 85.25 62.5899 84.56 62.5399 84.14Z",
    fill: "url(#paint70_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4899 106.67C73.3499 109.98 69.6799 111.28 66.2899 110C64.8999 109.48 64.8199 109.21 65.7599 108.12C68.0899 105.42 72.0099 104.78 75.4799 106.67H75.4899Z",
    fill: "url(#paint71_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.59 107.63C108.63 107.54 106.99 107.82 106.63 106.75C106.22 105.51 107.68 104.71 108.67 104.02C110.62 102.65 112.82 102.5 115.07 103.02C116.39 103.33 116.5 103.82 115.62 104.94C114.3 106.62 112.12 107.62 109.59 107.63Z",
    fill: "url(#paint72_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0998 63.3099C82.7998 63.0399 85.5898 64.6399 86.8498 67.6199C87.6098 69.3999 87.2798 69.8699 85.4298 69.6499C82.1298 69.2499 79.6798 66.8399 79.0898 63.3099H79.0998Z",
    fill: "url(#paint73_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3699 48.72C91.0199 51.61 90.7599 55.75 87.7699 58.4C85.1199 55.52 85.3799 51.4 88.3699 48.72Z",
    fill: "url(#paint74_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.54 62.49C100.24 66.35 99.1 69.8 95.59 71.79C93.59 68.52 94.8 64.58 98.54 62.49Z",
    fill: "url(#paint75_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.73 78.51C86.93 78.56 84.17 76.92 83.21 74.65C82.92 73.97 82.95 73.54 83.85 73.37C86.67 72.83 89.84 74.27 91.2699 76.81C92.0099 78.13 91.88 78.38 90.41 78.51C90.18 78.53 89.95 78.51 89.72 78.51H89.73Z",
    fill: "url(#paint76_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.43 28.61C90.31 25.85 89.84 22.58 91.98 19.14C95.23 20.92 95.93 25.19 93.43 28.61Z",
    fill: "url(#paint77_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7699 127.26C57.3299 127.13 55.3499 126.28 53.9399 124.33C53.2499 123.38 53.3999 123.01 54.4799 122.73C57.0699 122.05 60.0999 123.1 61.6799 125.21C62.5399 126.36 62.4299 126.69 61.0299 127.03C60.5899 127.14 60.1299 127.19 59.7699 127.26Z",
    fill: "url(#paint78_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.61 106.02C59.65 106.03 59.46 105.74 59.75 104.72C60.49 102.14 62.8299 100.18 65.5899 99.87C66.8099 99.73 67.12 100.1 66.8 101.28C66.14 103.74 63.2 105.99 60.61 106.02Z",
    fill: "url(#paint79_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.07 115.96C51.93 118.29 50.68 122.12 48.9 123.57C48.01 124.29 47.66 124.21 47.28 123.15C46.32 120.44 47.45 117.53 50.07 115.97V115.96Z",
    fill: "url(#paint80_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7199 138.55C63.3399 136.08 63.8999 132.92 65.9799 131.35C66.7899 130.74 67.1099 130.84 67.4699 131.8C68.4099 134.28 67.2299 137.17 64.7199 138.55Z",
    fill: "url(#paint81_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.68 154.76C152.15 164.03 153.26 173.16 156.03 182.05C156.63 183.26 156.63 184.49 159.28 184.5H121.07C123.47 184.51 124.06 182.73 124.22 182.22C127.03 173.34 128.16 164.21 127.63 154.94C126.91 142.51 117.99 133.55 105.57 132.33C100.88 131.87 96.21 132.03 91.53 132.15C84.51 132.33 77.57 131.81 70.7 130.35C68 129.78 65.26 129.37 62.47 129.76C59.35 130.19 56.95 131.91 54.7 133.97C55.94 131.23 58.05 129.4 60.77 128.23C62.76 127.37 64.88 126.96 67.04 126.89C68.96 126.83 70.88 126.93 72.8 126.83C74.16 126.76 75.27 127.58 76.68 127.56C75.21 126.49 73.74 125.41 72.35 124.25C69.94 122.23 67.5 120.23 65.03 118.27C63.83 117.32 62.56 116.43 61.26 115.62C54.65 111.51 46.82 114.12 44.26 121.54C42.76 125.9 39.93 128.46 35.67 129.71C33.34 130.39 31.03 131.14 28.83 132.24C29.97 130.9 31.39 130 32.97 129.32C34.09 128.83 35.24 128.38 36.33 127.81C39 126.43 40.83 124.39 41.26 121.29C41.37 120.47 41.62 119.67 41.82 118.79C40.78 118.75 40.1 119.3 39.36 119.62C36.81 120.71 34.23 121.62 31.45 121.98C27.66 122.46 24.28 121.53 21.3 119.21C19.62 117.9 18.18 116.32 16.6 114.54C17.54 114.54 17.88 115.09 18.31 115.45C19.01 116.05 19.66 116.7 20.37 117.29C24.08 120.4 28.26 121.21 32.88 119.77C35.61 118.92 38.11 117.56 40.56 116.13C43.28 114.54 45.96 112.91 48.79 111.51C53.95 108.95 58.96 109.08 63.96 111.97C66.96 113.71 69.79 115.67 72.65 117.61C74.81 119.07 77.01 120.47 79.22 121.86C82.57 123.97 86.2 124.78 90.18 124.69C95.33 124.57 100.45 124.01 105.61 124.11C110.47 124.2 115.27 124.55 119.8 126.52C120.1 127.02 120.56 127.28 121.18 127.49C120.95 126.82 120.56 126.47 119.98 126.32C118.66 124.8 116.8 124.25 115.01 123.59C111.69 122.37 108.19 121.8 104.77 120.94C102.38 120.34 100.05 119.61 97.86 118.47C95.53 117.27 92.98 116.65 90.51 115.81C88.4 115.09 86.33 114.29 84.34 113.28C80.99 111.57 78.23 109.19 76.06 106.12C75.62 105.49 75.15 104.88 74.77 104.21C72.69 100.47 69.31 99.09 65.26 98.68C60.85 98.24 56.53 98.8801 52.19 99.41C47.55 99.98 42.91 100.71 38.2 100.17C35.02 99.8 32.3 98.6 30.18 96.14C29.01 94.78 27.76 93.49 26.65 92.07C28 92.65 29.05 93.66 30.01 94.69C33.11 98.05 36.97 98.87 41.33 98.52C46.71 98.09 51.9 96.63 57.2 95.79C58.1 95.65 59 95.5 59.96 95.35C59.92 95.08 59.96 94.8101 59.83 94.66C56.8 90.8101 55.8 86.28 55.36 81.56C55.03 77.96 55.22 74.3401 55.16 70.7301C55.12 68.8101 55.09 66.8801 54.87 64.9801C54.41 61.0301 52.75 57.64 49.85 54.8801C49.24 54.3 48.6 53.75 47.97 53.18C48.58 52.78 48.88 53.3301 49.22 53.5601C54.23 56.8301 56.52 61.69 57.19 67.45C57.69 71.72 58.05 76 58.6 80.27C58.98 83.25 59.81 86.12 61.25 88.8C62.6 91.33 64.62 92.94 67.42 93.54C68.98 93.87 70.55 94.1701 72.27 94.51C72.33 93.69 71.95 93.11 71.73 92.51C69.84 87.4901 70.24 82.64 73.22 78.21C75.11 75.39 75.26 72.53 74.52 69.42C73.88 66.72 72.84 64.16 71.84 61.59C70.86 59.0801 70 56.5401 69.43 53.91C68.95 51.71 68.82 49.5201 70.42 47.59C69.34 50.8601 70.49 53.82 71.74 56.71C72.99 59.6 74.45 62.39 75.79 65.24C76.87 67.54 77.75 69.9 78.06 72.45C78.35 74.88 78.07 77.19 76.83 79.35C74.53 83.36 74.63 87.35 76.83 91.4C78.19 93.89 79.45 96.4501 80.59 99.04C82.74 103.9 86.38 106.86 91.55 107.98C99.33 109.67 106.91 112.25 114.89 113.12C120.42 113.72 125.41 115.82 129.51 119.77C131.46 121.64 133.09 123.57 132.36 126.54C132.31 126.75 132.4 126.99 132.56 127.26C133.5 123.64 135.25 120.31 136.12 116.66C136.82 113.71 135.76 111.57 133.32 109.97C131.77 108.95 130.06 108.26 128.37 107.53C124.85 106 121.31 104.52 117.81 102.96C114.92 101.67 112.21 100.08 109.99 97.77C109.18 96.93 108.18 96.37 107.12 95.89C104.73 94.82 102.27 93.96 99.74 93.32C98.4 92.98 97.09 92.54 95.86 91.89C91.67 89.67 90.55 86.8 92.14 82.35C92.42 81.56 92.72 80.76 93.09 80C93.99 78.16 93.77 76.46 92.64 74.78C91.65 73.32 90.69 71.83 89.8 70.31C88.28 67.73 87.8 65.8 87.89 62.98C88.1 63.3801 88.3 63.6301 88.36 63.91C88.92 66.5601 90.44 68.66 92.2 70.63C93.22 71.78 94.29 72.8901 95.25 74.0801C96.73 75.9301 97.26 78 96.59 80.34C96.29 81.37 96.08 82.43 95.93 83.49C95.6 85.89 95.98 86.44 98.36 87.07C99.25 87.3 100.16 87.46 101.07 87.58C102.05 87.7001 103.04 87.74 104.1 87.81C104.43 87.06 104.14 86.41 104.01 85.76C102.71 79.25 102.22 72.71 103.07 66.07C103.82 60.23 103.15 54.6001 100.03 49.4001C98.15 46.2601 97.21 42.7701 96.88 39.14C96.71 37.28 95.94 35.79 94.64 34.48C93.05 32.88 91.15 31.73 89.23 30.59C87.52 29.57 85.78 28.59 84.12 27.49C83.06 26.79 82.08 25.94 81.77 24.57C83.51 26.24 85.64 27.18 87.82 28.0201C91.04 29.25 94.23 30.5301 97.16 32.6301C98.94 25.5001 102.37 19.4 106.87 13.84C106.52 14.57 106.18 15.3 105.82 16.02C103.61 20.42 101.77 24.96 100.78 29.81C99.6 35.61 100.62 40.9401 104.06 45.7901C105.7 48.1001 107.57 50.25 108.87 52.7701C109.65 52.68 109.95 52.09 110.37 51.7001C113.77 48.5801 117.76 46.4901 122.03 44.8801C125.4 43.6101 128.81 42.42 132.19 41.17C134.14 40.45 136.01 39.57 137.81 38.53C144.03 34.94 147.5 29.55 148.5 22.47C149.06 18.5 149.06 14.53 148.72 10.55C150.18 16.74 150.59 22.94 148.79 29.12C147.27 34.35 143.9 38.26 139.52 41.37C136.75 43.34 133.69 44.7701 130.63 46.2001C128.06 47.4001 125.48 48.59 122.92 49.8101C121.18 50.6401 119.57 51.6701 118 52.7901C113.17 56.23 110.63 60.96 110.3 66.82C109.94 73.18 110.99 79.37 113.09 85.37C114.35 88.98 116.71 91.5601 120.44 92.76C121.53 93.11 122.61 93.54 123.68 93.95C125.88 94.78 128.24 95.18 130.45 96.37C128.8 94.75 129.54 93.14 130.21 91.55C131.48 88.55 133.34 85.91 135.47 83.48C137.7 80.94 139.99 78.46 142.25 75.94C143.64 74.39 144.88 72.74 146 70.99C149.48 65.55 149.9 59.8101 147.8 53.7901C147.53 53.0201 147.04 52.3101 147.03 51.07C151.17 56.83 153.04 62.73 151.48 69.49C150.61 73.27 149.03 76.75 147.09 80.08C145.66 82.53 144.14 84.94 142.71 87.39C141.59 89.31 140.65 91.32 140.05 93.49C139.35 95.99 139.81 98.18 141.36 100.21C142.16 101.25 143.13 102.12 144.06 103.04C147.12 106.06 149.16 109.55 149.02 114.03C148.97 115.75 148.34 117.29 147.74 118.9C151.89 127.7 152.71 154.79 152.71 154.79L152.68 154.76ZM138.09 159.28C137.89 159.8 137.93 160.31 138.09 161.08V159.29C138.02 157.76 137.94 156.24 137.87 154.71C137.71 151.18 137.31 147.69 136.01 144.37C135.3 142.56 134.49 140.79 132.93 139.47C133.04 140.06 133.31 140.58 133.56 141.11C134.99 144.09 136.01 147.21 136.46 150.49C136.8 152.99 137.08 155.5 137.39 158C137.45 158.51 137.37 159.12 138.09 159.28ZM112.31 130.79C116.52 132.47 120.4 134.67 123.63 137.88C126.9 141.13 129.09 145.05 130.72 149.33C130.3 140.01 121.21 130.85 112.3 130.79H112.31ZM136.19 125.83C137.47 122.89 139.12 120.11 139.93 116.99C141.02 112.75 138.89 108.61 134.97 107.27C134.97 107.32 134.96 107.4 134.99 107.43C135.2 107.65 135.42 107.86 135.65 108.07C137.65 109.89 138.51 112.15 138.39 114.85C138.3 117.02 137.64 119.06 137.12 121.13C136.73 122.67 136.09 124.16 136.2 125.83H136.19ZM133.93 158.43C133.6 159.57 133.86 160.55 133.95 161.53C134.47 167.32 135.17 173.1 134.61 178.92C134.46 180.51 134.15 182.1 133.91 183.68C133.86 184.01 133.9 184.3 134.25 184.41C134.66 184.54 135.02 184.46 135.16 184.01C135.28 183.65 135.38 183.27 135.42 182.9C135.76 179.63 136.17 176.37 135.86 173.06C135.4 168.21 134.78 163.38 133.93 158.43ZM108.47 118.73C114.52 120.97 120.9 122.63 125.32 127.9C121.69 121.21 115.01 120.1 108.47 118.73ZM131.71 171.58C131.17 175.68 130.43 179.73 129.07 183.65C129.05 183.72 129.04 183.8 129.03 183.88C128.97 184.14 129.08 184.36 129.3 184.42C129.5 184.47 129.81 184.47 129.94 184.35C130.16 184.16 130.34 183.88 130.41 183.6C131.37 179.66 132.14 175.69 131.71 171.59V171.58Z",
    fill: "url(#paint82_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77 26.8199C152.16 26.8199 151.87 26.3099 153.59 23.0599C156.48 17.5799 162.66 14.4299 168.77 15.3199C170.2 15.5299 170.27 15.65 169.77 17.12C167.81 22.82 162.02 26.8399 155.78 26.8299L155.77 26.8199Z",
    fill: "url(#paint83_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.42 26.54C143.46 27.87 143.24 29.15 142.93 30.42C142.68 31.48 142.21 31.54 141.28 31.14C135.17 28.51 131.41 20.45 133.33 14C133.69 12.78 133.95 12.61 135.12 13.23C140.48 16.05 143.18 20.54 143.41 26.54H143.42Z",
    fill: "url(#paint84_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91002 135.1C9.03002 128.87 13.17 123.31 18.91 121.54C20.79 120.96 21.08 121.16 21.14 123.07C21.33 129.28 16.86 135.36 10.88 137.02C9.19002 137.49 9.06003 137.39 8.93003 135.7C8.91003 135.47 8.91002 135.24 8.90002 135.11L8.91002 135.1Z",
    fill: "url(#paint85_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3899 87.62C23.3099 86.53 21.7699 84.88 20.6099 82.88C18.1899 78.7 17.9099 74.37 19.8199 69.91C20.1599 69.1 20.4599 68.61 21.4699 69.25C27.2099 72.9 29.2099 81.9 25.3999 87.62H25.3899Z",
    fill: "url(#paint86_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0199 37.7399C65.1499 33.2599 64.9099 23.5199 70.4799 18.6899C74.9999 21.7699 76.2699 32.3699 70.0199 37.7399Z",
    fill: "url(#paint87_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.23 22.96C109.17 22.83 108.1 22.74 107.05 22.55C106.35 22.42 106.08 22.07 106.37 21.25C108.39 15.56 116.23 11.67 122.06 13.46C123.07 13.77 122.95 14.24 122.66 14.98C120.8 19.62 115.65 22.91 110.23 22.97V22.96Z",
    fill: "url(#paint88_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.01 62.3C47 62.45 50.81 64.64 53.38 68.93C54.3 70.47 54.18 70.69 52.53 71.1C46.9 72.52 40.69 69.85 37.95 64.84C37.09 63.27 37.16 63.15 38.81 62.66C39.86 62.35 40.93 62.33 42.02 62.3H42.01Z",
    fill: "url(#paint89_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.38 114.7C12.65 114.8 13.88 114.79 15.06 115.2C16.35 115.65 16.46 115.8 15.8 116.95C13.92 120.27 11.08 122.31 7.36996 123.16C5.30996 123.63 3.24996 123.53 1.22996 123C-0.170035 122.63 -0.300035 122.35 0.439965 121.11C2.90996 116.95 6.62996 114.89 11.38 114.7Z",
    fill: "url(#paint90_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1399 34.5601C54.1499 38.0101 54.4399 48.0001 49.5999 51.8001C44.8199 47.9501 44.3499 38.9501 49.1399 34.5601Z",
    fill: "url(#paint91_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.74 44.94C67.74 46.45 67.6 46.57 66.19 46.3C60.76 45.24 56.25 39.61 56.44 34.15C56.48 32.93 56.77 32.71 58.02 32.95C63.28 33.98 67.71 39.45 67.73 44.95L67.74 44.94Z",
    fill: "url(#paint92_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 40.94C122.82 37.57 121.54 29.74 125.99 24.27C126.76 23.32 127.21 23.81 127.75 24.48C131.77 29.49 131.21 36.8 127 40.93V40.94Z",
    fill: "url(#paint93_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.12 41.57C148.1 41.61 147.13 41.37 146.16 41.13C144.69 40.77 144.58 40.57 145.29 39.3C147.38 35.57 150.59 33.43 154.81 32.87C156.18 32.69 157.57 32.72 158.93 33.02C160.91 33.46 161.04 33.71 160.01 35.38C157.52 39.44 153.79 41.35 149.12 41.57Z",
    fill: "url(#paint94_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.05 0C143.51 1.17 147.66 7.61 146.39 14.33C140.46 14.22 135.4 6.6 137.05 0Z",
    fill: "url(#paint95_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.95 68.12C124.59 73.64 118.99 79.06 113.67 79.14C112.88 79.15 112.53 78.8999 112.61 78.0899C113.3 71.6199 118.26 67.24 123.96 66.68C125.33 66.55 124.89 67.53 124.95 68.12Z",
    fill: "url(#paint96_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.69 1.36999C163.1 7.39999 159.4 13.96 153.78 15.65C153.06 15.87 152.33 16.18 152.11 14.91C151.04 9.00999 155.61 2.42999 161.7 1.35999L161.69 1.36999Z",
    fill: "url(#paint97_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.04 51.15C81.83 54.84 80.3 58.2 76.85 60.51C75.61 61.34 75.33 61.23 74.87 59.95C73.19 55.25 75.29 49.27 79.55 46.66C80.76 45.92 81.0299 46 81.4499 47.4C81.7799 48.5 82.03 49.62 82.03 51.14L82.04 51.15Z",
    fill: "url(#paint98_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.74 35.27C102.99 35.27 102.82 34.97 104.09 32.43C106.22 28.17 111.06 25.45 115.57 25.98C116.99 26.15 117.13 26.36 116.67 27.69C115.12 32.2 110.71 35.26 105.75 35.26L105.74 35.27Z",
    fill: "url(#paint99_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.63 140.71C41.64 141.81 41.13 143.7 40.14 145.47C39.71 146.24 39.3 146.39 38.54 145.78C34.61 142.62 33.47 135.66 36.17 131.34C36.78 130.36 37.29 130.55 37.95 131.19C40.38 133.54 41.62 136.39 41.63 140.71Z",
    fill: "url(#paint100_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.86 63.47C65.07 62.72 69.66 65.13 71.87 69.28C72.41 70.3 72.79 71.38 73.02 72.52C73.18 73.34 72.88 73.62 72.09 73.69C66.7 74.16 60.95 68.93 60.86 63.47Z",
    fill: "url(#paint101_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.11 48.99C62.84 49.07 67.25 52.29 68.74 56.76C69.23 58.23 69.09 58.44 67.49 58.55C62.7 58.9 57.67 55.51 56.08 50.87C55.53 49.26 55.69 49.04 57.42 48.99C57.65 48.99 57.88 48.99 58.11 48.99Z",
    fill: "url(#paint102_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.85 42.43C73.01 37.56 75.21 33.99 79.63 31.87C81.34 31.05 81.6 31.24 81.78 33.03C82.25 37.85 79.51 42.59 75.1 44.57C73.19 45.43 72.94 45.27 72.86 43.11C72.86 42.88 72.86 42.65 72.86 42.42L72.85 42.43Z",
    fill: "url(#paint103_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.04 98.62C142.63 93.84 145.88 87.64 151.5 85.86C152.72 85.47 152.94 85.66 153.05 86.98C153.46 92.07 150.02 97.16 145.17 98.64C144.8 98.75 144.42 98.83 144.04 98.62Z",
    fill: "url(#paint104_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.64 53.92C139.55 54.14 141.03 55.22 142.33 56.5C145.08 59.21 146.11 62.55 145.67 66.36C145.52 67.68 145.26 67.82 144.07 67.38C138.96 65.49 135.98 59.32 137.64 53.92Z",
    fill: "url(#paint105_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9799 96.51C34.0999 94.68 32.4499 92.05 31.9099 88.75C31.5299 86.45 31.7999 84.19 32.8199 82.04C33.2399 81.15 33.6899 80.98 34.5599 81.6C38.9399 84.75 40.1899 91.87 36.9899 96.51H36.9799Z",
    fill: "url(#paint106_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.5 74.2C137.52 76.07 137.11 77.82 136.27 79.5C135.85 80.33 135.39 80.43 134.69 79.82C131.53 77.05 130.14 73.58 130.64 69.41C130.79 68.12 131.21 66.89 131.8 65.72C132.22 64.87 132.66 64.8 133.36 65.4C136.09 67.71 137.45 70.65 137.5 74.21V74.2Z",
    fill: "url(#paint107_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.59 39.5901C164.04 34.2901 167.77 27.8001 172.87 26.5201C173.84 26.2801 174.12 26.7201 174.2 27.5301C174.41 29.8901 173.94 32.1201 172.78 34.1601C171.2 36.9401 168.87 38.7901 165.59 39.5801V39.5901Z",
    fill: "url(#paint108_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.18 110.61C9.50997 109.85 6.30997 106.45 5.58997 102.54C5.35997 101.33 5.28997 100.1 5.44997 98.87C5.67997 97.12 5.90997 96.97 7.43997 97.7C10.54 99.19 12.47 101.67 13.34 104.96C13.83 106.83 13.92 108.74 13.19 110.6L13.18 110.61Z",
    fill: "url(#paint109_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6599 54.59C34.4999 51.15 41.8399 50.55 46.1399 54.87C46.6999 55.43 46.4199 55.79 45.9299 56.16C40.8399 59.91 33.9599 58.05 31.6599 54.59Z",
    fill: "url(#paint110_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.05 56.19C126.01 61.27 119.03 63.99 114.2 61.47C115.51 56.38 122.55 53.65 128.05 56.19Z",
    fill: "url(#paint111_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7 10C110.41 8.88002 110.92 7.91002 111.4 6.98002C113.37 3.20002 116.53 1.25002 120.78 1.08002C122.12 1.03002 122.31 1.32002 122.03 2.51002C120.91 7.35002 115.74 10.78 110.7 9.99002V10Z",
    fill: "url(#paint112_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9199 77.04C47.7699 77.15 50.8899 79.01 52.9099 82.65C53.5599 83.82 53.3899 84.12 52.1899 84.39C47.8899 85.37 42.9899 83.11 40.9199 79.18C40.1499 77.71 40.3099 77.37 41.9899 77.14C42.5199 77.07 43.0599 77.08 43.9199 77.04Z",
    fill: "url(#paint113_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9301 24.49C80.7401 19.86 82.1901 13.35 86.9001 10.77C89.8001 14.16 88.8701 21.53 83.9301 24.49Z",
    fill: "url(#paint114_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.37 43.03C89.88 42.97 85.93 40.09 84.66 36.22C84.36 35.3 84.61 34.97 85.49 34.81C89.58 34.02 95.21 37.63 96.28 41.73C96.52 42.66 96.18 43.01 95.29 43.01C94.91 43.01 94.52 43.04 94.38 43.05L94.37 43.03Z",
    fill: "url(#paint115_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.47 12.21C93.54 11.08 93.61 10.02 93.97 8.98997C94.26 8.15997 94.68 8.15997 95.36 8.49997C99.16 10.41 101.43 16.43 99.88 20.48C99.55 21.34 99.11 21.52 98.34 21.01C95.14 18.92 93.52 15.97 93.47 12.21Z",
    fill: "url(#paint116_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5399 105.7C26.8899 108.42 28.6499 113.31 27.0099 117.75C26.4499 119.27 26.1599 119.37 24.9399 118.42C21.1499 115.49 20.0799 110.03 22.5399 105.7Z",
    fill: "url(#paint117_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.34 45.25C109.65 41.32 111.37 38.25 115 36.43C116.35 35.75 116.53 35.86 116.78 37.31C117.49 41.38 115.2 45.76 111.41 47.6C109.96 48.3 109.73 48.19 109.47 46.64C109.39 46.19 109.39 45.73 109.35 45.24L109.34 45.25Z",
    fill: "url(#paint118_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6499 102.01C97.4399 97.22 102.67 95.63 107.32 98.06C105.44 102.64 99.4499 104.57 94.6499 102.01Z",
    fill: "url(#paint119_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8199 132.47C62.1299 135.95 60.9399 142.3 57.4699 145.21C56.7399 145.83 56.4099 145.26 56.0699 144.71C53.6999 140.8 54.9599 135.21 58.8199 132.47Z",
    fill: "url(#paint120_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.24 78.64C127.5 82.67 126.39 87.9 122.83 90.39C121.78 91.12 121.55 91.04 121.06 89.77C119.5 85.71 121.19 81.07 125.24 78.63V78.64Z",
    fill: "url(#paint121_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.76 51.65C133.95 51.59 131.96 50.95 130.22 49.57C129.46 48.97 129.57 48.55 130.28 47.99C133.32 45.58 138.75 45.71 141.57 48.27C142.25 48.89 142.27 49.32 141.51 49.88C140.23 50.83 137.97 51.62 135.76 51.65Z",
    fill: "url(#paint122_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.32 102.78C82.05 98.48 83.89 93.25 86.37 91C87.24 90.21 87.5 90.25 88.07 91.29C90 94.84 89.15 100.41 85.33 102.78H85.32Z",
    fill: "url(#paint123_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.67 98.27C17.61 98.26 15.94 97.78 14.41 96.82C13.84 96.46 13.77 96.09 14.22 95.53C16.59 92.65 22.57 92.01 25.63 94.3C26.36 94.85 26.14 95.23 25.63 95.75C24.24 97.18 21.63 98.26 18.65 98.28L18.67 98.27Z",
    fill: "url(#paint124_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91 45.39C158.5 49.4 157.07 54.79 152.81 57.12C150.19 53.2 151.66 47.65 155.91 45.39Z",
    fill: "url(#paint125_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.35 61.7701C90.38 58.8201 91.59 56.4601 93.96 54.7101C94.96 53.9801 95.17 54.0701 95.59 55.1901C96.88 58.5801 95.34 63.2101 92.31 65.1501C91.56 65.6301 91.11 65.6401 90.78 64.7001C90.45 63.7401 90.33 62.7701 90.35 61.7601V61.7701Z",
    fill: "url(#paint126_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.11 80.3C83.95 83.95 82.33 86.6 79.12 88.25C78.49 88.57 78.03 88.69 77.73 87.82C76.61 84.58 79.5 79.02 82.84 78.09C83.48 77.91 83.88 78.05 83.95 78.77C84 79.3 84.06 79.83 84.12 80.3H84.11Z",
    fill: "url(#paint127_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76001 86.12C13 83.85 18.19 85.43 20.34 88.58C20.73 89.16 20.95 89.63 20.06 90C17.09 91.24 11.41 90.48 9.76001 86.12Z",
    fill: "url(#paint128_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4 129.97C53.14 133.66 48.02 134 45.27 132.61C44 131.97 43.95 131.62 45 130.62C47.16 128.54 51.85 127.1 55.41 129.97H55.4Z",
    fill: "url(#paint129_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4099 128.16C28.4199 128.01 26.5999 127.47 25.0799 126.16C24.5699 125.72 24.5199 125.34 25.0799 124.86C27.5899 122.68 33.0799 122.92 35.3199 125.32C35.8599 125.89 35.6299 126.24 35.1299 126.61C33.7199 127.66 32.0899 128.02 30.4199 128.16H30.4099Z",
    fill: "url(#paint130_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.63 107.32C47.93 103.47 51.46 100.21 55.25 100.23C56.25 100.23 56.38 100.74 56.22 101.55C55.5 105.24 51.46 107.95 47.62 107.32H47.63Z",
    fill: "url(#paint131_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.03 137.9C25.88 141.18 24.38 143.59 21.5 145.09C20.51 145.61 20.15 145.38 19.94 144.28C19.37 141.28 21.28 137.51 24.13 136.03C25.52 135.31 25.83 135.47 25.98 137.03C26.01 137.33 26.01 137.64 26.02 137.91L26.03 137.9Z",
    fill: "url(#paint132_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6099 100.89C32.2599 104.38 27.0099 104.55 24.3599 102.9C23.3699 102.28 23.3399 102.02 24.1999 101.19C26.8699 98.61 31.3499 98.46 34.6099 100.9V100.89Z",
    fill: "url(#paint133_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.46 88.1401C47.79 87.1201 51.49 90.9301 52.13 93.7001C52.42 94.9901 52.28 95.1901 50.97 95.1501C47.3 95.0401 44.39 92.3801 43.46 88.1401Z",
    fill: "url(#paint134_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2 109.06C35.97 109.08 35.73 108.77 36.05 107.53C36.85 104.42 40.46 101.7 43.6 101.81C44.53 101.84 44.8 102.18 44.57 103.1C43.77 106.31 40.47 109.01 37.2 109.06Z",
    fill: "url(#paint135_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.28 4.81995C106 7.91995 106.33 11.9199 104.23 14.8899C103.44 16.0099 103.16 16.0199 102.37 14.9899C100.15 12.0799 100.5 7.67995 103.28 4.82995V4.81995Z",
    fill: "url(#paint136_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5399 84.14C62.6299 80.9 63.8899 78.58 66.3899 76.95C67.0899 76.49 67.4799 76.7 67.7499 77.47C68.8199 80.56 67.3299 84.77 64.4999 86.59C63.3999 87.29 63.0699 87.18 62.7799 85.92C62.6299 85.25 62.5899 84.56 62.5399 84.14Z",
    fill: "url(#paint137_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4899 106.67C73.3499 109.98 69.6799 111.28 66.2899 110C64.8999 109.48 64.8199 109.21 65.7599 108.12C68.0899 105.42 72.0099 104.78 75.4799 106.67H75.4899Z",
    fill: "url(#paint138_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.59 107.63C108.63 107.54 106.99 107.82 106.63 106.75C106.22 105.51 107.68 104.71 108.67 104.02C110.62 102.65 112.82 102.5 115.07 103.02C116.39 103.33 116.5 103.82 115.62 104.94C114.3 106.62 112.12 107.62 109.59 107.63Z",
    fill: "url(#paint139_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0998 63.3099C82.7998 63.0399 85.5898 64.6399 86.8498 67.6199C87.6098 69.3999 87.2798 69.8699 85.4298 69.6499C82.1298 69.2499 79.6798 66.8399 79.0898 63.3099H79.0998Z",
    fill: "url(#paint140_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3699 48.72C91.0199 51.61 90.7599 55.75 87.7699 58.4C85.1199 55.52 85.3799 51.4 88.3699 48.72Z",
    fill: "url(#paint141_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.54 62.49C100.24 66.35 99.1 69.8 95.59 71.79C93.59 68.52 94.8 64.58 98.54 62.49Z",
    fill: "url(#paint142_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.73 78.51C86.93 78.56 84.17 76.92 83.21 74.65C82.92 73.97 82.95 73.54 83.85 73.37C86.67 72.83 89.84 74.27 91.2699 76.81C92.0099 78.13 91.88 78.38 90.41 78.51C90.18 78.53 89.95 78.51 89.72 78.51H89.73Z",
    fill: "url(#paint143_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.43 28.61C90.31 25.85 89.84 22.58 91.98 19.14C95.23 20.92 95.93 25.19 93.43 28.61Z",
    fill: "url(#paint144_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7699 127.26C57.3299 127.13 55.3499 126.28 53.9399 124.33C53.2499 123.38 53.3999 123.01 54.4799 122.73C57.0699 122.05 60.0999 123.1 61.6799 125.21C62.5399 126.36 62.4299 126.69 61.0299 127.03C60.5899 127.14 60.1299 127.19 59.7699 127.26Z",
    fill: "url(#paint145_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.61 106.02C59.65 106.03 59.46 105.74 59.75 104.72C60.49 102.14 62.8299 100.18 65.5899 99.87C66.8099 99.73 67.12 100.1 66.8 101.28C66.14 103.74 63.2 105.99 60.61 106.02Z",
    fill: "url(#paint146_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.07 115.96C51.93 118.29 50.68 122.12 48.9 123.57C48.01 124.29 47.66 124.21 47.28 123.15C46.32 120.44 47.45 117.53 50.07 115.97V115.96Z",
    fill: "url(#paint147_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7199 138.55C63.3399 136.08 63.8999 132.92 65.9799 131.35C66.7899 130.74 67.1099 130.84 67.4699 131.8C68.4099 134.28 67.2299 137.17 64.7199 138.55Z",
    fill: "url(#paint148_linear_9_833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.53 108.24V109.43H164.21V108.24C171.27 108.04 170.81 107.05 170.81 93.9901V77.7601C170.81 64.7001 171.27 63.7101 164.21 63.4501V62.3301H190.53V63.4501C183.47 63.7101 183.93 64.7001 183.93 77.7601V85.5401H200.81V77.7601C200.81 64.7001 201.27 63.7101 194.21 63.4501V62.3301H220.53V63.4501C213.47 63.7101 213.93 64.7001 213.93 77.7601V93.9901C213.93 107.05 213.47 108.04 220.53 108.24V109.43H194.21V108.24C201.27 108.04 200.81 107.05 200.81 93.9901V87.0601H183.93V93.9901C183.93 107.05 183.47 108.04 190.53 108.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.46 108.57C228.19 108.37 227.66 108.17 227.66 93.8001C227.66 78.4301 228.71 78.2301 221.06 78.1001V77.1801L240.19 76.3901V93.8001C240.72 108.18 239.66 108.38 246.39 108.57V109.43H221.46V108.57ZM226.54 65.1101C226.54 61.2801 229.9 58.1801 233.8 58.1801C237.7 58.1801 241.06 61.2801 241.06 65.1101C241.06 68.9401 237.76 72.0401 233.8 72.0401C229.84 72.0401 226.54 68.9401 226.54 65.1101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.72 108.57C253.25 108.31 252.99 108.64 252.99 93.14V77.64C252.99 61.94 253.72 62.73 246.26 62.54V61.62L266.71 60.76C266.05 64.06 265.46 74.54 265.46 77.64V89.45C266.38 89.38 267.51 89.25 269.29 89.25C270.21 84.37 273.25 75.14 281.95 75.14C287.82 75.14 290.26 79.3 290.26 82.92C290.26 87.21 286.83 89.38 283.73 89.38C280.63 89.38 277.93 87.34 277.93 83.58C277.93 79.36 281.95 76.92 285.98 78.3C285.39 76.91 283.8 76.19 281.69 76.19C274.7 76.19 271.47 84.37 270.87 89.18H273.24C287.42 89.18 283.07 106.72 288.67 106.72C290.52 106.72 291.64 104.81 291.9 102.04H292.89C292.56 106.59 289.53 110.55 283.19 110.55C267.03 110.55 277.19 90.5 265.78 90.5H265.45V93.14C265.45 108.77 265.32 108.18 271.12 108.57V109.43H246.72V108.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.94 108.57C300.67 108.37 300.14 108.17 300.14 93.8C300.14 78.43 301.2 78.23 293.54 78.1V77.18L312.67 76.39V81.86C314.39 77.84 317.81 75.13 323.55 75.13C328.89 75.13 332.78 77.77 333.97 82.52C335.55 78.17 339.05 75.13 345.12 75.13C351.19 75.13 356.27 79.02 356.27 85.82C356.27 90.44 355.87 94.46 355.87 98.29C355.87 108.58 355.34 108.38 361.74 108.58V109.44H340.11V108.58C344.86 108.38 343.94 108.18 343.87 93.15C343.87 81.81 343.48 79.04 339.72 79.04C336.95 79.04 334.84 81.55 334.38 87.68C334.31 91.57 334.12 95 334.12 98.3C334.12 108.59 333.99 108.39 337.95 108.59V109.45H318.36V108.59C323.11 108.39 322.12 108.19 322.12 93.16C322.12 81.82 321.92 79.05 318.16 79.05C314.93 79.05 312.69 82.41 312.69 90.79V93.82C312.69 108.2 311.77 108.4 316.51 108.59V109.45H293.95V108.59L293.94 108.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.1 98.3501L398.09 98.6101C396.77 105.01 390.77 110.88 381.6 110.88C369.33 110.88 363.73 101.84 363.73 92.9401C363.73 84.0401 369.8 75.0701 382.13 75.0701C394.46 75.0701 397.96 85.4901 397.37 91.8201H375.87V91.8901C375.87 99.6701 379.83 106.2 386.62 106.2C391.77 106.2 395.72 103.63 397.11 98.3501H397.1ZM375.86 90.4401H385.69C386.15 80.4801 385.29 76.1301 381.8 76.1301C378.31 76.1301 376.06 79.4901 375.86 90.4401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.94 78.8901V77.7701C407.84 77.7701 416.02 72.3601 417.61 61.8101H418.8V77.1801H421.04C426.05 77.1801 427.83 74.4101 427.83 70.7201H428.69V85.3601H427.83C427.83 81.6701 426.05 78.9001 421.04 78.9001H418.8V95.7801C418.8 104.09 420.71 106.79 424.01 106.79C428.23 106.79 429.95 101.38 430.34 98.2201L431.4 98.4201C430.67 105.15 427.24 110.89 418.54 110.89C410.69 110.89 405.88 107.59 405.88 99.2201C405.88 95.1301 406.28 91.3701 406.28 85.4301C406.28 78.7701 405.69 78.9001 398.96 78.9001L398.94 78.8901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.31 108.57C440.04 108.37 439.51 108.17 439.51 93.8001C439.51 78.4301 440.57 78.2301 432.91 78.1001V77.1801L452.04 76.3901V93.8001C452.57 108.18 451.51 108.38 458.24 108.57V109.43H433.31V108.57ZM438.38 65.1101C438.38 61.2801 441.74 58.1801 445.64 58.1801C449.54 58.1801 452.9 61.2801 452.9 65.1101C452.9 68.9401 449.6 72.0401 445.64 72.0401C441.68 72.0401 438.38 68.9401 438.38 65.1101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.83 108.57C465.56 108.37 465.03 108.17 465.03 93.8C465.03 78.43 466.09 78.23 458.43 78.1V77.18L477.56 76.39V81.86C479.28 77.84 482.7 75.13 488.44 75.13C495.56 75.13 499.92 79.02 499.92 85.82C499.92 90.44 499.52 94.46 499.52 98.29C499.52 108.58 498.99 108.38 505.39 108.58V109.44H483.76V108.58C488.51 108.38 487.52 108.18 487.52 93.15C487.52 81.81 487.32 79.04 483.04 79.04C479.81 79.04 477.57 82.34 477.57 90.71V93.81C477.57 108.19 476.65 108.39 481.39 108.58V109.44H458.83V108.58V108.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.53 108.24V109.43H164.21V108.24C171.27 108.04 170.81 107.05 170.81 93.9901V77.7601C170.81 64.7001 171.27 63.7101 164.21 63.4501V62.3301H190.53V63.4501C183.47 63.7101 183.93 64.7001 183.93 77.7601V85.5401H200.81V77.7601C200.81 64.7001 201.27 63.7101 194.21 63.4501V62.3301H220.53V63.4501C213.47 63.7101 213.93 64.7001 213.93 77.7601V93.9901C213.93 107.05 213.47 108.04 220.53 108.24V109.43H194.21V108.24C201.27 108.04 200.81 107.05 200.81 93.9901V87.0601H183.93V93.9901C183.93 107.05 183.47 108.04 190.53 108.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.46 108.57C228.19 108.37 227.66 108.17 227.66 93.8001C227.66 78.4301 228.71 78.2301 221.06 78.1001V77.1801L240.19 76.3901V93.8001C240.72 108.18 239.66 108.38 246.39 108.57V109.43H221.46V108.57ZM226.54 65.1101C226.54 61.2801 229.9 58.1801 233.8 58.1801C237.7 58.1801 241.06 61.2801 241.06 65.1101C241.06 68.9401 237.76 72.0401 233.8 72.0401C229.84 72.0401 226.54 68.9401 226.54 65.1101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.72 108.57C253.25 108.31 252.99 108.64 252.99 93.14V77.64C252.99 61.94 253.72 62.73 246.26 62.54V61.62L266.71 60.76C266.05 64.06 265.46 74.54 265.46 77.64V89.45C266.38 89.38 267.51 89.25 269.29 89.25C270.21 84.37 273.25 75.14 281.95 75.14C287.82 75.14 290.26 79.3 290.26 82.92C290.26 87.21 286.83 89.38 283.73 89.38C280.63 89.38 277.93 87.34 277.93 83.58C277.93 79.36 281.95 76.92 285.98 78.3C285.39 76.91 283.8 76.19 281.69 76.19C274.7 76.19 271.47 84.37 270.87 89.18H273.24C287.42 89.18 283.07 106.72 288.67 106.72C290.52 106.72 291.64 104.81 291.9 102.04H292.89C292.56 106.59 289.53 110.55 283.19 110.55C267.03 110.55 277.19 90.5 265.78 90.5H265.45V93.14C265.45 108.77 265.32 108.18 271.12 108.57V109.43H246.72V108.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.94 108.57C300.67 108.37 300.14 108.17 300.14 93.8C300.14 78.43 301.2 78.23 293.54 78.1V77.18L312.67 76.39V81.86C314.39 77.84 317.81 75.13 323.55 75.13C328.89 75.13 332.78 77.77 333.97 82.52C335.55 78.17 339.05 75.13 345.12 75.13C351.19 75.13 356.27 79.02 356.27 85.82C356.27 90.44 355.87 94.46 355.87 98.29C355.87 108.58 355.34 108.38 361.74 108.58V109.44H340.11V108.58C344.86 108.38 343.94 108.18 343.87 93.15C343.87 81.81 343.48 79.04 339.72 79.04C336.95 79.04 334.84 81.55 334.38 87.68C334.31 91.57 334.12 95 334.12 98.3C334.12 108.59 333.99 108.39 337.95 108.59V109.45H318.36V108.59C323.11 108.39 322.12 108.19 322.12 93.16C322.12 81.82 321.92 79.05 318.16 79.05C314.93 79.05 312.69 82.41 312.69 90.79V93.82C312.69 108.2 311.77 108.4 316.51 108.59V109.45H293.95V108.59L293.94 108.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.1 98.3501L398.09 98.6101C396.77 105.01 390.77 110.88 381.6 110.88C369.33 110.88 363.73 101.84 363.73 92.9401C363.73 84.0401 369.8 75.0701 382.13 75.0701C394.46 75.0701 397.96 85.4901 397.37 91.8201H375.87V91.8901C375.87 99.6701 379.83 106.2 386.62 106.2C391.77 106.2 395.72 103.63 397.11 98.3501H397.1ZM375.86 90.4401H385.69C386.15 80.4801 385.29 76.1301 381.8 76.1301C378.31 76.1301 376.06 79.4901 375.86 90.4401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.94 78.8901V77.7701C407.84 77.7701 416.02 72.3601 417.61 61.8101H418.8V77.1801H421.04C426.05 77.1801 427.83 74.4101 427.83 70.7201H428.69V85.3601H427.83C427.83 81.6701 426.05 78.9001 421.04 78.9001H418.8V95.7801C418.8 104.09 420.71 106.79 424.01 106.79C428.23 106.79 429.95 101.38 430.34 98.2201L431.4 98.4201C430.67 105.15 427.24 110.89 418.54 110.89C410.69 110.89 405.88 107.59 405.88 99.2201C405.88 95.1301 406.28 91.3701 406.28 85.4301C406.28 78.7701 405.69 78.9001 398.96 78.9001L398.94 78.8901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.31 108.57C440.04 108.37 439.51 108.17 439.51 93.8001C439.51 78.4301 440.57 78.2301 432.91 78.1001V77.1801L452.04 76.3901V93.8001C452.57 108.18 451.51 108.38 458.24 108.57V109.43H433.31V108.57ZM438.38 65.1101C438.38 61.2801 441.74 58.1801 445.64 58.1801C449.54 58.1801 452.9 61.2801 452.9 65.1101C452.9 68.9401 449.6 72.0401 445.64 72.0401C441.68 72.0401 438.38 68.9401 438.38 65.1101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.83 108.57C465.56 108.37 465.03 108.17 465.03 93.8C465.03 78.43 466.09 78.23 458.43 78.1V77.18L477.56 76.39V81.86C479.28 77.84 482.7 75.13 488.44 75.13C495.56 75.13 499.92 79.02 499.92 85.82C499.92 90.44 499.52 94.46 499.52 98.29C499.52 108.58 498.99 108.38 505.39 108.58V109.44H483.76V108.58C488.51 108.38 487.52 108.18 487.52 93.15C487.52 81.81 487.32 79.04 483.04 79.04C479.81 79.04 477.57 82.34 477.57 90.71V93.81C477.57 108.19 476.65 108.39 481.39 108.58V109.44H458.83V108.58V108.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.53 108.24V109.43H164.21V108.24C171.27 108.04 170.81 107.05 170.81 93.9901V77.7601C170.81 64.7001 171.27 63.7101 164.21 63.4501V62.3301H190.53V63.4501C183.47 63.7101 183.93 64.7001 183.93 77.7601V85.5401H200.81V77.7601C200.81 64.7001 201.27 63.7101 194.21 63.4501V62.3301H220.53V63.4501C213.47 63.7101 213.93 64.7001 213.93 77.7601V93.9901C213.93 107.05 213.47 108.04 220.53 108.24V109.43H194.21V108.24C201.27 108.04 200.81 107.05 200.81 93.9901V87.0601H183.93V93.9901C183.93 107.05 183.47 108.04 190.53 108.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.46 108.57C228.19 108.37 227.66 108.17 227.66 93.8001C227.66 78.4301 228.71 78.2301 221.06 78.1001V77.1801L240.19 76.3901V93.8001C240.72 108.18 239.66 108.38 246.39 108.57V109.43H221.46V108.57ZM226.54 65.1101C226.54 61.2801 229.9 58.1801 233.8 58.1801C237.7 58.1801 241.06 61.2801 241.06 65.1101C241.06 68.9401 237.76 72.0401 233.8 72.0401C229.84 72.0401 226.54 68.9401 226.54 65.1101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.72 108.57C253.25 108.31 252.99 108.64 252.99 93.14V77.64C252.99 61.94 253.72 62.73 246.26 62.54V61.62L266.71 60.76C266.05 64.06 265.46 74.54 265.46 77.64V89.45C266.38 89.38 267.51 89.25 269.29 89.25C270.21 84.37 273.25 75.14 281.95 75.14C287.82 75.14 290.26 79.3 290.26 82.92C290.26 87.21 286.83 89.38 283.73 89.38C280.63 89.38 277.93 87.34 277.93 83.58C277.93 79.36 281.95 76.92 285.98 78.3C285.39 76.91 283.8 76.19 281.69 76.19C274.7 76.19 271.47 84.37 270.87 89.18H273.24C287.42 89.18 283.07 106.72 288.67 106.72C290.52 106.72 291.64 104.81 291.9 102.04H292.89C292.56 106.59 289.53 110.55 283.19 110.55C267.03 110.55 277.19 90.5 265.78 90.5H265.45V93.14C265.45 108.77 265.32 108.18 271.12 108.57V109.43H246.72V108.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.94 108.57C300.67 108.37 300.14 108.17 300.14 93.8C300.14 78.43 301.2 78.23 293.54 78.1V77.18L312.67 76.39V81.86C314.39 77.84 317.81 75.13 323.55 75.13C328.89 75.13 332.78 77.77 333.97 82.52C335.55 78.17 339.05 75.13 345.12 75.13C351.19 75.13 356.27 79.02 356.27 85.82C356.27 90.44 355.87 94.46 355.87 98.29C355.87 108.58 355.34 108.38 361.74 108.58V109.44H340.11V108.58C344.86 108.38 343.94 108.18 343.87 93.15C343.87 81.81 343.48 79.04 339.72 79.04C336.95 79.04 334.84 81.55 334.38 87.68C334.31 91.57 334.12 95 334.12 98.3C334.12 108.59 333.99 108.39 337.95 108.59V109.45H318.36V108.59C323.11 108.39 322.12 108.19 322.12 93.16C322.12 81.82 321.92 79.05 318.16 79.05C314.93 79.05 312.69 82.41 312.69 90.79V93.82C312.69 108.2 311.77 108.4 316.51 108.59V109.45H293.95V108.59L293.94 108.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.1 98.3501L398.09 98.6101C396.77 105.01 390.77 110.88 381.6 110.88C369.33 110.88 363.73 101.84 363.73 92.9401C363.73 84.0401 369.8 75.0701 382.13 75.0701C394.46 75.0701 397.96 85.4901 397.37 91.8201H375.87V91.8901C375.87 99.6701 379.83 106.2 386.62 106.2C391.77 106.2 395.72 103.63 397.11 98.3501H397.1ZM375.86 90.4401H385.69C386.15 80.4801 385.29 76.1301 381.8 76.1301C378.31 76.1301 376.06 79.4901 375.86 90.4401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.94 78.8901V77.7701C407.84 77.7701 416.02 72.3601 417.61 61.8101H418.8V77.1801H421.04C426.05 77.1801 427.83 74.4101 427.83 70.7201H428.69V85.3601H427.83C427.83 81.6701 426.05 78.9001 421.04 78.9001H418.8V95.7801C418.8 104.09 420.71 106.79 424.01 106.79C428.23 106.79 429.95 101.38 430.34 98.2201L431.4 98.4201C430.67 105.15 427.24 110.89 418.54 110.89C410.69 110.89 405.88 107.59 405.88 99.2201C405.88 95.1301 406.28 91.3701 406.28 85.4301C406.28 78.7701 405.69 78.9001 398.96 78.9001L398.94 78.8901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.31 108.57C440.04 108.37 439.51 108.17 439.51 93.8001C439.51 78.4301 440.57 78.2301 432.91 78.1001V77.1801L452.04 76.3901V93.8001C452.57 108.18 451.51 108.38 458.24 108.57V109.43H433.31V108.57ZM438.38 65.1101C438.38 61.2801 441.74 58.1801 445.64 58.1801C449.54 58.1801 452.9 61.2801 452.9 65.1101C452.9 68.9401 449.6 72.0401 445.64 72.0401C441.68 72.0401 438.38 68.9401 438.38 65.1101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.83 108.57C465.56 108.37 465.03 108.17 465.03 93.8C465.03 78.43 466.09 78.23 458.43 78.1V77.18L477.56 76.39V81.86C479.28 77.84 482.7 75.13 488.44 75.13C495.56 75.13 499.92 79.02 499.92 85.82C499.92 90.44 499.52 94.46 499.52 98.29C499.52 108.58 498.99 108.38 505.39 108.58V109.44H483.76V108.58C488.51 108.38 487.52 108.18 487.52 93.15C487.52 81.81 487.32 79.04 483.04 79.04C479.81 79.04 477.57 82.34 477.57 90.71V93.81C477.57 108.19 476.65 108.39 481.39 108.58V109.44H458.83V108.58V108.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.69 182.98V184.17H170.37V182.98C177.43 182.78 176.97 181.79 176.97 168.73V152.5C176.97 139.44 177.43 138.45 170.37 138.19V137.07H196.69V138.19C189.63 138.45 190.09 139.44 190.09 152.5V168.73C190.09 181.79 189.63 182.78 196.69 182.98ZM176.18 125.79C176.18 121.97 179.54 118.86 183.44 118.86C187.34 118.86 190.7 121.96 190.7 125.79C190.7 129.62 187.4 132.72 183.44 132.72C179.48 132.72 176.18 129.62 176.18 125.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.84 161.28H212.85C204.41 161.28 201.9 161.08 201.7 168.8H200.58V151.19H230.19V152.24L209.08 174.07H217.52C225.96 174.07 228.53 174.66 228.73 166.95H229.85V184.16H198.46V183.1L219.83 161.27L219.84 161.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.09 183.3C239.82 183.1 239.29 182.9 239.29 168.53C239.29 153.16 240.35 152.96 232.69 152.83V151.91L251.82 151.12V168.53C252.35 182.91 251.29 183.11 258.02 183.3V184.16H233.09V183.3ZM238.17 139.84C238.17 136.01 241.53 132.91 245.43 132.91C249.33 132.91 252.69 136.01 252.69 139.84C252.69 143.67 249.39 146.77 245.43 146.77C241.47 146.77 238.17 143.67 238.17 139.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.62 183.3C265.35 183.1 264.82 182.9 264.82 168.53C264.82 153.16 265.88 152.96 258.22 152.83V151.91L277.35 151.12V156.59C279.07 152.57 282.49 149.86 288.23 149.86C295.35 149.86 299.71 153.75 299.71 160.55C299.71 165.17 299.31 169.19 299.31 173.02C299.31 183.31 298.78 183.11 305.18 183.31V184.17H283.55V183.31C288.3 183.11 287.31 182.91 287.31 167.88C287.31 156.54 287.11 153.77 282.83 153.77C279.6 153.77 277.36 157.07 277.36 165.44V168.54C277.36 182.92 276.44 183.12 281.18 183.31V184.17H258.62V183.31V183.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.27 178.36C332.36 182.45 328.8 185.48 322.6 185.48C313.3 185.48 307.5 178.36 307.5 168.2C307.5 158.04 313.5 149.86 324.32 149.86C329.46 149.86 332.56 151.84 333.95 154.61V152.7C333.95 136.34 335.07 137.46 326.04 137.2V136.41L347.47 135.49C346.88 138.79 346.15 149.54 346.15 152.7V167.94C346.15 181.07 348.13 182.65 354.46 182.91V183.7L336.06 185.02C335.14 183.37 334.54 180.8 334.28 178.36H334.27ZM334.47 167.01C334.47 157.45 332.1 151.84 326.82 151.84C322.07 151.84 319.63 158.37 319.63 167.21C319.63 174.86 322 182.31 327.15 182.31C331.77 182.31 334.47 176.84 334.47 167.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.15 173.08L389.14 173.34C387.82 179.74 381.82 185.61 372.65 185.61C360.38 185.61 354.78 176.57 354.78 167.67C354.78 158.77 360.85 149.8 373.18 149.8C385.51 149.8 389.01 160.22 388.42 166.55H366.92V166.62C366.92 174.4 370.88 180.93 377.67 180.93C382.82 180.93 386.77 178.36 388.16 173.08H388.15ZM366.91 165.17H376.74C377.2 155.21 376.34 150.86 372.85 150.86C369.36 150.86 367.11 154.22 366.91 165.17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.69 182.98V184.17H170.37V182.98C177.43 182.78 176.97 181.79 176.97 168.73V152.5C176.97 139.44 177.43 138.45 170.37 138.19V137.07H196.69V138.19C189.63 138.45 190.09 139.44 190.09 152.5V168.73C190.09 181.79 189.63 182.78 196.69 182.98ZM176.18 125.79C176.18 121.97 179.54 118.86 183.44 118.86C187.34 118.86 190.7 121.96 190.7 125.79C190.7 129.62 187.4 132.72 183.44 132.72C179.48 132.72 176.18 129.62 176.18 125.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.84 161.28H212.85C204.41 161.28 201.9 161.08 201.7 168.8H200.58V151.19H230.19V152.24L209.08 174.07H217.52C225.96 174.07 228.53 174.66 228.73 166.95H229.85V184.16H198.46V183.1L219.83 161.27L219.84 161.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.09 183.3C239.82 183.1 239.29 182.9 239.29 168.53C239.29 153.16 240.35 152.96 232.69 152.83V151.91L251.82 151.12V168.53C252.35 182.91 251.29 183.11 258.02 183.3V184.16H233.09V183.3ZM238.17 139.84C238.17 136.01 241.53 132.91 245.43 132.91C249.33 132.91 252.69 136.01 252.69 139.84C252.69 143.67 249.39 146.77 245.43 146.77C241.47 146.77 238.17 143.67 238.17 139.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.62 183.3C265.35 183.1 264.82 182.9 264.82 168.53C264.82 153.16 265.88 152.96 258.22 152.83V151.91L277.35 151.12V156.59C279.07 152.57 282.49 149.86 288.23 149.86C295.35 149.86 299.71 153.75 299.71 160.55C299.71 165.17 299.31 169.19 299.31 173.02C299.31 183.31 298.78 183.11 305.18 183.31V184.17H283.55V183.31C288.3 183.11 287.31 182.91 287.31 167.88C287.31 156.54 287.11 153.77 282.83 153.77C279.6 153.77 277.36 157.07 277.36 165.44V168.54C277.36 182.92 276.44 183.12 281.18 183.31V184.17H258.62V183.31V183.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.27 178.36C332.36 182.45 328.8 185.48 322.6 185.48C313.3 185.48 307.5 178.36 307.5 168.2C307.5 158.04 313.5 149.86 324.32 149.86C329.46 149.86 332.56 151.84 333.95 154.61V152.7C333.95 136.34 335.07 137.46 326.04 137.2V136.41L347.47 135.49C346.88 138.79 346.15 149.54 346.15 152.7V167.94C346.15 181.07 348.13 182.65 354.46 182.91V183.7L336.06 185.02C335.14 183.37 334.54 180.8 334.28 178.36H334.27ZM334.47 167.01C334.47 157.45 332.1 151.84 326.82 151.84C322.07 151.84 319.63 158.37 319.63 167.21C319.63 174.86 322 182.31 327.15 182.31C331.77 182.31 334.47 176.84 334.47 167.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.15 173.08L389.14 173.34C387.82 179.74 381.82 185.61 372.65 185.61C360.38 185.61 354.78 176.57 354.78 167.67C354.78 158.77 360.85 149.8 373.18 149.8C385.51 149.8 389.01 160.22 388.42 166.55H366.92V166.62C366.92 174.4 370.88 180.93 377.67 180.93C382.82 180.93 386.77 178.36 388.16 173.08H388.15ZM366.91 165.17H376.74C377.2 155.21 376.34 150.86 372.85 150.86C369.36 150.86 367.11 154.22 366.91 165.17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.69 182.98V184.17H170.37V182.98C177.43 182.78 176.97 181.79 176.97 168.73V152.5C176.97 139.44 177.43 138.45 170.37 138.19V137.07H196.69V138.19C189.63 138.45 190.09 139.44 190.09 152.5V168.73C190.09 181.79 189.63 182.78 196.69 182.98ZM176.18 125.79C176.18 121.97 179.54 118.86 183.44 118.86C187.34 118.86 190.7 121.96 190.7 125.79C190.7 129.62 187.4 132.72 183.44 132.72C179.48 132.72 176.18 129.62 176.18 125.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.84 161.28H212.85C204.41 161.28 201.9 161.08 201.7 168.8H200.58V151.19H230.19V152.24L209.08 174.07H217.52C225.96 174.07 228.53 174.66 228.73 166.95H229.85V184.16H198.46V183.1L219.83 161.27L219.84 161.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.09 183.3C239.82 183.1 239.29 182.9 239.29 168.53C239.29 153.16 240.35 152.96 232.69 152.83V151.91L251.82 151.12V168.53C252.35 182.91 251.29 183.11 258.02 183.3V184.16H233.09V183.3ZM238.17 139.84C238.17 136.01 241.53 132.91 245.43 132.91C249.33 132.91 252.69 136.01 252.69 139.84C252.69 143.67 249.39 146.77 245.43 146.77C241.47 146.77 238.17 143.67 238.17 139.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.62 183.3C265.35 183.1 264.82 182.9 264.82 168.53C264.82 153.16 265.88 152.96 258.22 152.83V151.91L277.35 151.12V156.59C279.07 152.57 282.49 149.86 288.23 149.86C295.35 149.86 299.71 153.75 299.71 160.55C299.71 165.17 299.31 169.19 299.31 173.02C299.31 183.31 298.78 183.11 305.18 183.31V184.17H283.55V183.31C288.3 183.11 287.31 182.91 287.31 167.88C287.31 156.54 287.11 153.77 282.83 153.77C279.6 153.77 277.36 157.07 277.36 165.44V168.54C277.36 182.92 276.44 183.12 281.18 183.31V184.17H258.62V183.31V183.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.27 178.36C332.36 182.45 328.8 185.48 322.6 185.48C313.3 185.48 307.5 178.36 307.5 168.2C307.5 158.04 313.5 149.86 324.32 149.86C329.46 149.86 332.56 151.84 333.95 154.61V152.7C333.95 136.34 335.07 137.46 326.04 137.2V136.41L347.47 135.49C346.88 138.79 346.15 149.54 346.15 152.7V167.94C346.15 181.07 348.13 182.65 354.46 182.91V183.7L336.06 185.02C335.14 183.37 334.54 180.8 334.28 178.36H334.27ZM334.47 167.01C334.47 157.45 332.1 151.84 326.82 151.84C322.07 151.84 319.63 158.37 319.63 167.21C319.63 174.86 322 182.31 327.15 182.31C331.77 182.31 334.47 176.84 334.47 167.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.15 173.08L389.14 173.34C387.82 179.74 381.82 185.61 372.65 185.61C360.38 185.61 354.78 176.57 354.78 167.67C354.78 158.77 360.85 149.8 373.18 149.8C385.51 149.8 389.01 160.22 388.42 166.55H366.92V166.62C366.92 174.4 370.88 180.93 377.67 180.93C382.82 180.93 386.77 178.36 388.16 173.08H388.15ZM366.91 165.17H376.74C377.2 155.21 376.34 150.86 372.85 150.86C369.36 150.86 367.11 154.22 366.91 165.17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.86 231.64C285.11 231.56 282.44 231.6 279.75 231.58C274.47 231.54 269.21 231.18 263.95 230.59C258.07 229.93 252.24 229.01 246.47 227.7C239.84 226.2 233.28 224.46 227.19 221.51C225.19 220.54 223.23 219.49 221.85 217.82C220.64 216.37 220.72 215.15 222.07 213.91C223.03 213.03 224.54 212.28 226.32 211.88C225.26 212.5 224.38 212.97 223.56 213.51C221.43 214.92 221.42 216.59 223.55 218.21C225.45 219.66 227.68 220.64 229.95 221.53C236.47 224.08 243.29 225.62 250.2 226.86C262 228.98 273.85 229.98 285.76 229.42C292.16 229.12 298.45 228.31 304.34 226.13C305.82 225.58 307.26 224.97 308.49 224.04C305.92 225.05 303.3 225.91 300.52 226.44C297.75 226.96 294.95 227.25 292.08 227.31C293.69 226.91 295.31 226.54 296.91 226.12C300.9 225.09 304.53 223.49 307.73 221.24C309.42 220.05 310.57 218.55 311.14 216.69C311.44 215.72 311.18 214.97 310.29 214.3C307.93 212.52 305.11 211.57 302.23 210.77C293.18 208.26 283.89 207.27 274.56 206.43C269.17 205.94 263.78 205.56 258.38 205.28C252.59 204.98 246.8 204.76 241.01 204.6C233.21 204.39 225.41 204.22 217.62 204.16C205.91 204.07 194.2 204.09 182.5 204.08C176.63 204.08 170.76 204.12 164.89 204.13C156.5 204.13 148.1 204.42 139.71 204C135.62 203.8 131.53 203.67 127.44 203.61C117.31 203.46 107.18 203.31 97.05 202.51C92.52 202.15 87.98 201.7 83.62 200.28C81.69 199.65 79.92 198.8 78.66 197.3C76.75 195.03 77.2 192.71 78.18 190.41C79.63 186.98 82.43 184.48 85.71 182.37C92.39 178.09 100.1 175.57 108 173.38C110.22 172.76 112.49 172.24 114.74 171.68C115.03 171.61 115.34 171.57 115.69 171.68C113.4 172.28 111.11 172.86 108.84 173.49C102.8 175.16 96.9 177.11 91.4 179.79C87.43 181.72 83.75 183.97 80.99 187.17C79.86 188.48 78.97 189.92 78.45 191.52C77.3 195.06 78.74 197.72 82.73 199.29C85.91 200.54 89.29 201.01 92.68 201.37C104.77 202.64 116.85 202.63 128.93 202.66C135.41 202.68 141.9 202.66 148.37 202.58C158.31 202.45 168.24 202.26 178.17 202.06C183.95 201.94 189.73 201.77 195.51 201.62C195.93 201.61 196.36 201.56 196.77 201.38C171.55 200.6 146.4 201.34 121.2 200.86C149.4 200.76 177.54 200.07 205.69 199.11C204.23 199.04 202.76 198.93 201.3 198.91C191.83 198.75 182.36 198.69 172.9 198.71C166.66 198.72 160.42 198.6 154.18 198.65C144.07 198.73 133.95 198.65 123.84 198.55C116.41 198.47 108.97 198.18 101.54 197.84C101.14 197.82 100.73 197.75 100.32 197.63C106.79 197.5 113.24 197.34 119.68 196.92C115.78 196.52 111.88 196.23 108.01 195.54C110.75 195.59 113.5 195.64 116.24 195.68C125.38 195.81 134.51 195.78 143.65 195.69C149.51 195.63 155.37 195.61 161.24 195.55C167.8 195.49 174.36 195.38 180.92 195.34C190.54 195.28 200.17 195.26 209.79 195.24C219.78 195.21 229.79 195.36 239.79 195.64C247.23 195.85 254.66 196.16 262.1 196.61C273.56 197.31 284.99 198.27 296.3 200.43C302.43 201.6 308.48 203.07 313.91 206.09C316.6 207.58 318.85 209.43 320.13 212.02C322.01 215.79 321.06 219.28 319.1 222.61C316.67 226.73 312.58 229.27 307.8 231.08C301.38 233.51 294.5 234.33 287.48 234.68C283.98 234.85 280.47 234.73 276.96 234.7C276.48 234.7 275.99 234.61 275.51 234.43C277.99 234.43 280.48 234.48 282.96 234.43C290.36 234.25 297.66 233.58 304.59 231.43C309.84 229.8 314.5 227.44 317.54 223.24C319.14 221.02 320.1 218.58 320.04 215.89C319.95 212.17 317.54 209.53 314.15 207.45C310.28 205.07 305.88 203.8 301.41 202.71C292.05 200.43 282.51 199.47 272.94 198.73C271.48 198.62 270.02 198.48 268.54 198.54C270.45 198.72 272.35 198.89 274.26 199.08C284.47 200.1 294.66 201.24 304.56 204.07C307.94 205.03 311.22 206.24 314.13 208.15C319.72 211.82 320.52 216.09 317.91 221.18C315.7 225.49 311.57 228.06 306.74 229.87C299.93 232.41 292.61 233.2 285.18 233.46C278.9 233.68 272.62 233.35 266.32 232.8C258.12 232.08 250.05 230.7 242.08 228.75C235.95 227.25 229.92 225.45 224.46 222.41C222.17 221.13 219.99 219.7 219 217.36C218.73 216.73 218.51 216.08 218.9 215.32C219.18 218.24 221.44 219.85 223.92 221.26C227.61 223.35 231.66 224.71 235.79 225.89C247.99 229.38 260.47 231.13 273.12 231.83C277.65 232.08 282.18 232.08 286.69 231.82C287.09 231.8 287.48 231.74 287.88 231.71L287.86 231.64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.68 154.76C152.15 164.03 153.26 173.16 156.03 182.05C156.63 183.26 156.63 184.49 159.28 184.5H121.07C123.47 184.51 124.06 182.73 124.22 182.22C127.03 173.34 128.16 164.21 127.63 154.94C126.91 142.51 117.99 133.55 105.57 132.33C100.88 131.87 96.21 132.03 91.53 132.15C84.51 132.33 77.57 131.81 70.7 130.35C68 129.78 65.26 129.37 62.47 129.76C59.35 130.19 56.95 131.91 54.7 133.97C55.94 131.23 58.05 129.4 60.77 128.23C62.76 127.37 64.88 126.96 67.04 126.89C68.96 126.83 70.88 126.93 72.8 126.83C74.16 126.76 75.27 127.58 76.68 127.56C75.21 126.49 73.74 125.41 72.35 124.25C69.94 122.23 67.5 120.23 65.03 118.27C63.83 117.32 62.56 116.43 61.26 115.62C54.65 111.51 46.82 114.12 44.26 121.54C42.76 125.9 39.93 128.46 35.67 129.71C33.34 130.39 31.03 131.14 28.83 132.24C29.97 130.9 31.39 130 32.97 129.32C34.09 128.83 35.24 128.38 36.33 127.81C39 126.43 40.83 124.39 41.26 121.29C41.37 120.47 41.62 119.67 41.82 118.79C40.78 118.75 40.1 119.3 39.36 119.62C36.81 120.71 34.23 121.62 31.45 121.98C27.66 122.46 24.28 121.53 21.3 119.21C19.62 117.9 18.18 116.32 16.6 114.54C17.54 114.54 17.88 115.09 18.31 115.45C19.01 116.05 19.66 116.7 20.37 117.29C24.08 120.4 28.26 121.21 32.88 119.77C35.61 118.92 38.11 117.56 40.56 116.13C43.28 114.54 45.96 112.91 48.79 111.51C53.95 108.95 58.96 109.08 63.96 111.97C66.96 113.71 69.79 115.67 72.65 117.61C74.81 119.07 77.01 120.47 79.22 121.86C82.57 123.97 86.2 124.78 90.18 124.69C95.33 124.57 100.45 124.01 105.61 124.11C110.47 124.2 115.27 124.55 119.8 126.52C120.1 127.02 120.56 127.28 121.18 127.49C120.95 126.82 120.56 126.47 119.98 126.32C118.66 124.8 116.8 124.25 115.01 123.59C111.69 122.37 108.19 121.8 104.77 120.94C102.38 120.34 100.05 119.61 97.86 118.47C95.53 117.27 92.98 116.65 90.51 115.81C88.4 115.09 86.33 114.29 84.34 113.28C80.99 111.57 78.23 109.19 76.06 106.12C75.62 105.49 75.15 104.88 74.77 104.21C72.69 100.47 69.31 99.09 65.26 98.68C60.85 98.24 56.53 98.8801 52.19 99.41C47.55 99.98 42.91 100.71 38.2 100.17C35.02 99.8 32.3 98.6 30.18 96.14C29.01 94.78 27.76 93.49 26.65 92.07C28 92.65 29.05 93.66 30.01 94.69C33.11 98.05 36.97 98.87 41.33 98.52C46.71 98.09 51.9 96.63 57.2 95.79C58.1 95.65 59 95.5 59.96 95.35C59.92 95.08 59.96 94.8101 59.83 94.66C56.8 90.8101 55.8 86.28 55.36 81.56C55.03 77.96 55.22 74.3401 55.16 70.7301C55.12 68.8101 55.09 66.8801 54.87 64.9801C54.41 61.0301 52.75 57.64 49.85 54.8801C49.24 54.3 48.6 53.75 47.97 53.18C48.58 52.78 48.88 53.3301 49.22 53.5601C54.23 56.8301 56.52 61.69 57.19 67.45C57.69 71.72 58.05 76 58.6 80.27C58.98 83.25 59.81 86.12 61.25 88.8C62.6 91.33 64.62 92.94 67.42 93.54C68.98 93.87 70.55 94.1701 72.27 94.51C72.33 93.69 71.95 93.11 71.73 92.51C69.84 87.4901 70.24 82.64 73.22 78.21C75.11 75.39 75.26 72.53 74.52 69.42C73.88 66.72 72.84 64.16 71.84 61.59C70.86 59.0801 70 56.5401 69.43 53.91C68.95 51.71 68.82 49.5201 70.42 47.59C69.34 50.8601 70.49 53.82 71.74 56.71C72.99 59.6 74.45 62.39 75.79 65.24C76.87 67.54 77.75 69.9 78.06 72.45C78.35 74.88 78.07 77.19 76.83 79.35C74.53 83.36 74.63 87.35 76.83 91.4C78.19 93.89 79.45 96.4501 80.59 99.04C82.74 103.9 86.38 106.86 91.55 107.98C99.33 109.67 106.91 112.25 114.89 113.12C120.42 113.72 125.41 115.82 129.51 119.77C131.46 121.64 133.09 123.57 132.36 126.54C132.31 126.75 132.4 126.99 132.56 127.26C133.5 123.64 135.25 120.31 136.12 116.66C136.82 113.71 135.76 111.57 133.32 109.97C131.77 108.95 130.06 108.26 128.37 107.53C124.85 106 121.31 104.52 117.81 102.96C114.92 101.67 112.21 100.08 109.99 97.77C109.18 96.93 108.18 96.37 107.12 95.89C104.73 94.82 102.27 93.96 99.74 93.32C98.4 92.98 97.09 92.54 95.86 91.89C91.67 89.67 90.55 86.8 92.14 82.35C92.42 81.56 92.72 80.76 93.09 80C93.99 78.16 93.77 76.46 92.64 74.78C91.65 73.32 90.69 71.83 89.8 70.31C88.28 67.73 87.8 65.8 87.89 62.98C88.1 63.3801 88.3 63.6301 88.36 63.91C88.92 66.5601 90.44 68.66 92.2 70.63C93.22 71.78 94.29 72.8901 95.25 74.0801C96.73 75.9301 97.26 78 96.59 80.34C96.29 81.37 96.08 82.43 95.93 83.49C95.6 85.89 95.98 86.44 98.36 87.07C99.25 87.3 100.16 87.46 101.07 87.58C102.05 87.7001 103.04 87.74 104.1 87.81C104.43 87.06 104.14 86.41 104.01 85.76C102.71 79.25 102.22 72.71 103.07 66.07C103.82 60.23 103.15 54.6001 100.03 49.4001C98.15 46.2601 97.21 42.7701 96.88 39.14C96.71 37.28 95.94 35.79 94.64 34.48C93.05 32.88 91.15 31.73 89.23 30.59C87.52 29.57 85.78 28.59 84.12 27.49C83.06 26.79 82.08 25.94 81.77 24.57C83.51 26.24 85.64 27.18 87.82 28.0201C91.04 29.25 94.23 30.5301 97.16 32.6301C98.94 25.5001 102.37 19.4 106.87 13.84C106.52 14.57 106.18 15.3 105.82 16.02C103.61 20.42 101.77 24.96 100.78 29.81C99.6 35.61 100.62 40.9401 104.06 45.7901C105.7 48.1001 107.57 50.25 108.87 52.7701C109.65 52.68 109.95 52.09 110.37 51.7001C113.77 48.5801 117.76 46.4901 122.03 44.8801C125.4 43.6101 128.81 42.42 132.19 41.17C134.14 40.45 136.01 39.57 137.81 38.53C144.03 34.94 147.5 29.55 148.5 22.47C149.06 18.5 149.06 14.53 148.72 10.55C150.18 16.74 150.59 22.94 148.79 29.12C147.27 34.35 143.9 38.26 139.52 41.37C136.75 43.34 133.69 44.7701 130.63 46.2001C128.06 47.4001 125.48 48.59 122.92 49.8101C121.18 50.6401 119.57 51.6701 118 52.7901C113.17 56.23 110.63 60.96 110.3 66.82C109.94 73.18 110.99 79.37 113.09 85.37C114.35 88.98 116.71 91.5601 120.44 92.76C121.53 93.11 122.61 93.54 123.68 93.95C125.88 94.78 128.24 95.18 130.45 96.37C128.8 94.75 129.54 93.14 130.21 91.55C131.48 88.55 133.34 85.91 135.47 83.48C137.7 80.94 139.99 78.46 142.25 75.94C143.64 74.39 144.88 72.74 146 70.99C149.48 65.55 149.9 59.8101 147.8 53.7901C147.53 53.0201 147.04 52.3101 147.03 51.07C151.17 56.83 153.04 62.73 151.48 69.49C150.61 73.27 149.03 76.75 147.09 80.08C145.66 82.53 144.14 84.94 142.71 87.39C141.59 89.31 140.65 91.32 140.05 93.49C139.35 95.99 139.81 98.18 141.36 100.21C142.16 101.25 143.13 102.12 144.06 103.04C147.12 106.06 149.16 109.55 149.02 114.03C148.97 115.75 148.34 117.29 147.74 118.9C151.89 127.7 152.71 154.79 152.71 154.79L152.68 154.76ZM138.09 159.28C137.89 159.8 137.93 160.31 138.09 161.08V159.29C138.02 157.76 137.94 156.24 137.87 154.71C137.71 151.18 137.31 147.69 136.01 144.37C135.3 142.56 134.49 140.79 132.93 139.47C133.04 140.06 133.31 140.58 133.56 141.11C134.99 144.09 136.01 147.21 136.46 150.49C136.8 152.99 137.08 155.5 137.39 158C137.45 158.51 137.37 159.12 138.09 159.28ZM112.31 130.79C116.52 132.47 120.4 134.67 123.63 137.88C126.9 141.13 129.09 145.05 130.72 149.33C130.3 140.01 121.21 130.85 112.3 130.79H112.31ZM136.19 125.83C137.47 122.89 139.12 120.11 139.93 116.99C141.02 112.75 138.89 108.61 134.97 107.27C134.97 107.32 134.96 107.4 134.99 107.43C135.2 107.65 135.42 107.86 135.65 108.07C137.65 109.89 138.51 112.15 138.39 114.85C138.3 117.02 137.64 119.06 137.12 121.13C136.73 122.67 136.09 124.16 136.2 125.83H136.19ZM133.93 158.43C133.6 159.57 133.86 160.55 133.95 161.53C134.47 167.32 135.17 173.1 134.61 178.92C134.46 180.51 134.15 182.1 133.91 183.68C133.86 184.01 133.9 184.3 134.25 184.41C134.66 184.54 135.02 184.46 135.16 184.01C135.28 183.65 135.38 183.27 135.42 182.9C135.76 179.63 136.17 176.37 135.86 173.06C135.4 168.21 134.78 163.38 133.93 158.43ZM108.47 118.73C114.52 120.97 120.9 122.63 125.32 127.9C121.69 121.21 115.01 120.1 108.47 118.73ZM131.71 171.58C131.17 175.68 130.43 179.73 129.07 183.65C129.05 183.72 129.04 183.8 129.03 183.88C128.97 184.14 129.08 184.36 129.3 184.42C129.5 184.47 129.81 184.47 129.94 184.35C130.16 184.16 130.34 183.88 130.41 183.6C131.37 179.66 132.14 175.69 131.71 171.59V171.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77 26.8199C152.16 26.8199 151.87 26.3099 153.59 23.0599C156.48 17.5799 162.66 14.4299 168.77 15.3199C170.2 15.5299 170.27 15.65 169.77 17.12C167.81 22.82 162.02 26.8399 155.78 26.8299L155.77 26.8199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.42 26.54C143.46 27.87 143.24 29.15 142.93 30.42C142.68 31.48 142.21 31.54 141.28 31.14C135.17 28.51 131.41 20.45 133.33 14C133.69 12.78 133.95 12.61 135.12 13.23C140.48 16.05 143.18 20.54 143.41 26.54H143.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91002 135.1C9.03002 128.87 13.17 123.31 18.91 121.54C20.79 120.96 21.08 121.16 21.14 123.07C21.33 129.28 16.86 135.36 10.88 137.02C9.19002 137.49 9.06003 137.39 8.93003 135.7C8.91003 135.47 8.91002 135.24 8.90002 135.11L8.91002 135.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3899 87.62C23.3099 86.53 21.7699 84.88 20.6099 82.88C18.1899 78.7 17.9099 74.37 19.8199 69.91C20.1599 69.1 20.4599 68.61 21.4699 69.25C27.2099 72.9 29.2099 81.9 25.3999 87.62H25.3899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0199 37.7399C65.1499 33.2599 64.9099 23.5199 70.4799 18.6899C74.9999 21.7699 76.2699 32.3699 70.0199 37.7399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.23 22.96C109.17 22.83 108.1 22.74 107.05 22.55C106.35 22.42 106.08 22.07 106.37 21.25C108.39 15.56 116.23 11.67 122.06 13.46C123.07 13.77 122.95 14.24 122.66 14.98C120.8 19.62 115.65 22.91 110.23 22.97V22.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.01 62.3C47 62.45 50.81 64.64 53.38 68.93C54.3 70.47 54.18 70.69 52.53 71.1C46.9 72.52 40.69 69.85 37.95 64.84C37.09 63.27 37.16 63.15 38.81 62.66C39.86 62.35 40.93 62.33 42.02 62.3H42.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.38 114.7C12.65 114.8 13.88 114.79 15.06 115.2C16.35 115.65 16.46 115.8 15.8 116.95C13.92 120.27 11.08 122.31 7.36996 123.16C5.30996 123.63 3.24996 123.53 1.22996 123C-0.170035 122.63 -0.300035 122.35 0.439965 121.11C2.90996 116.95 6.62996 114.89 11.38 114.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1399 34.5601C54.1499 38.0101 54.4399 48.0001 49.5999 51.8001C44.8199 47.9501 44.3499 38.9501 49.1399 34.5601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.74 44.94C67.74 46.45 67.6 46.57 66.19 46.3C60.76 45.24 56.25 39.61 56.44 34.15C56.48 32.93 56.77 32.71 58.02 32.95C63.28 33.98 67.71 39.45 67.73 44.95L67.74 44.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 40.94C122.82 37.57 121.54 29.74 125.99 24.27C126.76 23.32 127.21 23.81 127.75 24.48C131.77 29.49 131.21 36.8 127 40.93V40.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.12 41.57C148.1 41.61 147.13 41.37 146.16 41.13C144.69 40.77 144.58 40.57 145.29 39.3C147.38 35.57 150.59 33.43 154.81 32.87C156.18 32.69 157.57 32.72 158.93 33.02C160.91 33.46 161.04 33.71 160.01 35.38C157.52 39.44 153.79 41.35 149.12 41.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.05 0C143.51 1.17 147.66 7.61 146.39 14.33C140.46 14.22 135.4 6.6 137.05 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.95 68.12C124.59 73.64 118.99 79.06 113.67 79.14C112.88 79.15 112.53 78.8999 112.61 78.0899C113.3 71.6199 118.26 67.24 123.96 66.68C125.33 66.55 124.89 67.53 124.95 68.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.69 1.36999C163.1 7.39999 159.4 13.96 153.78 15.65C153.06 15.87 152.33 16.18 152.11 14.91C151.04 9.00999 155.61 2.42999 161.7 1.35999L161.69 1.36999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.04 51.15C81.83 54.84 80.3 58.2 76.85 60.51C75.61 61.34 75.33 61.23 74.87 59.95C73.19 55.25 75.29 49.27 79.55 46.66C80.76 45.92 81.0299 46 81.4499 47.4C81.7799 48.5 82.03 49.62 82.03 51.14L82.04 51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.74 35.27C102.99 35.27 102.82 34.97 104.09 32.43C106.22 28.17 111.06 25.45 115.57 25.98C116.99 26.15 117.13 26.36 116.67 27.69C115.12 32.2 110.71 35.26 105.75 35.26L105.74 35.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.63 140.71C41.64 141.81 41.13 143.7 40.14 145.47C39.71 146.24 39.3 146.39 38.54 145.78C34.61 142.62 33.47 135.66 36.17 131.34C36.78 130.36 37.29 130.55 37.95 131.19C40.38 133.54 41.62 136.39 41.63 140.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.86 63.47C65.07 62.72 69.66 65.13 71.87 69.28C72.41 70.3 72.79 71.38 73.02 72.52C73.18 73.34 72.88 73.62 72.09 73.69C66.7 74.16 60.95 68.93 60.86 63.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.11 48.99C62.84 49.07 67.25 52.29 68.74 56.76C69.23 58.23 69.09 58.44 67.49 58.55C62.7 58.9 57.67 55.51 56.08 50.87C55.53 49.26 55.69 49.04 57.42 48.99C57.65 48.99 57.88 48.99 58.11 48.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.85 42.43C73.01 37.56 75.21 33.99 79.63 31.87C81.34 31.05 81.6 31.24 81.78 33.03C82.25 37.85 79.51 42.59 75.1 44.57C73.19 45.43 72.94 45.27 72.86 43.11C72.86 42.88 72.86 42.65 72.86 42.42L72.85 42.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.04 98.62C142.63 93.84 145.88 87.64 151.5 85.86C152.72 85.47 152.94 85.66 153.05 86.98C153.46 92.07 150.02 97.16 145.17 98.64C144.8 98.75 144.42 98.83 144.04 98.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.64 53.92C139.55 54.14 141.03 55.22 142.33 56.5C145.08 59.21 146.11 62.55 145.67 66.36C145.52 67.68 145.26 67.82 144.07 67.38C138.96 65.49 135.98 59.32 137.64 53.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9799 96.51C34.0999 94.68 32.4499 92.05 31.9099 88.75C31.5299 86.45 31.7999 84.19 32.8199 82.04C33.2399 81.15 33.6899 80.98 34.5599 81.6C38.9399 84.75 40.1899 91.87 36.9899 96.51H36.9799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.5 74.2C137.52 76.07 137.11 77.82 136.27 79.5C135.85 80.33 135.39 80.43 134.69 79.82C131.53 77.05 130.14 73.58 130.64 69.41C130.79 68.12 131.21 66.89 131.8 65.72C132.22 64.87 132.66 64.8 133.36 65.4C136.09 67.71 137.45 70.65 137.5 74.21V74.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.59 39.5901C164.04 34.2901 167.77 27.8001 172.87 26.5201C173.84 26.2801 174.12 26.7201 174.2 27.5301C174.41 29.8901 173.94 32.1201 172.78 34.1601C171.2 36.9401 168.87 38.7901 165.59 39.5801V39.5901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.18 110.61C9.50997 109.85 6.30997 106.45 5.58997 102.54C5.35997 101.33 5.28997 100.1 5.44997 98.87C5.67997 97.12 5.90997 96.97 7.43997 97.7C10.54 99.19 12.47 101.67 13.34 104.96C13.83 106.83 13.92 108.74 13.19 110.6L13.18 110.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6599 54.59C34.4999 51.15 41.8399 50.55 46.1399 54.87C46.6999 55.43 46.4199 55.79 45.9299 56.16C40.8399 59.91 33.9599 58.05 31.6599 54.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.05 56.19C126.01 61.27 119.03 63.99 114.2 61.47C115.51 56.38 122.55 53.65 128.05 56.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7 10C110.41 8.88002 110.92 7.91002 111.4 6.98002C113.37 3.20002 116.53 1.25002 120.78 1.08002C122.12 1.03002 122.31 1.32002 122.03 2.51002C120.91 7.35002 115.74 10.78 110.7 9.99002V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9199 77.04C47.7699 77.15 50.8899 79.01 52.9099 82.65C53.5599 83.82 53.3899 84.12 52.1899 84.39C47.8899 85.37 42.9899 83.11 40.9199 79.18C40.1499 77.71 40.3099 77.37 41.9899 77.14C42.5199 77.07 43.0599 77.08 43.9199 77.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9301 24.49C80.7401 19.86 82.1901 13.35 86.9001 10.77C89.8001 14.16 88.8701 21.53 83.9301 24.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.37 43.03C89.88 42.97 85.93 40.09 84.66 36.22C84.36 35.3 84.61 34.97 85.49 34.81C89.58 34.02 95.21 37.63 96.28 41.73C96.52 42.66 96.18 43.01 95.29 43.01C94.91 43.01 94.52 43.04 94.38 43.05L94.37 43.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.47 12.21C93.54 11.08 93.61 10.02 93.97 8.98997C94.26 8.15997 94.68 8.15997 95.36 8.49997C99.16 10.41 101.43 16.43 99.88 20.48C99.55 21.34 99.11 21.52 98.34 21.01C95.14 18.92 93.52 15.97 93.47 12.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5399 105.7C26.8899 108.42 28.6499 113.31 27.0099 117.75C26.4499 119.27 26.1599 119.37 24.9399 118.42C21.1499 115.49 20.0799 110.03 22.5399 105.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.34 45.25C109.65 41.32 111.37 38.25 115 36.43C116.35 35.75 116.53 35.86 116.78 37.31C117.49 41.38 115.2 45.76 111.41 47.6C109.96 48.3 109.73 48.19 109.47 46.64C109.39 46.19 109.39 45.73 109.35 45.24L109.34 45.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6499 102.01C97.4399 97.22 102.67 95.63 107.32 98.06C105.44 102.64 99.4499 104.57 94.6499 102.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8199 132.47C62.1299 135.95 60.9399 142.3 57.4699 145.21C56.7399 145.83 56.4099 145.26 56.0699 144.71C53.6999 140.8 54.9599 135.21 58.8199 132.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.24 78.64C127.5 82.67 126.39 87.9 122.83 90.39C121.78 91.12 121.55 91.04 121.06 89.77C119.5 85.71 121.19 81.07 125.24 78.63V78.64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.76 51.65C133.95 51.59 131.96 50.95 130.22 49.57C129.46 48.97 129.57 48.55 130.28 47.99C133.32 45.58 138.75 45.71 141.57 48.27C142.25 48.89 142.27 49.32 141.51 49.88C140.23 50.83 137.97 51.62 135.76 51.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.32 102.78C82.05 98.48 83.89 93.25 86.37 91C87.24 90.21 87.5 90.25 88.07 91.29C90 94.84 89.15 100.41 85.33 102.78H85.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.67 98.27C17.61 98.26 15.94 97.78 14.41 96.82C13.84 96.46 13.77 96.09 14.22 95.53C16.59 92.65 22.57 92.01 25.63 94.3C26.36 94.85 26.14 95.23 25.63 95.75C24.24 97.18 21.63 98.26 18.65 98.28L18.67 98.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91 45.39C158.5 49.4 157.07 54.79 152.81 57.12C150.19 53.2 151.66 47.65 155.91 45.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.35 61.7701C90.38 58.8201 91.59 56.4601 93.96 54.7101C94.96 53.9801 95.17 54.0701 95.59 55.1901C96.88 58.5801 95.34 63.2101 92.31 65.1501C91.56 65.6301 91.11 65.6401 90.78 64.7001C90.45 63.7401 90.33 62.7701 90.35 61.7601V61.7701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.11 80.3C83.95 83.95 82.33 86.6 79.12 88.25C78.49 88.57 78.03 88.69 77.73 87.82C76.61 84.58 79.5 79.02 82.84 78.09C83.48 77.91 83.88 78.05 83.95 78.77C84 79.3 84.06 79.83 84.12 80.3H84.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76001 86.12C13 83.85 18.19 85.43 20.34 88.58C20.73 89.16 20.95 89.63 20.06 90C17.09 91.24 11.41 90.48 9.76001 86.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4 129.97C53.14 133.66 48.02 134 45.27 132.61C44 131.97 43.95 131.62 45 130.62C47.16 128.54 51.85 127.1 55.41 129.97H55.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4099 128.16C28.4199 128.01 26.5999 127.47 25.0799 126.16C24.5699 125.72 24.5199 125.34 25.0799 124.86C27.5899 122.68 33.0799 122.92 35.3199 125.32C35.8599 125.89 35.6299 126.24 35.1299 126.61C33.7199 127.66 32.0899 128.02 30.4199 128.16H30.4099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.63 107.32C47.93 103.47 51.46 100.21 55.25 100.23C56.25 100.23 56.38 100.74 56.22 101.55C55.5 105.24 51.46 107.95 47.62 107.32H47.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.03 137.9C25.88 141.18 24.38 143.59 21.5 145.09C20.51 145.61 20.15 145.38 19.94 144.28C19.37 141.28 21.28 137.51 24.13 136.03C25.52 135.31 25.83 135.47 25.98 137.03C26.01 137.33 26.01 137.64 26.02 137.91L26.03 137.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6099 100.89C32.2599 104.38 27.0099 104.55 24.3599 102.9C23.3699 102.28 23.3399 102.02 24.1999 101.19C26.8699 98.61 31.3499 98.46 34.6099 100.9V100.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.46 88.1401C47.79 87.1201 51.49 90.9301 52.13 93.7001C52.42 94.9901 52.28 95.1901 50.97 95.1501C47.3 95.0401 44.39 92.3801 43.46 88.1401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2 109.06C35.97 109.08 35.73 108.77 36.05 107.53C36.85 104.42 40.46 101.7 43.6 101.81C44.53 101.84 44.8 102.18 44.57 103.1C43.77 106.31 40.47 109.01 37.2 109.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.28 4.81995C106 7.91995 106.33 11.9199 104.23 14.8899C103.44 16.0099 103.16 16.0199 102.37 14.9899C100.15 12.0799 100.5 7.67995 103.28 4.82995V4.81995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5399 84.14C62.6299 80.9 63.8899 78.58 66.3899 76.95C67.0899 76.49 67.4799 76.7 67.7499 77.47C68.8199 80.56 67.3299 84.77 64.4999 86.59C63.3999 87.29 63.0699 87.18 62.7799 85.92C62.6299 85.25 62.5899 84.56 62.5399 84.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4899 106.67C73.3499 109.98 69.6799 111.28 66.2899 110C64.8999 109.48 64.8199 109.21 65.7599 108.12C68.0899 105.42 72.0099 104.78 75.4799 106.67H75.4899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.59 107.63C108.63 107.54 106.99 107.82 106.63 106.75C106.22 105.51 107.68 104.71 108.67 104.02C110.62 102.65 112.82 102.5 115.07 103.02C116.39 103.33 116.5 103.82 115.62 104.94C114.3 106.62 112.12 107.62 109.59 107.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0998 63.3099C82.7998 63.0399 85.5898 64.6399 86.8498 67.6199C87.6098 69.3999 87.2798 69.8699 85.4298 69.6499C82.1298 69.2499 79.6798 66.8399 79.0898 63.3099H79.0998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3699 48.72C91.0199 51.61 90.7599 55.75 87.7699 58.4C85.1199 55.52 85.3799 51.4 88.3699 48.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.54 62.49C100.24 66.35 99.1 69.8 95.59 71.79C93.59 68.52 94.8 64.58 98.54 62.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.73 78.51C86.93 78.56 84.17 76.92 83.21 74.65C82.92 73.97 82.95 73.54 83.85 73.37C86.67 72.83 89.84 74.27 91.2699 76.81C92.0099 78.13 91.88 78.38 90.41 78.51C90.18 78.53 89.95 78.51 89.72 78.51H89.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.43 28.61C90.31 25.85 89.84 22.58 91.98 19.14C95.23 20.92 95.93 25.19 93.43 28.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7699 127.26C57.3299 127.13 55.3499 126.28 53.9399 124.33C53.2499 123.38 53.3999 123.01 54.4799 122.73C57.0699 122.05 60.0999 123.1 61.6799 125.21C62.5399 126.36 62.4299 126.69 61.0299 127.03C60.5899 127.14 60.1299 127.19 59.7699 127.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.61 106.02C59.65 106.03 59.46 105.74 59.75 104.72C60.49 102.14 62.8299 100.18 65.5899 99.87C66.8099 99.73 67.12 100.1 66.8 101.28C66.14 103.74 63.2 105.99 60.61 106.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.07 115.96C51.93 118.29 50.68 122.12 48.9 123.57C48.01 124.29 47.66 124.21 47.28 123.15C46.32 120.44 47.45 117.53 50.07 115.97V115.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7199 138.55C63.3399 136.08 63.8999 132.92 65.9799 131.35C66.7899 130.74 67.1099 130.84 67.4699 131.8C68.4099 134.28 67.2299 137.17 64.7199 138.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.68 154.76C152.15 164.03 153.26 173.16 156.03 182.05C156.63 183.26 156.63 184.49 159.28 184.5H121.07C123.47 184.51 124.06 182.73 124.22 182.22C127.03 173.34 128.16 164.21 127.63 154.94C126.91 142.51 117.99 133.55 105.57 132.33C100.88 131.87 96.21 132.03 91.53 132.15C84.51 132.33 77.57 131.81 70.7 130.35C68 129.78 65.26 129.37 62.47 129.76C59.35 130.19 56.95 131.91 54.7 133.97C55.94 131.23 58.05 129.4 60.77 128.23C62.76 127.37 64.88 126.96 67.04 126.89C68.96 126.83 70.88 126.93 72.8 126.83C74.16 126.76 75.27 127.58 76.68 127.56C75.21 126.49 73.74 125.41 72.35 124.25C69.94 122.23 67.5 120.23 65.03 118.27C63.83 117.32 62.56 116.43 61.26 115.62C54.65 111.51 46.82 114.12 44.26 121.54C42.76 125.9 39.93 128.46 35.67 129.71C33.34 130.39 31.03 131.14 28.83 132.24C29.97 130.9 31.39 130 32.97 129.32C34.09 128.83 35.24 128.38 36.33 127.81C39 126.43 40.83 124.39 41.26 121.29C41.37 120.47 41.62 119.67 41.82 118.79C40.78 118.75 40.1 119.3 39.36 119.62C36.81 120.71 34.23 121.62 31.45 121.98C27.66 122.46 24.28 121.53 21.3 119.21C19.62 117.9 18.18 116.32 16.6 114.54C17.54 114.54 17.88 115.09 18.31 115.45C19.01 116.05 19.66 116.7 20.37 117.29C24.08 120.4 28.26 121.21 32.88 119.77C35.61 118.92 38.11 117.56 40.56 116.13C43.28 114.54 45.96 112.91 48.79 111.51C53.95 108.95 58.96 109.08 63.96 111.97C66.96 113.71 69.79 115.67 72.65 117.61C74.81 119.07 77.01 120.47 79.22 121.86C82.57 123.97 86.2 124.78 90.18 124.69C95.33 124.57 100.45 124.01 105.61 124.11C110.47 124.2 115.27 124.55 119.8 126.52C120.1 127.02 120.56 127.28 121.18 127.49C120.95 126.82 120.56 126.47 119.98 126.32C118.66 124.8 116.8 124.25 115.01 123.59C111.69 122.37 108.19 121.8 104.77 120.94C102.38 120.34 100.05 119.61 97.86 118.47C95.53 117.27 92.98 116.65 90.51 115.81C88.4 115.09 86.33 114.29 84.34 113.28C80.99 111.57 78.23 109.19 76.06 106.12C75.62 105.49 75.15 104.88 74.77 104.21C72.69 100.47 69.31 99.09 65.26 98.68C60.85 98.24 56.53 98.8801 52.19 99.41C47.55 99.98 42.91 100.71 38.2 100.17C35.02 99.8 32.3 98.6 30.18 96.14C29.01 94.78 27.76 93.49 26.65 92.07C28 92.65 29.05 93.66 30.01 94.69C33.11 98.05 36.97 98.87 41.33 98.52C46.71 98.09 51.9 96.63 57.2 95.79C58.1 95.65 59 95.5 59.96 95.35C59.92 95.08 59.96 94.8101 59.83 94.66C56.8 90.8101 55.8 86.28 55.36 81.56C55.03 77.96 55.22 74.3401 55.16 70.7301C55.12 68.8101 55.09 66.8801 54.87 64.9801C54.41 61.0301 52.75 57.64 49.85 54.8801C49.24 54.3 48.6 53.75 47.97 53.18C48.58 52.78 48.88 53.3301 49.22 53.5601C54.23 56.8301 56.52 61.69 57.19 67.45C57.69 71.72 58.05 76 58.6 80.27C58.98 83.25 59.81 86.12 61.25 88.8C62.6 91.33 64.62 92.94 67.42 93.54C68.98 93.87 70.55 94.1701 72.27 94.51C72.33 93.69 71.95 93.11 71.73 92.51C69.84 87.4901 70.24 82.64 73.22 78.21C75.11 75.39 75.26 72.53 74.52 69.42C73.88 66.72 72.84 64.16 71.84 61.59C70.86 59.0801 70 56.5401 69.43 53.91C68.95 51.71 68.82 49.5201 70.42 47.59C69.34 50.8601 70.49 53.82 71.74 56.71C72.99 59.6 74.45 62.39 75.79 65.24C76.87 67.54 77.75 69.9 78.06 72.45C78.35 74.88 78.07 77.19 76.83 79.35C74.53 83.36 74.63 87.35 76.83 91.4C78.19 93.89 79.45 96.4501 80.59 99.04C82.74 103.9 86.38 106.86 91.55 107.98C99.33 109.67 106.91 112.25 114.89 113.12C120.42 113.72 125.41 115.82 129.51 119.77C131.46 121.64 133.09 123.57 132.36 126.54C132.31 126.75 132.4 126.99 132.56 127.26C133.5 123.64 135.25 120.31 136.12 116.66C136.82 113.71 135.76 111.57 133.32 109.97C131.77 108.95 130.06 108.26 128.37 107.53C124.85 106 121.31 104.52 117.81 102.96C114.92 101.67 112.21 100.08 109.99 97.77C109.18 96.93 108.18 96.37 107.12 95.89C104.73 94.82 102.27 93.96 99.74 93.32C98.4 92.98 97.09 92.54 95.86 91.89C91.67 89.67 90.55 86.8 92.14 82.35C92.42 81.56 92.72 80.76 93.09 80C93.99 78.16 93.77 76.46 92.64 74.78C91.65 73.32 90.69 71.83 89.8 70.31C88.28 67.73 87.8 65.8 87.89 62.98C88.1 63.3801 88.3 63.6301 88.36 63.91C88.92 66.5601 90.44 68.66 92.2 70.63C93.22 71.78 94.29 72.8901 95.25 74.0801C96.73 75.9301 97.26 78 96.59 80.34C96.29 81.37 96.08 82.43 95.93 83.49C95.6 85.89 95.98 86.44 98.36 87.07C99.25 87.3 100.16 87.46 101.07 87.58C102.05 87.7001 103.04 87.74 104.1 87.81C104.43 87.06 104.14 86.41 104.01 85.76C102.71 79.25 102.22 72.71 103.07 66.07C103.82 60.23 103.15 54.6001 100.03 49.4001C98.15 46.2601 97.21 42.7701 96.88 39.14C96.71 37.28 95.94 35.79 94.64 34.48C93.05 32.88 91.15 31.73 89.23 30.59C87.52 29.57 85.78 28.59 84.12 27.49C83.06 26.79 82.08 25.94 81.77 24.57C83.51 26.24 85.64 27.18 87.82 28.0201C91.04 29.25 94.23 30.5301 97.16 32.6301C98.94 25.5001 102.37 19.4 106.87 13.84C106.52 14.57 106.18 15.3 105.82 16.02C103.61 20.42 101.77 24.96 100.78 29.81C99.6 35.61 100.62 40.9401 104.06 45.7901C105.7 48.1001 107.57 50.25 108.87 52.7701C109.65 52.68 109.95 52.09 110.37 51.7001C113.77 48.5801 117.76 46.4901 122.03 44.8801C125.4 43.6101 128.81 42.42 132.19 41.17C134.14 40.45 136.01 39.57 137.81 38.53C144.03 34.94 147.5 29.55 148.5 22.47C149.06 18.5 149.06 14.53 148.72 10.55C150.18 16.74 150.59 22.94 148.79 29.12C147.27 34.35 143.9 38.26 139.52 41.37C136.75 43.34 133.69 44.7701 130.63 46.2001C128.06 47.4001 125.48 48.59 122.92 49.8101C121.18 50.6401 119.57 51.6701 118 52.7901C113.17 56.23 110.63 60.96 110.3 66.82C109.94 73.18 110.99 79.37 113.09 85.37C114.35 88.98 116.71 91.5601 120.44 92.76C121.53 93.11 122.61 93.54 123.68 93.95C125.88 94.78 128.24 95.18 130.45 96.37C128.8 94.75 129.54 93.14 130.21 91.55C131.48 88.55 133.34 85.91 135.47 83.48C137.7 80.94 139.99 78.46 142.25 75.94C143.64 74.39 144.88 72.74 146 70.99C149.48 65.55 149.9 59.8101 147.8 53.7901C147.53 53.0201 147.04 52.3101 147.03 51.07C151.17 56.83 153.04 62.73 151.48 69.49C150.61 73.27 149.03 76.75 147.09 80.08C145.66 82.53 144.14 84.94 142.71 87.39C141.59 89.31 140.65 91.32 140.05 93.49C139.35 95.99 139.81 98.18 141.36 100.21C142.16 101.25 143.13 102.12 144.06 103.04C147.12 106.06 149.16 109.55 149.02 114.03C148.97 115.75 148.34 117.29 147.74 118.9C151.89 127.7 152.71 154.79 152.71 154.79L152.68 154.76ZM138.09 159.28C137.89 159.8 137.93 160.31 138.09 161.08V159.29C138.02 157.76 137.94 156.24 137.87 154.71C137.71 151.18 137.31 147.69 136.01 144.37C135.3 142.56 134.49 140.79 132.93 139.47C133.04 140.06 133.31 140.58 133.56 141.11C134.99 144.09 136.01 147.21 136.46 150.49C136.8 152.99 137.08 155.5 137.39 158C137.45 158.51 137.37 159.12 138.09 159.28ZM112.31 130.79C116.52 132.47 120.4 134.67 123.63 137.88C126.9 141.13 129.09 145.05 130.72 149.33C130.3 140.01 121.21 130.85 112.3 130.79H112.31ZM136.19 125.83C137.47 122.89 139.12 120.11 139.93 116.99C141.02 112.75 138.89 108.61 134.97 107.27C134.97 107.32 134.96 107.4 134.99 107.43C135.2 107.65 135.42 107.86 135.65 108.07C137.65 109.89 138.51 112.15 138.39 114.85C138.3 117.02 137.64 119.06 137.12 121.13C136.73 122.67 136.09 124.16 136.2 125.83H136.19ZM133.93 158.43C133.6 159.57 133.86 160.55 133.95 161.53C134.47 167.32 135.17 173.1 134.61 178.92C134.46 180.51 134.15 182.1 133.91 183.68C133.86 184.01 133.9 184.3 134.25 184.41C134.66 184.54 135.02 184.46 135.16 184.01C135.28 183.65 135.38 183.27 135.42 182.9C135.76 179.63 136.17 176.37 135.86 173.06C135.4 168.21 134.78 163.38 133.93 158.43ZM108.47 118.73C114.52 120.97 120.9 122.63 125.32 127.9C121.69 121.21 115.01 120.1 108.47 118.73ZM131.71 171.58C131.17 175.68 130.43 179.73 129.07 183.65C129.05 183.72 129.04 183.8 129.03 183.88C128.97 184.14 129.08 184.36 129.3 184.42C129.5 184.47 129.81 184.47 129.94 184.35C130.16 184.16 130.34 183.88 130.41 183.6C131.37 179.66 132.14 175.69 131.71 171.59V171.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77 26.8199C152.16 26.8199 151.87 26.3099 153.59 23.0599C156.48 17.5799 162.66 14.4299 168.77 15.3199C170.2 15.5299 170.27 15.65 169.77 17.12C167.81 22.82 162.02 26.8399 155.78 26.8299L155.77 26.8199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.42 26.54C143.46 27.87 143.24 29.15 142.93 30.42C142.68 31.48 142.21 31.54 141.28 31.14C135.17 28.51 131.41 20.45 133.33 14C133.69 12.78 133.95 12.61 135.12 13.23C140.48 16.05 143.18 20.54 143.41 26.54H143.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91002 135.1C9.03002 128.87 13.17 123.31 18.91 121.54C20.79 120.96 21.08 121.16 21.14 123.07C21.33 129.28 16.86 135.36 10.88 137.02C9.19002 137.49 9.06003 137.39 8.93003 135.7C8.91003 135.47 8.91002 135.24 8.90002 135.11L8.91002 135.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3899 87.62C23.3099 86.53 21.7699 84.88 20.6099 82.88C18.1899 78.7 17.9099 74.37 19.8199 69.91C20.1599 69.1 20.4599 68.61 21.4699 69.25C27.2099 72.9 29.2099 81.9 25.3999 87.62H25.3899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0199 37.7399C65.1499 33.2599 64.9099 23.5199 70.4799 18.6899C74.9999 21.7699 76.2699 32.3699 70.0199 37.7399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.23 22.96C109.17 22.83 108.1 22.74 107.05 22.55C106.35 22.42 106.08 22.07 106.37 21.25C108.39 15.56 116.23 11.67 122.06 13.46C123.07 13.77 122.95 14.24 122.66 14.98C120.8 19.62 115.65 22.91 110.23 22.97V22.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.01 62.3C47 62.45 50.81 64.64 53.38 68.93C54.3 70.47 54.18 70.69 52.53 71.1C46.9 72.52 40.69 69.85 37.95 64.84C37.09 63.27 37.16 63.15 38.81 62.66C39.86 62.35 40.93 62.33 42.02 62.3H42.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.38 114.7C12.65 114.8 13.88 114.79 15.06 115.2C16.35 115.65 16.46 115.8 15.8 116.95C13.92 120.27 11.08 122.31 7.36996 123.16C5.30996 123.63 3.24996 123.53 1.22996 123C-0.170035 122.63 -0.300035 122.35 0.439965 121.11C2.90996 116.95 6.62996 114.89 11.38 114.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1399 34.5601C54.1499 38.0101 54.4399 48.0001 49.5999 51.8001C44.8199 47.9501 44.3499 38.9501 49.1399 34.5601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.74 44.94C67.74 46.45 67.6 46.57 66.19 46.3C60.76 45.24 56.25 39.61 56.44 34.15C56.48 32.93 56.77 32.71 58.02 32.95C63.28 33.98 67.71 39.45 67.73 44.95L67.74 44.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 40.94C122.82 37.57 121.54 29.74 125.99 24.27C126.76 23.32 127.21 23.81 127.75 24.48C131.77 29.49 131.21 36.8 127 40.93V40.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.12 41.57C148.1 41.61 147.13 41.37 146.16 41.13C144.69 40.77 144.58 40.57 145.29 39.3C147.38 35.57 150.59 33.43 154.81 32.87C156.18 32.69 157.57 32.72 158.93 33.02C160.91 33.46 161.04 33.71 160.01 35.38C157.52 39.44 153.79 41.35 149.12 41.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.05 0C143.51 1.17 147.66 7.61 146.39 14.33C140.46 14.22 135.4 6.6 137.05 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.95 68.12C124.59 73.64 118.99 79.06 113.67 79.14C112.88 79.15 112.53 78.8999 112.61 78.0899C113.3 71.6199 118.26 67.24 123.96 66.68C125.33 66.55 124.89 67.53 124.95 68.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.69 1.36999C163.1 7.39999 159.4 13.96 153.78 15.65C153.06 15.87 152.33 16.18 152.11 14.91C151.04 9.00999 155.61 2.42999 161.7 1.35999L161.69 1.36999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.04 51.15C81.83 54.84 80.3 58.2 76.85 60.51C75.61 61.34 75.33 61.23 74.87 59.95C73.19 55.25 75.29 49.27 79.55 46.66C80.76 45.92 81.0299 46 81.4499 47.4C81.7799 48.5 82.03 49.62 82.03 51.14L82.04 51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.74 35.27C102.99 35.27 102.82 34.97 104.09 32.43C106.22 28.17 111.06 25.45 115.57 25.98C116.99 26.15 117.13 26.36 116.67 27.69C115.12 32.2 110.71 35.26 105.75 35.26L105.74 35.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.63 140.71C41.64 141.81 41.13 143.7 40.14 145.47C39.71 146.24 39.3 146.39 38.54 145.78C34.61 142.62 33.47 135.66 36.17 131.34C36.78 130.36 37.29 130.55 37.95 131.19C40.38 133.54 41.62 136.39 41.63 140.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.86 63.47C65.07 62.72 69.66 65.13 71.87 69.28C72.41 70.3 72.79 71.38 73.02 72.52C73.18 73.34 72.88 73.62 72.09 73.69C66.7 74.16 60.95 68.93 60.86 63.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.11 48.99C62.84 49.07 67.25 52.29 68.74 56.76C69.23 58.23 69.09 58.44 67.49 58.55C62.7 58.9 57.67 55.51 56.08 50.87C55.53 49.26 55.69 49.04 57.42 48.99C57.65 48.99 57.88 48.99 58.11 48.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.85 42.43C73.01 37.56 75.21 33.99 79.63 31.87C81.34 31.05 81.6 31.24 81.78 33.03C82.25 37.85 79.51 42.59 75.1 44.57C73.19 45.43 72.94 45.27 72.86 43.11C72.86 42.88 72.86 42.65 72.86 42.42L72.85 42.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.04 98.62C142.63 93.84 145.88 87.64 151.5 85.86C152.72 85.47 152.94 85.66 153.05 86.98C153.46 92.07 150.02 97.16 145.17 98.64C144.8 98.75 144.42 98.83 144.04 98.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.64 53.92C139.55 54.14 141.03 55.22 142.33 56.5C145.08 59.21 146.11 62.55 145.67 66.36C145.52 67.68 145.26 67.82 144.07 67.38C138.96 65.49 135.98 59.32 137.64 53.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9799 96.51C34.0999 94.68 32.4499 92.05 31.9099 88.75C31.5299 86.45 31.7999 84.19 32.8199 82.04C33.2399 81.15 33.6899 80.98 34.5599 81.6C38.9399 84.75 40.1899 91.87 36.9899 96.51H36.9799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.5 74.2C137.52 76.07 137.11 77.82 136.27 79.5C135.85 80.33 135.39 80.43 134.69 79.82C131.53 77.05 130.14 73.58 130.64 69.41C130.79 68.12 131.21 66.89 131.8 65.72C132.22 64.87 132.66 64.8 133.36 65.4C136.09 67.71 137.45 70.65 137.5 74.21V74.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.59 39.5901C164.04 34.2901 167.77 27.8001 172.87 26.5201C173.84 26.2801 174.12 26.7201 174.2 27.5301C174.41 29.8901 173.94 32.1201 172.78 34.1601C171.2 36.9401 168.87 38.7901 165.59 39.5801V39.5901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.18 110.61C9.50997 109.85 6.30997 106.45 5.58997 102.54C5.35997 101.33 5.28997 100.1 5.44997 98.87C5.67997 97.12 5.90997 96.97 7.43997 97.7C10.54 99.19 12.47 101.67 13.34 104.96C13.83 106.83 13.92 108.74 13.19 110.6L13.18 110.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6599 54.59C34.4999 51.15 41.8399 50.55 46.1399 54.87C46.6999 55.43 46.4199 55.79 45.9299 56.16C40.8399 59.91 33.9599 58.05 31.6599 54.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.05 56.19C126.01 61.27 119.03 63.99 114.2 61.47C115.51 56.38 122.55 53.65 128.05 56.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7 10C110.41 8.88002 110.92 7.91002 111.4 6.98002C113.37 3.20002 116.53 1.25002 120.78 1.08002C122.12 1.03002 122.31 1.32002 122.03 2.51002C120.91 7.35002 115.74 10.78 110.7 9.99002V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9199 77.04C47.7699 77.15 50.8899 79.01 52.9099 82.65C53.5599 83.82 53.3899 84.12 52.1899 84.39C47.8899 85.37 42.9899 83.11 40.9199 79.18C40.1499 77.71 40.3099 77.37 41.9899 77.14C42.5199 77.07 43.0599 77.08 43.9199 77.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9301 24.49C80.7401 19.86 82.1901 13.35 86.9001 10.77C89.8001 14.16 88.8701 21.53 83.9301 24.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.37 43.03C89.88 42.97 85.93 40.09 84.66 36.22C84.36 35.3 84.61 34.97 85.49 34.81C89.58 34.02 95.21 37.63 96.28 41.73C96.52 42.66 96.18 43.01 95.29 43.01C94.91 43.01 94.52 43.04 94.38 43.05L94.37 43.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.47 12.21C93.54 11.08 93.61 10.02 93.97 8.98997C94.26 8.15997 94.68 8.15997 95.36 8.49997C99.16 10.41 101.43 16.43 99.88 20.48C99.55 21.34 99.11 21.52 98.34 21.01C95.14 18.92 93.52 15.97 93.47 12.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5399 105.7C26.8899 108.42 28.6499 113.31 27.0099 117.75C26.4499 119.27 26.1599 119.37 24.9399 118.42C21.1499 115.49 20.0799 110.03 22.5399 105.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.34 45.25C109.65 41.32 111.37 38.25 115 36.43C116.35 35.75 116.53 35.86 116.78 37.31C117.49 41.38 115.2 45.76 111.41 47.6C109.96 48.3 109.73 48.19 109.47 46.64C109.39 46.19 109.39 45.73 109.35 45.24L109.34 45.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6499 102.01C97.4399 97.22 102.67 95.63 107.32 98.06C105.44 102.64 99.4499 104.57 94.6499 102.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8199 132.47C62.1299 135.95 60.9399 142.3 57.4699 145.21C56.7399 145.83 56.4099 145.26 56.0699 144.71C53.6999 140.8 54.9599 135.21 58.8199 132.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.24 78.64C127.5 82.67 126.39 87.9 122.83 90.39C121.78 91.12 121.55 91.04 121.06 89.77C119.5 85.71 121.19 81.07 125.24 78.63V78.64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.76 51.65C133.95 51.59 131.96 50.95 130.22 49.57C129.46 48.97 129.57 48.55 130.28 47.99C133.32 45.58 138.75 45.71 141.57 48.27C142.25 48.89 142.27 49.32 141.51 49.88C140.23 50.83 137.97 51.62 135.76 51.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.32 102.78C82.05 98.48 83.89 93.25 86.37 91C87.24 90.21 87.5 90.25 88.07 91.29C90 94.84 89.15 100.41 85.33 102.78H85.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.67 98.27C17.61 98.26 15.94 97.78 14.41 96.82C13.84 96.46 13.77 96.09 14.22 95.53C16.59 92.65 22.57 92.01 25.63 94.3C26.36 94.85 26.14 95.23 25.63 95.75C24.24 97.18 21.63 98.26 18.65 98.28L18.67 98.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91 45.39C158.5 49.4 157.07 54.79 152.81 57.12C150.19 53.2 151.66 47.65 155.91 45.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.35 61.7701C90.38 58.8201 91.59 56.4601 93.96 54.7101C94.96 53.9801 95.17 54.0701 95.59 55.1901C96.88 58.5801 95.34 63.2101 92.31 65.1501C91.56 65.6301 91.11 65.6401 90.78 64.7001C90.45 63.7401 90.33 62.7701 90.35 61.7601V61.7701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.11 80.3C83.95 83.95 82.33 86.6 79.12 88.25C78.49 88.57 78.03 88.69 77.73 87.82C76.61 84.58 79.5 79.02 82.84 78.09C83.48 77.91 83.88 78.05 83.95 78.77C84 79.3 84.06 79.83 84.12 80.3H84.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76001 86.12C13 83.85 18.19 85.43 20.34 88.58C20.73 89.16 20.95 89.63 20.06 90C17.09 91.24 11.41 90.48 9.76001 86.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4 129.97C53.14 133.66 48.02 134 45.27 132.61C44 131.97 43.95 131.62 45 130.62C47.16 128.54 51.85 127.1 55.41 129.97H55.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4099 128.16C28.4199 128.01 26.5999 127.47 25.0799 126.16C24.5699 125.72 24.5199 125.34 25.0799 124.86C27.5899 122.68 33.0799 122.92 35.3199 125.32C35.8599 125.89 35.6299 126.24 35.1299 126.61C33.7199 127.66 32.0899 128.02 30.4199 128.16H30.4099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.63 107.32C47.93 103.47 51.46 100.21 55.25 100.23C56.25 100.23 56.38 100.74 56.22 101.55C55.5 105.24 51.46 107.95 47.62 107.32H47.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.03 137.9C25.88 141.18 24.38 143.59 21.5 145.09C20.51 145.61 20.15 145.38 19.94 144.28C19.37 141.28 21.28 137.51 24.13 136.03C25.52 135.31 25.83 135.47 25.98 137.03C26.01 137.33 26.01 137.64 26.02 137.91L26.03 137.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6099 100.89C32.2599 104.38 27.0099 104.55 24.3599 102.9C23.3699 102.28 23.3399 102.02 24.1999 101.19C26.8699 98.61 31.3499 98.46 34.6099 100.9V100.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.46 88.1401C47.79 87.1201 51.49 90.9301 52.13 93.7001C52.42 94.9901 52.28 95.1901 50.97 95.1501C47.3 95.0401 44.39 92.3801 43.46 88.1401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2 109.06C35.97 109.08 35.73 108.77 36.05 107.53C36.85 104.42 40.46 101.7 43.6 101.81C44.53 101.84 44.8 102.18 44.57 103.1C43.77 106.31 40.47 109.01 37.2 109.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.28 4.81995C106 7.91995 106.33 11.9199 104.23 14.8899C103.44 16.0099 103.16 16.0199 102.37 14.9899C100.15 12.0799 100.5 7.67995 103.28 4.82995V4.81995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5399 84.14C62.6299 80.9 63.8899 78.58 66.3899 76.95C67.0899 76.49 67.4799 76.7 67.7499 77.47C68.8199 80.56 67.3299 84.77 64.4999 86.59C63.3999 87.29 63.0699 87.18 62.7799 85.92C62.6299 85.25 62.5899 84.56 62.5399 84.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4899 106.67C73.3499 109.98 69.6799 111.28 66.2899 110C64.8999 109.48 64.8199 109.21 65.7599 108.12C68.0899 105.42 72.0099 104.78 75.4799 106.67H75.4899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.59 107.63C108.63 107.54 106.99 107.82 106.63 106.75C106.22 105.51 107.68 104.71 108.67 104.02C110.62 102.65 112.82 102.5 115.07 103.02C116.39 103.33 116.5 103.82 115.62 104.94C114.3 106.62 112.12 107.62 109.59 107.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0998 63.3099C82.7998 63.0399 85.5898 64.6399 86.8498 67.6199C87.6098 69.3999 87.2798 69.8699 85.4298 69.6499C82.1298 69.2499 79.6798 66.8399 79.0898 63.3099H79.0998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3699 48.72C91.0199 51.61 90.7599 55.75 87.7699 58.4C85.1199 55.52 85.3799 51.4 88.3699 48.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.54 62.49C100.24 66.35 99.1 69.8 95.59 71.79C93.59 68.52 94.8 64.58 98.54 62.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.73 78.51C86.93 78.56 84.17 76.92 83.21 74.65C82.92 73.97 82.95 73.54 83.85 73.37C86.67 72.83 89.84 74.27 91.2699 76.81C92.0099 78.13 91.88 78.38 90.41 78.51C90.18 78.53 89.95 78.51 89.72 78.51H89.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.43 28.61C90.31 25.85 89.84 22.58 91.98 19.14C95.23 20.92 95.93 25.19 93.43 28.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7699 127.26C57.3299 127.13 55.3499 126.28 53.9399 124.33C53.2499 123.38 53.3999 123.01 54.4799 122.73C57.0699 122.05 60.0999 123.1 61.6799 125.21C62.5399 126.36 62.4299 126.69 61.0299 127.03C60.5899 127.14 60.1299 127.19 59.7699 127.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.61 106.02C59.65 106.03 59.46 105.74 59.75 104.72C60.49 102.14 62.8299 100.18 65.5899 99.87C66.8099 99.73 67.12 100.1 66.8 101.28C66.14 103.74 63.2 105.99 60.61 106.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.07 115.96C51.93 118.29 50.68 122.12 48.9 123.57C48.01 124.29 47.66 124.21 47.28 123.15C46.32 120.44 47.45 117.53 50.07 115.97V115.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7199 138.55C63.3399 136.08 63.8999 132.92 65.9799 131.35C66.7899 130.74 67.1099 130.84 67.4699 131.8C68.4099 134.28 67.2299 137.17 64.7199 138.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.68 154.76C152.15 164.03 153.26 173.16 156.03 182.05C156.63 183.26 156.63 184.49 159.28 184.5H121.07C123.47 184.51 124.06 182.73 124.22 182.22C127.03 173.34 128.16 164.21 127.63 154.94C126.91 142.51 117.99 133.55 105.57 132.33C100.88 131.87 96.21 132.03 91.53 132.15C84.51 132.33 77.57 131.81 70.7 130.35C68 129.78 65.26 129.37 62.47 129.76C59.35 130.19 56.95 131.91 54.7 133.97C55.94 131.23 58.05 129.4 60.77 128.23C62.76 127.37 64.88 126.96 67.04 126.89C68.96 126.83 70.88 126.93 72.8 126.83C74.16 126.76 75.27 127.58 76.68 127.56C75.21 126.49 73.74 125.41 72.35 124.25C69.94 122.23 67.5 120.23 65.03 118.27C63.83 117.32 62.56 116.43 61.26 115.62C54.65 111.51 46.82 114.12 44.26 121.54C42.76 125.9 39.93 128.46 35.67 129.71C33.34 130.39 31.03 131.14 28.83 132.24C29.97 130.9 31.39 130 32.97 129.32C34.09 128.83 35.24 128.38 36.33 127.81C39 126.43 40.83 124.39 41.26 121.29C41.37 120.47 41.62 119.67 41.82 118.79C40.78 118.75 40.1 119.3 39.36 119.62C36.81 120.71 34.23 121.62 31.45 121.98C27.66 122.46 24.28 121.53 21.3 119.21C19.62 117.9 18.18 116.32 16.6 114.54C17.54 114.54 17.88 115.09 18.31 115.45C19.01 116.05 19.66 116.7 20.37 117.29C24.08 120.4 28.26 121.21 32.88 119.77C35.61 118.92 38.11 117.56 40.56 116.13C43.28 114.54 45.96 112.91 48.79 111.51C53.95 108.95 58.96 109.08 63.96 111.97C66.96 113.71 69.79 115.67 72.65 117.61C74.81 119.07 77.01 120.47 79.22 121.86C82.57 123.97 86.2 124.78 90.18 124.69C95.33 124.57 100.45 124.01 105.61 124.11C110.47 124.2 115.27 124.55 119.8 126.52C120.1 127.02 120.56 127.28 121.18 127.49C120.95 126.82 120.56 126.47 119.98 126.32C118.66 124.8 116.8 124.25 115.01 123.59C111.69 122.37 108.19 121.8 104.77 120.94C102.38 120.34 100.05 119.61 97.86 118.47C95.53 117.27 92.98 116.65 90.51 115.81C88.4 115.09 86.33 114.29 84.34 113.28C80.99 111.57 78.23 109.19 76.06 106.12C75.62 105.49 75.15 104.88 74.77 104.21C72.69 100.47 69.31 99.09 65.26 98.68C60.85 98.24 56.53 98.8801 52.19 99.41C47.55 99.98 42.91 100.71 38.2 100.17C35.02 99.8 32.3 98.6 30.18 96.14C29.01 94.78 27.76 93.49 26.65 92.07C28 92.65 29.05 93.66 30.01 94.69C33.11 98.05 36.97 98.87 41.33 98.52C46.71 98.09 51.9 96.63 57.2 95.79C58.1 95.65 59 95.5 59.96 95.35C59.92 95.08 59.96 94.8101 59.83 94.66C56.8 90.8101 55.8 86.28 55.36 81.56C55.03 77.96 55.22 74.3401 55.16 70.7301C55.12 68.8101 55.09 66.8801 54.87 64.9801C54.41 61.0301 52.75 57.64 49.85 54.8801C49.24 54.3 48.6 53.75 47.97 53.18C48.58 52.78 48.88 53.3301 49.22 53.5601C54.23 56.8301 56.52 61.69 57.19 67.45C57.69 71.72 58.05 76 58.6 80.27C58.98 83.25 59.81 86.12 61.25 88.8C62.6 91.33 64.62 92.94 67.42 93.54C68.98 93.87 70.55 94.1701 72.27 94.51C72.33 93.69 71.95 93.11 71.73 92.51C69.84 87.4901 70.24 82.64 73.22 78.21C75.11 75.39 75.26 72.53 74.52 69.42C73.88 66.72 72.84 64.16 71.84 61.59C70.86 59.0801 70 56.5401 69.43 53.91C68.95 51.71 68.82 49.5201 70.42 47.59C69.34 50.8601 70.49 53.82 71.74 56.71C72.99 59.6 74.45 62.39 75.79 65.24C76.87 67.54 77.75 69.9 78.06 72.45C78.35 74.88 78.07 77.19 76.83 79.35C74.53 83.36 74.63 87.35 76.83 91.4C78.19 93.89 79.45 96.4501 80.59 99.04C82.74 103.9 86.38 106.86 91.55 107.98C99.33 109.67 106.91 112.25 114.89 113.12C120.42 113.72 125.41 115.82 129.51 119.77C131.46 121.64 133.09 123.57 132.36 126.54C132.31 126.75 132.4 126.99 132.56 127.26C133.5 123.64 135.25 120.31 136.12 116.66C136.82 113.71 135.76 111.57 133.32 109.97C131.77 108.95 130.06 108.26 128.37 107.53C124.85 106 121.31 104.52 117.81 102.96C114.92 101.67 112.21 100.08 109.99 97.77C109.18 96.93 108.18 96.37 107.12 95.89C104.73 94.82 102.27 93.96 99.74 93.32C98.4 92.98 97.09 92.54 95.86 91.89C91.67 89.67 90.55 86.8 92.14 82.35C92.42 81.56 92.72 80.76 93.09 80C93.99 78.16 93.77 76.46 92.64 74.78C91.65 73.32 90.69 71.83 89.8 70.31C88.28 67.73 87.8 65.8 87.89 62.98C88.1 63.3801 88.3 63.6301 88.36 63.91C88.92 66.5601 90.44 68.66 92.2 70.63C93.22 71.78 94.29 72.8901 95.25 74.0801C96.73 75.9301 97.26 78 96.59 80.34C96.29 81.37 96.08 82.43 95.93 83.49C95.6 85.89 95.98 86.44 98.36 87.07C99.25 87.3 100.16 87.46 101.07 87.58C102.05 87.7001 103.04 87.74 104.1 87.81C104.43 87.06 104.14 86.41 104.01 85.76C102.71 79.25 102.22 72.71 103.07 66.07C103.82 60.23 103.15 54.6001 100.03 49.4001C98.15 46.2601 97.21 42.7701 96.88 39.14C96.71 37.28 95.94 35.79 94.64 34.48C93.05 32.88 91.15 31.73 89.23 30.59C87.52 29.57 85.78 28.59 84.12 27.49C83.06 26.79 82.08 25.94 81.77 24.57C83.51 26.24 85.64 27.18 87.82 28.0201C91.04 29.25 94.23 30.5301 97.16 32.6301C98.94 25.5001 102.37 19.4 106.87 13.84C106.52 14.57 106.18 15.3 105.82 16.02C103.61 20.42 101.77 24.96 100.78 29.81C99.6 35.61 100.62 40.9401 104.06 45.7901C105.7 48.1001 107.57 50.25 108.87 52.7701C109.65 52.68 109.95 52.09 110.37 51.7001C113.77 48.5801 117.76 46.4901 122.03 44.8801C125.4 43.6101 128.81 42.42 132.19 41.17C134.14 40.45 136.01 39.57 137.81 38.53C144.03 34.94 147.5 29.55 148.5 22.47C149.06 18.5 149.06 14.53 148.72 10.55C150.18 16.74 150.59 22.94 148.79 29.12C147.27 34.35 143.9 38.26 139.52 41.37C136.75 43.34 133.69 44.7701 130.63 46.2001C128.06 47.4001 125.48 48.59 122.92 49.8101C121.18 50.6401 119.57 51.6701 118 52.7901C113.17 56.23 110.63 60.96 110.3 66.82C109.94 73.18 110.99 79.37 113.09 85.37C114.35 88.98 116.71 91.5601 120.44 92.76C121.53 93.11 122.61 93.54 123.68 93.95C125.88 94.78 128.24 95.18 130.45 96.37C128.8 94.75 129.54 93.14 130.21 91.55C131.48 88.55 133.34 85.91 135.47 83.48C137.7 80.94 139.99 78.46 142.25 75.94C143.64 74.39 144.88 72.74 146 70.99C149.48 65.55 149.9 59.8101 147.8 53.7901C147.53 53.0201 147.04 52.3101 147.03 51.07C151.17 56.83 153.04 62.73 151.48 69.49C150.61 73.27 149.03 76.75 147.09 80.08C145.66 82.53 144.14 84.94 142.71 87.39C141.59 89.31 140.65 91.32 140.05 93.49C139.35 95.99 139.81 98.18 141.36 100.21C142.16 101.25 143.13 102.12 144.06 103.04C147.12 106.06 149.16 109.55 149.02 114.03C148.97 115.75 148.34 117.29 147.74 118.9C151.89 127.7 152.71 154.79 152.71 154.79L152.68 154.76ZM138.09 159.28C137.89 159.8 137.93 160.31 138.09 161.08V159.29C138.02 157.76 137.94 156.24 137.87 154.71C137.71 151.18 137.31 147.69 136.01 144.37C135.3 142.56 134.49 140.79 132.93 139.47C133.04 140.06 133.31 140.58 133.56 141.11C134.99 144.09 136.01 147.21 136.46 150.49C136.8 152.99 137.08 155.5 137.39 158C137.45 158.51 137.37 159.12 138.09 159.28ZM112.31 130.79C116.52 132.47 120.4 134.67 123.63 137.88C126.9 141.13 129.09 145.05 130.72 149.33C130.3 140.01 121.21 130.85 112.3 130.79H112.31ZM136.19 125.83C137.47 122.89 139.12 120.11 139.93 116.99C141.02 112.75 138.89 108.61 134.97 107.27C134.97 107.32 134.96 107.4 134.99 107.43C135.2 107.65 135.42 107.86 135.65 108.07C137.65 109.89 138.51 112.15 138.39 114.85C138.3 117.02 137.64 119.06 137.12 121.13C136.73 122.67 136.09 124.16 136.2 125.83H136.19ZM133.93 158.43C133.6 159.57 133.86 160.55 133.95 161.53C134.47 167.32 135.17 173.1 134.61 178.92C134.46 180.51 134.15 182.1 133.91 183.68C133.86 184.01 133.9 184.3 134.25 184.41C134.66 184.54 135.02 184.46 135.16 184.01C135.28 183.65 135.38 183.27 135.42 182.9C135.76 179.63 136.17 176.37 135.86 173.06C135.4 168.21 134.78 163.38 133.93 158.43ZM108.47 118.73C114.52 120.97 120.9 122.63 125.32 127.9C121.69 121.21 115.01 120.1 108.47 118.73ZM131.71 171.58C131.17 175.68 130.43 179.73 129.07 183.65C129.05 183.72 129.04 183.8 129.03 183.88C128.97 184.14 129.08 184.36 129.3 184.42C129.5 184.47 129.81 184.47 129.94 184.35C130.16 184.16 130.34 183.88 130.41 183.6C131.37 179.66 132.14 175.69 131.71 171.59V171.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77 26.8199C152.16 26.8199 151.87 26.3099 153.59 23.0599C156.48 17.5799 162.66 14.4299 168.77 15.3199C170.2 15.5299 170.27 15.65 169.77 17.12C167.81 22.82 162.02 26.8399 155.78 26.8299L155.77 26.8199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.42 26.54C143.46 27.87 143.24 29.15 142.93 30.42C142.68 31.48 142.21 31.54 141.28 31.14C135.17 28.51 131.41 20.45 133.33 14C133.69 12.78 133.95 12.61 135.12 13.23C140.48 16.05 143.18 20.54 143.41 26.54H143.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91002 135.1C9.03002 128.87 13.17 123.31 18.91 121.54C20.79 120.96 21.08 121.16 21.14 123.07C21.33 129.28 16.86 135.36 10.88 137.02C9.19002 137.49 9.06003 137.39 8.93003 135.7C8.91003 135.47 8.91002 135.24 8.90002 135.11L8.91002 135.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3899 87.62C23.3099 86.53 21.7699 84.88 20.6099 82.88C18.1899 78.7 17.9099 74.37 19.8199 69.91C20.1599 69.1 20.4599 68.61 21.4699 69.25C27.2099 72.9 29.2099 81.9 25.3999 87.62H25.3899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0199 37.7399C65.1499 33.2599 64.9099 23.5199 70.4799 18.6899C74.9999 21.7699 76.2699 32.3699 70.0199 37.7399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.23 22.96C109.17 22.83 108.1 22.74 107.05 22.55C106.35 22.42 106.08 22.07 106.37 21.25C108.39 15.56 116.23 11.67 122.06 13.46C123.07 13.77 122.95 14.24 122.66 14.98C120.8 19.62 115.65 22.91 110.23 22.97V22.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.01 62.3C47 62.45 50.81 64.64 53.38 68.93C54.3 70.47 54.18 70.69 52.53 71.1C46.9 72.52 40.69 69.85 37.95 64.84C37.09 63.27 37.16 63.15 38.81 62.66C39.86 62.35 40.93 62.33 42.02 62.3H42.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.38 114.7C12.65 114.8 13.88 114.79 15.06 115.2C16.35 115.65 16.46 115.8 15.8 116.95C13.92 120.27 11.08 122.31 7.36996 123.16C5.30996 123.63 3.24996 123.53 1.22996 123C-0.170035 122.63 -0.300035 122.35 0.439965 121.11C2.90996 116.95 6.62996 114.89 11.38 114.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1399 34.5601C54.1499 38.0101 54.4399 48.0001 49.5999 51.8001C44.8199 47.9501 44.3499 38.9501 49.1399 34.5601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.74 44.94C67.74 46.45 67.6 46.57 66.19 46.3C60.76 45.24 56.25 39.61 56.44 34.15C56.48 32.93 56.77 32.71 58.02 32.95C63.28 33.98 67.71 39.45 67.73 44.95L67.74 44.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 40.94C122.82 37.57 121.54 29.74 125.99 24.27C126.76 23.32 127.21 23.81 127.75 24.48C131.77 29.49 131.21 36.8 127 40.93V40.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.12 41.57C148.1 41.61 147.13 41.37 146.16 41.13C144.69 40.77 144.58 40.57 145.29 39.3C147.38 35.57 150.59 33.43 154.81 32.87C156.18 32.69 157.57 32.72 158.93 33.02C160.91 33.46 161.04 33.71 160.01 35.38C157.52 39.44 153.79 41.35 149.12 41.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.05 0C143.51 1.17 147.66 7.61 146.39 14.33C140.46 14.22 135.4 6.6 137.05 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.95 68.12C124.59 73.64 118.99 79.06 113.67 79.14C112.88 79.15 112.53 78.8999 112.61 78.0899C113.3 71.6199 118.26 67.24 123.96 66.68C125.33 66.55 124.89 67.53 124.95 68.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.69 1.36999C163.1 7.39999 159.4 13.96 153.78 15.65C153.06 15.87 152.33 16.18 152.11 14.91C151.04 9.00999 155.61 2.42999 161.7 1.35999L161.69 1.36999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.04 51.15C81.83 54.84 80.3 58.2 76.85 60.51C75.61 61.34 75.33 61.23 74.87 59.95C73.19 55.25 75.29 49.27 79.55 46.66C80.76 45.92 81.0299 46 81.4499 47.4C81.7799 48.5 82.03 49.62 82.03 51.14L82.04 51.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.74 35.27C102.99 35.27 102.82 34.97 104.09 32.43C106.22 28.17 111.06 25.45 115.57 25.98C116.99 26.15 117.13 26.36 116.67 27.69C115.12 32.2 110.71 35.26 105.75 35.26L105.74 35.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.63 140.71C41.64 141.81 41.13 143.7 40.14 145.47C39.71 146.24 39.3 146.39 38.54 145.78C34.61 142.62 33.47 135.66 36.17 131.34C36.78 130.36 37.29 130.55 37.95 131.19C40.38 133.54 41.62 136.39 41.63 140.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.86 63.47C65.07 62.72 69.66 65.13 71.87 69.28C72.41 70.3 72.79 71.38 73.02 72.52C73.18 73.34 72.88 73.62 72.09 73.69C66.7 74.16 60.95 68.93 60.86 63.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.11 48.99C62.84 49.07 67.25 52.29 68.74 56.76C69.23 58.23 69.09 58.44 67.49 58.55C62.7 58.9 57.67 55.51 56.08 50.87C55.53 49.26 55.69 49.04 57.42 48.99C57.65 48.99 57.88 48.99 58.11 48.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.85 42.43C73.01 37.56 75.21 33.99 79.63 31.87C81.34 31.05 81.6 31.24 81.78 33.03C82.25 37.85 79.51 42.59 75.1 44.57C73.19 45.43 72.94 45.27 72.86 43.11C72.86 42.88 72.86 42.65 72.86 42.42L72.85 42.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.04 98.62C142.63 93.84 145.88 87.64 151.5 85.86C152.72 85.47 152.94 85.66 153.05 86.98C153.46 92.07 150.02 97.16 145.17 98.64C144.8 98.75 144.42 98.83 144.04 98.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.64 53.92C139.55 54.14 141.03 55.22 142.33 56.5C145.08 59.21 146.11 62.55 145.67 66.36C145.52 67.68 145.26 67.82 144.07 67.38C138.96 65.49 135.98 59.32 137.64 53.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9799 96.51C34.0999 94.68 32.4499 92.05 31.9099 88.75C31.5299 86.45 31.7999 84.19 32.8199 82.04C33.2399 81.15 33.6899 80.98 34.5599 81.6C38.9399 84.75 40.1899 91.87 36.9899 96.51H36.9799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.5 74.2C137.52 76.07 137.11 77.82 136.27 79.5C135.85 80.33 135.39 80.43 134.69 79.82C131.53 77.05 130.14 73.58 130.64 69.41C130.79 68.12 131.21 66.89 131.8 65.72C132.22 64.87 132.66 64.8 133.36 65.4C136.09 67.71 137.45 70.65 137.5 74.21V74.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.59 39.5901C164.04 34.2901 167.77 27.8001 172.87 26.5201C173.84 26.2801 174.12 26.7201 174.2 27.5301C174.41 29.8901 173.94 32.1201 172.78 34.1601C171.2 36.9401 168.87 38.7901 165.59 39.5801V39.5901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.18 110.61C9.50997 109.85 6.30997 106.45 5.58997 102.54C5.35997 101.33 5.28997 100.1 5.44997 98.87C5.67997 97.12 5.90997 96.97 7.43997 97.7C10.54 99.19 12.47 101.67 13.34 104.96C13.83 106.83 13.92 108.74 13.19 110.6L13.18 110.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6599 54.59C34.4999 51.15 41.8399 50.55 46.1399 54.87C46.6999 55.43 46.4199 55.79 45.9299 56.16C40.8399 59.91 33.9599 58.05 31.6599 54.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.05 56.19C126.01 61.27 119.03 63.99 114.2 61.47C115.51 56.38 122.55 53.65 128.05 56.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7 10C110.41 8.88002 110.92 7.91002 111.4 6.98002C113.37 3.20002 116.53 1.25002 120.78 1.08002C122.12 1.03002 122.31 1.32002 122.03 2.51002C120.91 7.35002 115.74 10.78 110.7 9.99002V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9199 77.04C47.7699 77.15 50.8899 79.01 52.9099 82.65C53.5599 83.82 53.3899 84.12 52.1899 84.39C47.8899 85.37 42.9899 83.11 40.9199 79.18C40.1499 77.71 40.3099 77.37 41.9899 77.14C42.5199 77.07 43.0599 77.08 43.9199 77.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9301 24.49C80.7401 19.86 82.1901 13.35 86.9001 10.77C89.8001 14.16 88.8701 21.53 83.9301 24.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.37 43.03C89.88 42.97 85.93 40.09 84.66 36.22C84.36 35.3 84.61 34.97 85.49 34.81C89.58 34.02 95.21 37.63 96.28 41.73C96.52 42.66 96.18 43.01 95.29 43.01C94.91 43.01 94.52 43.04 94.38 43.05L94.37 43.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.47 12.21C93.54 11.08 93.61 10.02 93.97 8.98997C94.26 8.15997 94.68 8.15997 95.36 8.49997C99.16 10.41 101.43 16.43 99.88 20.48C99.55 21.34 99.11 21.52 98.34 21.01C95.14 18.92 93.52 15.97 93.47 12.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5399 105.7C26.8899 108.42 28.6499 113.31 27.0099 117.75C26.4499 119.27 26.1599 119.37 24.9399 118.42C21.1499 115.49 20.0799 110.03 22.5399 105.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.34 45.25C109.65 41.32 111.37 38.25 115 36.43C116.35 35.75 116.53 35.86 116.78 37.31C117.49 41.38 115.2 45.76 111.41 47.6C109.96 48.3 109.73 48.19 109.47 46.64C109.39 46.19 109.39 45.73 109.35 45.24L109.34 45.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6499 102.01C97.4399 97.22 102.67 95.63 107.32 98.06C105.44 102.64 99.4499 104.57 94.6499 102.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8199 132.47C62.1299 135.95 60.9399 142.3 57.4699 145.21C56.7399 145.83 56.4099 145.26 56.0699 144.71C53.6999 140.8 54.9599 135.21 58.8199 132.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.24 78.64C127.5 82.67 126.39 87.9 122.83 90.39C121.78 91.12 121.55 91.04 121.06 89.77C119.5 85.71 121.19 81.07 125.24 78.63V78.64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.76 51.65C133.95 51.59 131.96 50.95 130.22 49.57C129.46 48.97 129.57 48.55 130.28 47.99C133.32 45.58 138.75 45.71 141.57 48.27C142.25 48.89 142.27 49.32 141.51 49.88C140.23 50.83 137.97 51.62 135.76 51.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.32 102.78C82.05 98.48 83.89 93.25 86.37 91C87.24 90.21 87.5 90.25 88.07 91.29C90 94.84 89.15 100.41 85.33 102.78H85.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.67 98.27C17.61 98.26 15.94 97.78 14.41 96.82C13.84 96.46 13.77 96.09 14.22 95.53C16.59 92.65 22.57 92.01 25.63 94.3C26.36 94.85 26.14 95.23 25.63 95.75C24.24 97.18 21.63 98.26 18.65 98.28L18.67 98.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91 45.39C158.5 49.4 157.07 54.79 152.81 57.12C150.19 53.2 151.66 47.65 155.91 45.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.35 61.7701C90.38 58.8201 91.59 56.4601 93.96 54.7101C94.96 53.9801 95.17 54.0701 95.59 55.1901C96.88 58.5801 95.34 63.2101 92.31 65.1501C91.56 65.6301 91.11 65.6401 90.78 64.7001C90.45 63.7401 90.33 62.7701 90.35 61.7601V61.7701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.11 80.3C83.95 83.95 82.33 86.6 79.12 88.25C78.49 88.57 78.03 88.69 77.73 87.82C76.61 84.58 79.5 79.02 82.84 78.09C83.48 77.91 83.88 78.05 83.95 78.77C84 79.3 84.06 79.83 84.12 80.3H84.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76001 86.12C13 83.85 18.19 85.43 20.34 88.58C20.73 89.16 20.95 89.63 20.06 90C17.09 91.24 11.41 90.48 9.76001 86.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4 129.97C53.14 133.66 48.02 134 45.27 132.61C44 131.97 43.95 131.62 45 130.62C47.16 128.54 51.85 127.1 55.41 129.97H55.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4099 128.16C28.4199 128.01 26.5999 127.47 25.0799 126.16C24.5699 125.72 24.5199 125.34 25.0799 124.86C27.5899 122.68 33.0799 122.92 35.3199 125.32C35.8599 125.89 35.6299 126.24 35.1299 126.61C33.7199 127.66 32.0899 128.02 30.4199 128.16H30.4099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.63 107.32C47.93 103.47 51.46 100.21 55.25 100.23C56.25 100.23 56.38 100.74 56.22 101.55C55.5 105.24 51.46 107.95 47.62 107.32H47.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.03 137.9C25.88 141.18 24.38 143.59 21.5 145.09C20.51 145.61 20.15 145.38 19.94 144.28C19.37 141.28 21.28 137.51 24.13 136.03C25.52 135.31 25.83 135.47 25.98 137.03C26.01 137.33 26.01 137.64 26.02 137.91L26.03 137.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6099 100.89C32.2599 104.38 27.0099 104.55 24.3599 102.9C23.3699 102.28 23.3399 102.02 24.1999 101.19C26.8699 98.61 31.3499 98.46 34.6099 100.9V100.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.46 88.1401C47.79 87.1201 51.49 90.9301 52.13 93.7001C52.42 94.9901 52.28 95.1901 50.97 95.1501C47.3 95.0401 44.39 92.3801 43.46 88.1401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2 109.06C35.97 109.08 35.73 108.77 36.05 107.53C36.85 104.42 40.46 101.7 43.6 101.81C44.53 101.84 44.8 102.18 44.57 103.1C43.77 106.31 40.47 109.01 37.2 109.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.28 4.81995C106 7.91995 106.33 11.9199 104.23 14.8899C103.44 16.0099 103.16 16.0199 102.37 14.9899C100.15 12.0799 100.5 7.67995 103.28 4.82995V4.81995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5399 84.14C62.6299 80.9 63.8899 78.58 66.3899 76.95C67.0899 76.49 67.4799 76.7 67.7499 77.47C68.8199 80.56 67.3299 84.77 64.4999 86.59C63.3999 87.29 63.0699 87.18 62.7799 85.92C62.6299 85.25 62.5899 84.56 62.5399 84.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4899 106.67C73.3499 109.98 69.6799 111.28 66.2899 110C64.8999 109.48 64.8199 109.21 65.7599 108.12C68.0899 105.42 72.0099 104.78 75.4799 106.67H75.4899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.59 107.63C108.63 107.54 106.99 107.82 106.63 106.75C106.22 105.51 107.68 104.71 108.67 104.02C110.62 102.65 112.82 102.5 115.07 103.02C116.39 103.33 116.5 103.82 115.62 104.94C114.3 106.62 112.12 107.62 109.59 107.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0998 63.3099C82.7998 63.0399 85.5898 64.6399 86.8498 67.6199C87.6098 69.3999 87.2798 69.8699 85.4298 69.6499C82.1298 69.2499 79.6798 66.8399 79.0898 63.3099H79.0998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3699 48.72C91.0199 51.61 90.7599 55.75 87.7699 58.4C85.1199 55.52 85.3799 51.4 88.3699 48.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.54 62.49C100.24 66.35 99.1 69.8 95.59 71.79C93.59 68.52 94.8 64.58 98.54 62.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.73 78.51C86.93 78.56 84.17 76.92 83.21 74.65C82.92 73.97 82.95 73.54 83.85 73.37C86.67 72.83 89.84 74.27 91.2699 76.81C92.0099 78.13 91.88 78.38 90.41 78.51C90.18 78.53 89.95 78.51 89.72 78.51H89.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.43 28.61C90.31 25.85 89.84 22.58 91.98 19.14C95.23 20.92 95.93 25.19 93.43 28.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7699 127.26C57.3299 127.13 55.3499 126.28 53.9399 124.33C53.2499 123.38 53.3999 123.01 54.4799 122.73C57.0699 122.05 60.0999 123.1 61.6799 125.21C62.5399 126.36 62.4299 126.69 61.0299 127.03C60.5899 127.14 60.1299 127.19 59.7699 127.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.61 106.02C59.65 106.03 59.46 105.74 59.75 104.72C60.49 102.14 62.8299 100.18 65.5899 99.87C66.8099 99.73 67.12 100.1 66.8 101.28C66.14 103.74 63.2 105.99 60.61 106.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.07 115.96C51.93 118.29 50.68 122.12 48.9 123.57C48.01 124.29 47.66 124.21 47.28 123.15C46.32 120.44 47.45 117.53 50.07 115.97V115.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7199 138.55C63.3399 136.08 63.8999 132.92 65.9799 131.35C66.7899 130.74 67.1099 130.84 67.4699 131.8C68.4099 134.28 67.2299 137.17 64.7199 138.55Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_833",
    x1: 334.8,
    y1: 110.88,
    x2: 334.8,
    y2: 58.1801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_833",
    x1: 334.8,
    y1: 110.88,
    x2: 334.8,
    y2: 58.1801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_833",
    x1: 334.8,
    y1: 110.88,
    x2: 334.8,
    y2: 58.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9_833",
    x1: 334.8,
    y1: 110.88,
    x2: 334.8,
    y2: 58.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9_833",
    x1: 334.8,
    y1: 110.88,
    x2: 334.8,
    y2: 58.1801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9_833",
    x1: 334.8,
    y1: 110.88,
    x2: 334.8,
    y2: 58.1801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9_833",
    x1: 334.8,
    y1: 110.88,
    x2: 334.8,
    y2: 58.1801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9_833",
    x1: 334.8,
    y1: 110.88,
    x2: 334.8,
    y2: 58.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9_833",
    x1: 279.76,
    y1: 185.61,
    x2: 279.76,
    y2: 118.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9_833",
    x1: 279.76,
    y1: 185.61,
    x2: 279.76,
    y2: 118.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9_833",
    x1: 279.76,
    y1: 185.61,
    x2: 279.76,
    y2: 118.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9_833",
    x1: 279.76,
    y1: 185.61,
    x2: 279.76,
    y2: 118.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9_833",
    x1: 279.76,
    y1: 185.61,
    x2: 279.76,
    y2: 118.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9_833",
    x1: 279.76,
    y1: 185.61,
    x2: 279.76,
    y2: 118.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9_833",
    x1: 77.34,
    y1: 203.17,
    x2: 321.13,
    y2: 203.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9_833",
    x1: 16.58,
    y1: 97.5301,
    x2: 159.28,
    y2: 97.5301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_9_833",
    x1: 152.57,
    y1: 20.9899,
    x2: 170.04,
    y2: 20.9899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_9_833",
    x1: 132.84,
    y1: 22.13,
    x2: 143.43,
    y2: 22.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_9_833",
    x1: 8.91002,
    y1: 129.25,
    x2: 21.15,
    y2: 129.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_9_833",
    x1: 18.5599,
    y1: 78.29,
    x2: 27.3399,
    y2: 78.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_9_833",
    x1: 66.3399,
    y1: 28.2199,
    x2: 74.2999,
    y2: 28.2199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_9_833",
    x1: 106.25,
    y1: 17.99,
    x2: 122.86,
    y2: 17.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_9_833",
    x1: 37.4,
    y1: 66.89,
    x2: 53.96,
    y2: 66.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_9_833",
    x1: -0.0000353231,
    y1: 119.08,
    x2: 16.2,
    y2: 119.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_9_833",
    x1: 45.7699,
    y1: 43.1801,
    x2: 53.0699,
    y2: 43.1801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_9_833",
    x1: 56.44,
    y1: 39.64,
    x2: 67.75,
    y2: 39.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_9_833",
    x1: 123.2,
    y1: 32.35,
    x2: 130.48,
    y2: 32.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_9_833",
    x1: 144.86,
    y1: 37.16,
    x2: 160.64,
    y2: 37.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_9_833",
    x1: 136.73,
    y1: 7.17,
    x2: 146.62,
    y2: 7.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_9_833",
    x1: 112.61,
    y1: 72.91,
    x2: 124.98,
    y2: 72.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_9_833",
    x1: 151.95,
    y1: 8.60999,
    x2: 161.99,
    y2: 8.60999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_9_833",
    x1: 74.28,
    y1: 53.62,
    x2: 82.04,
    y2: 53.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_9_833",
    x1: 103.32,
    y1: 30.59,
    x2: 116.89,
    y2: 30.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_9_833",
    x1: 34.71,
    y1: 138.41,
    x2: 41.63,
    y2: 138.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_9_833",
    x1: 60.86,
    y1: 68.52,
    x2: 73.05,
    y2: 68.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_9_833",
    x1: 55.79,
    y1: 53.78,
    x2: 68.98,
    y2: 53.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_9_833",
    x1: 72.85,
    y1: 38.23,
    x2: 81.83,
    y2: 38.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_9_833",
    x1: 143.71,
    y1: 92.22,
    x2: 153.07,
    y2: 92.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_9_833",
    x1: 137.17,
    y1: 60.76,
    x2: 145.76,
    y2: 60.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_9_833",
    x1: 31.7399,
    y1: 88.87,
    x2: 38.7799,
    y2: 88.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_9_833",
    x1: 130.54,
    y1: 72.6,
    x2: 137.5,
    y2: 72.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_9_833",
    x1: 165.23,
    y1: 33.0301,
    x2: 174.25,
    y2: 33.0301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_9_833",
    x1: 5.36997,
    y1: 103.95,
    x2: 13.72,
    y2: 103.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_9_833",
    x1: 31.6599,
    y1: 55.02,
    x2: 46.4499,
    y2: 55.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_9_833",
    x1: 114.19,
    y1: 58.83,
    x2: 128.05,
    y2: 58.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_9_833",
    x1: 110.62,
    y1: 5.59002,
    x2: 122.14,
    y2: 5.59002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_9_833",
    x1: 40.4799,
    y1: 80.83,
    x2: 53.2899,
    y2: 80.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_9_833",
    x1: 82.2201,
    y1: 17.62,
    x2: 88.5401,
    y2: 17.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_9_833",
    x1: 84.54,
    y1: 38.86,
    x2: 96.35,
    y2: 38.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_9_833",
    x1: 93.47,
    y1: 14.79,
    x2: 100.37,
    y2: 14.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_9_833",
    x1: 21.2199,
    y1: 112.37,
    x2: 27.6199,
    y2: 112.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_9_833",
    x1: 109.34,
    y1: 42.03,
    x2: 116.91,
    y2: 42.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_9_833",
    x1: 94.6499,
    y1: 100.04,
    x2: 107.33,
    y2: 100.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_9_833",
    x1: 54.8799,
    y1: 138.98,
    x2: 60.7799,
    y2: 138.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_9_833",
    x1: 120.48,
    y1: 84.75,
    x2: 126.42,
    y2: 84.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_9_833",
    x1: 129.7,
    y1: 48.95,
    x2: 142.08,
    y2: 48.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_9_833",
    x1: 83.56,
    y1: 96.62,
    x2: 89.06,
    y2: 96.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_9_833",
    x1: 13.93,
    y1: 95.59,
    x2: 26.12,
    y2: 95.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_9_833",
    x1: 151.5,
    y1: 51.26,
    x2: 157.2,
    y2: 51.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_9_833",
    x1: 90.35,
    y1: 59.8601,
    x2: 96.05,
    y2: 59.8601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_9_833",
    x1: 77.48,
    y1: 83.25,
    x2: 84.11,
    y2: 83.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_9_833",
    x1: 9.76001,
    y1: 87.79,
    x2: 20.68,
    y2: 87.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_9_833",
    x1: 44.26,
    y1: 130.87,
    x2: 55.4,
    y2: 130.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_9_833",
    x1: 24.6799,
    y1: 125.76,
    x2: 35.6299,
    y2: 125.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_9_833",
    x1: 47.63,
    y1: 103.82,
    x2: 56.28,
    y2: 103.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_9_833",
    x1: 19.84,
    y1: 140.48,
    x2: 26.03,
    y2: 140.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_9_833",
    x1: 23.5799,
    y1: 101.53,
    x2: 34.6099,
    y2: 101.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_9_833",
    x1: 43.46,
    y1: 91.5701,
    x2: 52.25,
    y2: 91.5701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_9_833",
    x1: 35.92,
    y1: 105.43,
    x2: 44.64,
    y2: 105.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_9_833",
    x1: 100.92,
    y1: 10.2799,
    x2: 105.59,
    y2: 10.2799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_9_833",
    x1: 62.5399,
    y1: 81.87,
    x2: 68.0999,
    y2: 81.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_9_833",
    x1: 65.1399,
    y1: 108.04,
    x2: 75.4899,
    y2: 108.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_9_833",
    x1: 106.57,
    y1: 105.19,
    x2: 116.19,
    y2: 105.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_9_833",
    x1: 79.0998,
    y1: 66.4899,
    x2: 87.2298,
    y2: 66.4899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_9_833",
    x1: 85.9399,
    y1: 53.57,
    x2: 90.1999,
    y2: 53.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_9_833",
    x1: 94.63,
    y1: 67.14,
    x2: 99.32,
    y2: 67.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_9_833",
    x1: 83.05,
    y1: 75.89,
    x2: 91.72,
    y2: 75.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_9_833",
    x1: 90.67,
    y1: 23.88,
    x2: 94.93,
    y2: 23.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_9_833",
    x1: 53.5199,
    y1: 124.89,
    x2: 62.2299,
    y2: 124.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_9_833",
    x1: 59.63,
    y1: 102.93,
    x2: 66.92,
    y2: 102.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_9_833",
    x1: 46.94,
    y1: 120,
    x2: 50.99,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_9_833",
    x1: 63.9599,
    y1: 134.76,
    x2: 67.7899,
    y2: 134.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_9_833",
    x1: -0.430022,
    y1: 120.01,
    x2: 185.18,
    y2: 83.9301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_9_833",
    x1: -0.430089,
    y1: 120.01,
    x2: 185.18,
    y2: 83.9299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_9_833",
    x1: -0.430104,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_9_833",
    x1: -0.429975,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_9_833",
    x1: -0.430065,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_9_833",
    x1: -0.430087,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_9_833",
    x1: -0.43011,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_9_833",
    x1: -0.430028,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_9_833",
    x1: -0.430036,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_9_833",
    x1: -0.430089,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_9_833",
    x1: -0.430002,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_9_833",
    x1: -0.429965,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_9_833",
    x1: -0.429886,
    y1: 120.01,
    x2: 185.18,
    y2: 83.9301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_9_833",
    x1: -0.429934,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_9_833",
    x1: -0.429942,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_9_833",
    x1: -0.429959,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_9_833",
    x1: -0.430029,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_9_833",
    x1: -0.430159,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_9_833",
    x1: -0.430016,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_9_833",
    x1: -0.429994,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_9_833",
    x1: -0.430016,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_9_833",
    x1: -0.430028,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_9_833",
    x1: -0.430098,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_9_833",
    x1: -0.430091,
    y1: 120.01,
    x2: 185.18,
    y2: 83.9301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_9_833",
    x1: -0.430083,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_9_833",
    x1: -0.430001,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_9_833",
    x1: -0.430148,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_9_833",
    x1: -0.430034,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_9_833",
    x1: -0.430087,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_9_833",
    x1: -0.430107,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_9_833",
    x1: -0.430121,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_9_833",
    x1: -0.430087,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_9_833",
    x1: -0.429946,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_9_833",
    x1: -0.43,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_9_833",
    x1: -0.429974,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_9_833",
    x1: -0.430093,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_9_833",
    x1: -0.430182,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_9_833",
    x1: -0.430081,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_9_833",
    x1: -0.430062,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_9_833",
    x1: -0.430131,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_9_833",
    x1: -0.430145,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_9_833",
    x1: -0.43004,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_9_833",
    x1: -0.430021,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_9_833",
    x1: -0.43019,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_9_833",
    x1: -0.429945,
    y1: 120.01,
    x2: 185.18,
    y2: 83.9301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_9_833",
    x1: -0.430042,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_9_833",
    x1: -0.429991,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_9_833",
    x1: -0.429991,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_9_833",
    x1: -0.430065,
    y1: 120.01,
    x2: 185.18,
    y2: 83.9301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_9_833",
    x1: -0.430012,
    y1: 120.01,
    x2: 185.18,
    y2: 83.9299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_9_833",
    x1: -0.430039,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_9_833",
    x1: -0.430069,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_9_833",
    x1: -0.430049,
    y1: 120.01,
    x2: 185.18,
    y2: 83.9301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_9_833",
    x1: -0.430016,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_9_833",
    x1: -0.430104,
    y1: 120.01,
    x2: 185.18,
    y2: 83.9299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_9_833",
    x1: -0.430073,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_9_833",
    x1: -0.430067,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_9_833",
    x1: -0.430097,
    y1: 120.01,
    x2: 185.18,
    y2: 83.9299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_9_833",
    x1: -0.430178,
    y1: 120.01,
    x2: 185.18,
    y2: 83.9299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_9_833",
    x1: -0.4301,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_9_833",
    x1: -0.430029,
    y1: 120.01,
    x2: 185.18,
    y2: 83.9299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_9_833",
    x1: -0.430054,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_9_833",
    x1: -0.429994,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_9_833",
    x1: -0.430078,
    y1: 120.01,
    x2: 185.18,
    y2: 83.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_9_833",
    x1: -0.430068,
    y1: 120.01,
    x2: 185.18,
    y2: 83.9299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_9_833",
    x1: -0.429995,
    y1: 120.01,
    x2: 185.18,
    y2: 83.9299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_9_833",
    x1: -0.430048,
    y1: 120.01,
    x2: 185.18,
    y2: 83.9301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#634E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8579"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 505.39,
    height: 234.75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ae9d1b84e666914657ba8769352b16ae.svg";
export { ForwardRef as ReactComponent };